import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getContractData, getSinglePackage, createContract, requestHigherDiscount } from "../../../ReduxStore/Slice/Contract/contractSlice";
import { upload_contract_attachment } from "../../../Service/Contract/contractService";
import Select from "react-select";
import { useSelector } from "react-redux";
import { Trash2, Info } from 'lucide-react';
import debounce from 'lodash.debounce';
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import { agentDetails } from "../../../ReduxStore/Slice/Auth/AuthSlice";
import JoditEditor from 'jodit-react';
import * as Config from "../../../Utils/Config";
import axios from "axios";
import { components } from "react-select";
import JSZip from "jszip";
import ReusableModal from "../../../ExtraComponents/ReusableModal";


import { roundNumber, formatOrdinalDate, getPaymentTermFrequency, getPriceChange } from "../../../Utils/CommonFun";





const StepTwo = ({ formData1, handleChange, nextStep, prevStep, currentStep }) => {

  // console.log("StepTwo rendered",formData1);
  // console.log("StepTwo rendered",formData1.contractid);
  const location = useLocation();
  const navigate = useNavigate()
  const dispatch = useDispatch();
  let QuoteId = sessionStorage.getItem("contract_id");
  const userDetails = JSON.parse(localStorage.getItem("details"));


  if (location?.state != undefined && location?.state != null && location?.state?.record_id == undefined) {
    sessionStorage.setItem("contract_id", location?.state?.row?.id);
    QuoteId = location?.state?.row?.id;
  }

  let backupQuoteId = QuoteId;

  if (formData1 != undefined && formData1?.contractid != undefined) {
    backupQuoteId = formData1?.contractid;
  }

  if (location.state != null && location?.state?.row?.id != undefined) {
    backupQuoteId = location?.state?.row?.id;
  }


  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const [isLoading, setIsLoading] = useState(false);

  const [showDiscountModal, setShowDiscountModal] = useState(false);

  ///////////////-------- Request Higher Discount  START-------///////////////
  const [ongoingServicesHigherDiscount, setOngoingServicesHigherDiscount] = useState([]);
  const [oneoffServicesHigherDiscount, setOneoffServicesHigherDiscount] = useState([]);
  const [packagesServiceHigherDiscount, setPackagesServiceHigherDiscount] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showServiceHigherDiscount, setShowServiceHigherDiscount] = useState("ongoing");
  const [requestHigherDiscountStatus, setRequestHigherDiscountStatus] = useState(false);


  const [contractPackageServicesAll, setContractPackageServicesAll] = useState([]);
  const [errorDiscountValue, setErrorDiscountValue] = useState(false);
  const [clientid, setClientid] = useState("");
  const [packageName, setPackageName] = useState("");
  const [package_id, setPackage_id] = useState("");
  const [emailAuthorised, setEmailAuthorised] = useState("");
  const [currentPackageDiscount, setCurrentPackageDiscount] = useState("");
  const [currentCost, setCurrentCost] = useState("");
  const [desiredHigherDiscount, setDesiredHigherDiscount] = useState(0);
  const [desiredPriceApproval, setDesiredPriceApproval] = useState(0);
  const [agentListDataAuthorised, setAgentListDataAuthorised] = useState([]);
  const [agentListDataAuthorisedAll, setAgentListDataAuthorisedAll] = useState([]);
  const [reasonHigherDiscount, setReasonHigherDiscount] = useState("");

  const isServicediscount = useRef(false);

  const tdStyle = {
    padding: "8px",
    borderBottom: "1px solid #eee",
  };

  const inputStyle = {
    width: "90px",
    borderRadius: "20px",
    border: "1px solid #ccc",
    padding: "4px 8px",
    textAlign: "center",
  };

  const getMaxApprovalDiscountValue = (data) => {
    if (!data?.length) return 0;
    let maxValue = 0;
    for (let i = 0; i < data?.length; i++) {
      const value = Number(data[i]?.approval_discount) - Number(data[i]?.discount_rate) || 0;
      if (value > maxValue) {
        maxValue = value;
      }
    }
    return maxValue;
  };

  const getAuthorisedUsersByDiscount = (data, highestDiscount) => {
    if (!data?.length) return [];
    const result = [];
    for (let i = 0; i < data.length; i++) {
      const min = Number(data[i]?.min_discount) || 0;
      const max = Number(data[i]?.max_discount) || 0;
      if (highestDiscount >= min && highestDiscount <= max) {
        result.push(data[i]);
      }
    }
    return result;
  };

  const applyApprovalPrice = async (e, item, index, type) => {

    // console.log("applyApprovalPrice e", e.target.value)
    // console.log("item e", item)
    // return

    if (type == "ongoing") {
      let value = e.target.value;

      if (value === '.') {
        value = "0.";
      }
      const isValid = /^\d*\.?\d*$/.test(value);
      if (isValid == false) {
        return
      }

      if (parseFloat(value) > item.price) {
        setApprovalErrors(prevErrors => ({
          ...prevErrors,
          [index]: 'Approval price cannot be greater than original price.'
        }));
        return;
      }

      if (item.price_afterdiscount < parseFloat(value)) {
        setApprovalErrors(prevErrors => ({
          ...prevErrors,
          [index]: 'Approval price cannot be greater than discounted price.'
        }));
        return;
      }
      setApprovalErrors(prevErrors => ({
        ...prevErrors,
        [index]: ''
      }));

      const originalPrice = item.price;
      const approvalPrice = parseFloat(value || 0);
      // const discount = ((originalPrice - approvalPrice) / originalPrice) * 100;
      const safeOriginalPrice = Number(originalPrice) || 0;

      const discount = safeOriginalPrice > 0
        ? ((safeOriginalPrice - approvalPrice) / safeOriginalPrice) * 100
        : 0;

      const updatedServices = [...ongoingServicesHigherDiscount];


      updatedServices[index] = {
        ...updatedServices[index],
        approval_price: approvalPrice,
        approval_discount: discount,
      };

      // set discount athorised user filter
      const highestDiscount = getMaxApprovalDiscountValue(updatedServices);


      // Filter Authorised User
      const authoriseUser = getAuthorisedUsersByDiscount(agentListDataAuthorisedAll, highestDiscount);
      if (!["", null, undefined].includes(emailAuthorised)) {
        let isExistUser = authoriseUser?.find((val) => val.user_email === emailAuthorised);
        if (!isExistUser) {
          setEmailAuthorised("");
        }
      }

      setAgentListDataAuthorised(authoriseUser || []);
      ///////



      setOngoingServicesHigherDiscount(updatedServices);
      // setContractPackageServicesAll(updatedServices);

    }

    else if (type == "oneoff") {
      let value = e.target.value;

      if (value === '.') {
        value = "0.";
      }
      const isValid = /^\d*\.?\d*$/.test(value);
      if (isValid == false) {
        return
      }

      if (parseFloat(value) > item.price) {
        setApprovalErrors(prevErrors => ({
          ...prevErrors,
          [index]: 'Approval price cannot be greater than original price.'
        }));
        return;
      }

      if (item.price_afterdiscount < parseFloat(value)) {
        setApprovalErrors(prevErrors => ({
          ...prevErrors,
          [index]: 'Approval price cannot be greater than discounted price.'
        }));
        return;
      }
      setApprovalErrors(prevErrors => ({
        ...prevErrors,
        [index]: ''
      }));

      const originalPrice = item.price;
      const approvalPrice = parseFloat(value || 0);
      const discount = ((originalPrice - approvalPrice) / originalPrice) * 100;
      const updatedServices = [...oneoffServicesHigherDiscount];
      updatedServices[index] = {
        ...updatedServices[index],
        approval_price: value,
        approval_discount: discount,
      };

      // set discount athorised user filter
      const highestDiscount = getMaxApprovalDiscountValue(updatedServices);
      const authoriseUser = getAuthorisedUsersByDiscount(agentListDataAuthorisedAll, highestDiscount);

      // const [emailAuthorised, setEmailAuthorised] = useState("");
      if (!["", null, undefined].includes(emailAuthorised)) {
        let isExistUser = authoriseUser?.find((val) => val.user_email === emailAuthorised);
        if (!isExistUser) {
          setEmailAuthorised("");
        }
      }

      setAgentListDataAuthorised(authoriseUser || []);
      setOneoffServicesHigherDiscount(updatedServices);
      // setContractPackageServicesAll(updatedServices);

    } else {
      return
    }



  }

  const currentCostFun = async (discount, ContractPackageServices) => {
    let total_price = 0;
    if (discount == "") {
      return total_price
    }
    await ContractPackageServices.forEach(async (service) => {
      if (Number(service.service_type) == 1) {

        let price_afterdiscount = service.price - (service.price * discount) / 100;
        total_price += price_afterdiscount;
      }
    });
    return total_price;
  }

  const setDesiredHigherDiscountFun = async (e) => {
    let value = e.target.value;
    const isValid = /^\d*\.?\d*$/.test(value);
    if (isValid == false) {
      value = ""
      setDesiredHigherDiscount(value);
      let currentCost = await currentCostFun(value, quoteData && quoteData?.ContractPackageServices)
      setDesiredPriceApproval(currentCost)
      return
    }

    else if (value > 100) {
      value = 100;
    }

    if (parseFloat(value) <= parseFloat(currentPackageDiscount)) {
      setErrorDiscount(true)
    } else {
      setErrorDiscount(false)
    }

    setDesiredHigherDiscount(value);
    let currentCost = await currentCostFun(value, quoteData && quoteData?.ContractPackageServices)
    setDesiredPriceApproval(currentCost)
  }

  const desiredPriceApprovalFun = async (e) => {
    let value = e.target.value;

    if (value === '.') {
      value = "0.";
    }
    const isValid = /^\d*\.?\d*$/.test(value);
    if (isValid == false) {
      return
    }

    if (parseFloat(value) > parseFloat(totalCostWithDiscount)) {
      setDesiredHigherDiscount(0);
      setErrorDiscountValue(true);
    } else if (value === "") {
      setErrorDiscountValue(true);
    }
    else {

      let total_price = 0;
      await packagesServiceHigherDiscount?.forEach(async (service) => {
        if (Number(service.service_type) == 1) {
          let price_afterdiscount = service.price;
          total_price += price_afterdiscount;
        }
      });

      const discountPercent = ((total_price - value) / total_price) * 100;
      setDesiredHigherDiscount(discountPercent.toFixed(2));
      setErrorDiscountValue(false);

      // Filter Authorised User
      const highestDiscount = discountPercent - discount;
      const authoriseUser = getAuthorisedUsersByDiscount(agentListDataAuthorisedAll, highestDiscount);
      if (!["", null, undefined].includes(emailAuthorised)) {
        let isExistUser = authoriseUser?.find((val) => val.user_email === emailAuthorised);
        if (!isExistUser) {
          setEmailAuthorised("");
        }
      }
      setAgentListDataAuthorised(authoriseUser || []);
      /////


    }
    setDesiredPriceApproval(value);

  }

  const [approvalErrors, setApprovalErrors] = useState({});
  const [rateQtyChange, setRateQtyChange] = useState(false);


  ///////////////-------- Request Higher Discount  END -------///////////////


  let paymentMethodsArray = [];
  const agent_payment_settings = JSON.parse(localStorage.getItem("agent_payment_settings"));
  if (agent_payment_settings != null && agent_payment_settings != undefined && typeof agent_payment_settings == 'object') {
    paymentMethodsArray = Object.values(agent_payment_settings);
  }



  const [serviceTypeForQuote, setServiceTypeForQuote] = useState("");
  const [isSelfAssessmentChargeBasis, setIsSelfAssessmentChargeBasis] = useState(false);
  const [selfAssessmentCount, setSelfAssessmentCount] = useState(1);
  const individuals = Array.from({ length: selfAssessmentCount }, (_, i) => `Individual ${i + 1}`);
  const [quoteEnterDefaultValue, setQuoteEnterDefaultValue] = useState([]);
  // console.log("quoteEnterDefaultValue", quoteEnterDefaultValue)
  const [quoteIndividualSetValue, setQuoteIndividualSetValue] = useState([]);



  const [showDiscount, setShowDiscount] = useState("1");
  const [showPrice, setShowPrice] = useState("0");
  const [showAttachment, setShowAttachment] = useState("1");



  // Package
  const [packageID, setPackageID] = useState(null);
  const [packagesServiceData, setPackagesServiceData] = useState([]);
  const [packagesChangesModel, setPackagesChangesModel] = useState(false);
  const [packagesChanges, setPackagesChanges] = useState(false);


  const [packagehandleChangeChargeBasis, setPackagehandleChangeChargeBasis] = useState({});
  const [packageDeleteService, setPackageDeleteService] = useState({});
  const [packageChangeEnterDefaultValue, setPackageChangeEnterDefaultValue] = useState({});
  const [packageChangeAddedService, setPackageChangeAddedService] = useState({});

  const [content, setContent] = useState('');
  const [editorReady, setEditorReady] = useState(false);

  const [formData, setFormData] = useState({
    packageDescription: "",
    paymentTermDescription: "",
    attachments: [],
  });

  // console.log("formData --- ", formData);

  const editor = useRef(null);
  const UpdateFormBody = useCallback((value) => {
    setFormData((prev) => {
      let updatedBody = prev.body.trim();

      const imgTag = `<img src="${value}" width="252" height="160" style="display: inline-block; margin-left: 5px; vertical-align: middle;"/>`;

      if (updatedBody.endsWith("<br>") || updatedBody.endsWith("</p>")) {
        updatedBody = updatedBody.replace(/(<br>|<\/p>)+$/, "");
      }

      updatedBody += ` ${imgTag}`;

      return { ...prev, body: updatedBody };
    });
  }, []);
  const cleanWordHtml = (html = "") => {
    if (!html) return html;

    html = html.replace(/<style[\s\S]*?<\/style>/gi, "");
    html = html.replace(/<!--[\s\S]*?-->/g, "");
    html = html.replace(/mso-[a-z\-]+\s*:[^;"]+(;|")/gi, "");
    html = html.replace(/<o:p>\s*<\/o:p>|<o:p>.*?<\/o:p>/gi, "");

    return html;
  };

  const config1 = useMemo(() => ({
    readonly: false,
    placeholder: "",
    buttons:
      "bold,italic,underline,strikethrough,ul,ol,paragraph,indent,outdent,fontsize,font,brush,link,image,video,table,align,undo,redo,cut,copy,paste,selectall,source",
    removeButtons: ["speechRecognize"],
    toolbarSticky: false,

    style: {
      font: '14px "Times New Roman", Arial, sans-serif',
      color: "#000000",
      lineHeight: "1.4",
    },

    controls: {
      font: {
        list: {
          Poppins: '"Poppins", sans-serif',
          Arial: "Arial, Helvetica, sans-serif",
          "Times New Roman": '"Times New Roman", Times, serif',
          Roboto: "Roboto, sans-serif",
          Verdana: "Verdana, Geneva, sans-serif",
        },
      },
    },

    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: "insert_clear_html",
    defaultActionOnPasteFromWord: "insert_clear_html",

    processPasteHTML: (html) => {
      return cleanWordHtml(html);
    },

    processPasteFromWord: (html) => {
      return cleanWordHtml(html);
    },

    uploader: {
      url: Config.base_url + "img/uploader",
      accept: "image/*,video/*",
      method: "POST",
      withCredentials: false,
      prepareData: async (formData1) => {
        const data = new FormData();
        formData1.forEach((file) => {
          data.append("files[0]", file);
        });
        try {
          const response = await axios.post(Config.base_url + "img/uploader", data, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (response.data.success && Array.isArray(response.data.files) && response.data.files.length > 0) {
            UpdateFormBody(response.data.files[0]);
            return {
              success: true,
              files: response.data.files,
              messages: response.data.messages || ["Image uploaded successfully"],
            };
          } else {
            return {
              success: false,
              files: [],
              messages: ["Image upload failed"],
            };
          }
        } catch (error) {
          console.error("Image upload error:", error);
          return {
            success: false,
            files: [],
            messages: ["Image upload failed"],
          };
        }
      },
      defaultHandlerSuccess: (response) => {
        if (response?.files?.length > 0) {
          return response.files;
        } else {
          console.error("No files in response:", response);
          return [];
        }
      },
      defaultHandlerError: (error) => {
        console.error("Image upload error:", error);
        return [];
      },
    },
    events: {
      afterInit: (editorInstance) => {
        setEditorReady(true);
        editor.current = editorInstance;
      },
    },
  }), [UpdateFormBody]);



  const [packageDescription, setPackageDescription] = useState(null);
  const [paymentTermDescription, setPaymentTermDescription] = useState(null);
  const textareaRef = useRef(null);
  const textareaRef_payment = useRef(null);

  // console.log("packagesServiceData", packagesServiceData)
  const [higherDiscountStatus, setHigherDiscountStatus] = useState(0);
  const [higherDiscountCost, setHigherDiscountCost] = useState(0);

  const [higherDiscountStatusOneOff, setHigherDiscountStatusOneOff] = useState(0);
  const [higherDiscountCostOneOff, setHigherDiscountCostOneOff] = useState(0);

  // OnGoing Input
  const [discount, setDiscount] = useState(0);
  const [premium, setPremium] = useState(0);
  const [discount_exist, setDiscount_exist] = useState(0);
  const [defaultPrice_exist, setDefaultPrice_exist] = useState(0);


  // One-Off Input
  const [discountOneOff, setDiscountOneOff] = useState(0);
  const [premiumOneOff, setPremiumOneOff] = useState(0);
  const [discount_existOneOff, setDiscount_existOneOff] = useState(0);
  const [defaultPrice_existOneOff, setDefaultPrice_existOneOff] = useState(0);

  const [max_discount, setMax_discount] = useState(0);
  const [agentConfigSetting, setAgentConfigSetting] = useState({});

  // console.log("agentConfigSetting contract", agentConfigSetting)

  const [paymentTerm, setPaymentTerm] = useState("monthly_dd");
  const [paymentTermOneOff, setPaymentTermOneOff] = useState("100_upfront");
  const [qualifyPackages, setQualifyPackages] = useState([]);

  const [paymentTypeOngoing, setPaymentTypeOngoing] = useState("monthly_dd");
  const [paymentTypeOneOff, setPaymentTypeOneOff] = useState("100_upfront");

  const [contractTypeOngoing, setContractTypeOngoing] = useState("contract_type_ongoing");
  const [contractTypeOneOff, setContractTypeOneOff] = useState("contract_type_oneoff");

  const [cmPremiumOngoing, setCmPremiumOngoing] = useState(0);
  const [cmPremiumOneOff, setCmPremiumOneOff] = useState(0);

  const [cmDiscountOngoing, setCmDiscountOngoing] = useState(0);
  const [cmDiscountOneOff, setCmDiscountOneOff] = useState(0);

  // console.log('cmPremiumOngoing', cmPremiumOngoing)
  // console.log('cmPremiumOneOff', cmPremiumOneOff)
  // console.log('cmDiscountOngoing', cmDiscountOngoing)
  // console.log('cmDiscountOneOff', cmDiscountOneOff)

  const [quoteData, setQuoteData] = useState({
    quote: [],
    chargeBasisQuery: [],
    onOffServices: [],
    onGoingServices: [],
    packages: [],
    ExistClientContract: null,
  });

  console.log("ExistClientContract ---->>  ", quoteData?.ExistClientContract)



  // OnGoing Input
  const [max_discountAgent, setMax_discountAgent] = useState(null);
  const [serviceData, setServiceData] = useState([]);
  const [addedService, setAddedService] = useState([]);

  // console.log("addedservice", addedService);

  const [agentData, setAgentData] = useState({});
  const [showModalPaymentTerm, setShowModalPaymentTerm] = useState(false);
  const [showModalPaymentTermOneOff, setShowModalPaymentTermOneOff] = useState(false);
  // const [paymentTypeOfModal, setPaymentTypeOfModal] = useState("ManualPayment");
  const [paymentTypeOfModal, setPaymentTypeOfModal] = useState("GoCardless");
  const [paymentTypeOfModalOneOff, setPaymentTypeOfModalOneOff] = useState("ManualPayment");


  const handleCloseModal = () => {
    setShowModalPaymentTerm(false);
  };

  const handleCloseModalOneOff = () => {
    setShowModalPaymentTermOneOff(false);
  };

  const handleCloseModalPackageChanges = () => {
    setPackagesChangesModel(false);
    setPackagehandleChangeChargeBasis({});
    setPackageDeleteService({});
    setPackageChangeEnterDefaultValue({});
    setPackageChangeAddedService({});
  };

  const handlePackageChangesProceed = async () => {
    setPackagesChanges(true);
    setDiscount(0);
    // For Package Services Charge Basis Change 
    if (packagehandleChangeChargeBasis.type !== undefined && packagehandleChangeChargeBasis.type === 'package') {
      const { name, value, item, index, type } = packagehandleChangeChargeBasis;
      // For Package Servieces
      if (name == "default") {
        const defaultBasis = item.ServiceChargeBases.find(
          b => Number(b.ChargeBasis.id) === Number(value)
        );
        const basisTypeId = defaultBasis?.ChargeBasis?.BasisType?.id;
        let price;
        if ([3, 4].includes(Number(basisTypeId))) {
          const inputValue = (() => {
            const matchedItem = quoteEnterDefaultValue.find(
              item => item.chargebasis_id === defaultBasis.ChargeBasis.id
            );
            if (!matchedItem) return null;
            const valueObj = defaultBasis.ServiceChargeBasisValues.find(
              v => v.chargetype_rule_id === matchedItem.chargetype_rule_id
            );
            return valueObj ? valueObj.value : null;
          })();

          if (inputValue != null) {
            price = parseFloat(inputValue);
          } else {
            price = '-';
          }
        }
        else if (Number(basisTypeId) === 2 || Number(basisTypeId) === 6) {
          price = defaultBasis.price_rate;
        }

        else {
          const inputValue = quoteEnterDefaultValue?.find(item => item?.chargebasis_id === defaultBasis?.ChargeBasis?.id)?.inputValue;
          if (inputValue != null && defaultBasis.price_rate != null) {
            let calculatPrice = parseFloat(inputValue) * parseFloat(defaultBasis.price_rate);
            if (calculatPrice > 0) {
              if (calculatPrice < parseFloat(defaultBasis.min_base_price)) {
                price = defaultBasis.min_base_price;
              } else {
                price = calculatPrice;
              }
            } else {
              price = 0;
            }
          } else {
            price = '-';
          }
        }
        setPackagesServiceData((prevState) => {
          const updatedServices = [...prevState];
          updatedServices[index].Service.setDefaultId = Number(value);
          updatedServices[index].Service.sell_chargebasis_id = Number(value);
          price = servicePriceCalculation(updatedServices[index]?.Service);
          updatedServices[index].price = Number.isFinite(price) ? Number(roundNumber(price)) : price;
          return updatedServices;
        });

      }
      else if (name == "frequency") {
        setPackagesServiceData((prevState) => {
          const updatedServices = [...prevState];
          updatedServices[index].Service.setDefaultId = Number(value);
          updatedServices[index].Service.sell_chargebasis_id = Number(value);
          let price = servicePriceCalculation(updatedServices[index]?.Service)
          updatedServices[index].price = Number.isFinite(price) ? Number(roundNumber(price)) : price;
          return updatedServices;
        });

      }
      setPackagehandleChangeChargeBasis({});
    }

    // For Package Services Charge Basis Change End
    if (packageDeleteService.type !== undefined && packageDeleteService.type === 'package') {
      const { index, type } = packageDeleteService;
      const updatedServices = [...packagesServiceData];
      updatedServices.splice(index, 1);
      setPackagesServiceData(updatedServices);
      setPackageDeleteService({});
    }

    // For Package Change Enter Default Value
    if (packageChangeEnterDefaultValue.typ !== undefined && packageChangeEnterDefaultValue.typ === 'package') {
      let { name, value, item, type, typ, serviceItem, currentChargeBasis } = packageChangeEnterDefaultValue;


      let packages = quoteData.packages;
      if (name == "needSelfAssessmentCount") {


        const isValid = /^[0-9]+$/.test(value);
        if (!isValid) {
          if (value == "") {
            debouncedSearch({ quoteEnterDefaultValue: quoteEnterDefaultValue, selfAssessmentCount: "", packageID: packageID, quoteIndividualSetValue: quoteIndividualSetValue });
            await stateManageQuoteIndividualSetValue(1, packages);
          }
          setSelfAssessmentCount("")
          return
        }
        if (value > 5) {
          Swal.fire({
            icon: "warning",
            title: "Oops...",
            text: "You can only add 5 individuals",
            confirmButtonText: "ok"
          });
          setSelfAssessmentCount(5)
          await stateManageQuoteIndividualSetValue(5, packages);
          return
        }


        setSelfAssessmentCount(value);
        await stateManageQuoteIndividualSetValue(value, packages);

      }
      // 2 Handle chargeBasisQuery dynamic inputs (chargeBasisQuery_0, chargeBasisQuery_1, etc.)
      else if (name.startsWith("chargeBasisQuery_")) {

        const isValid = /^[0-9]+$/.test(value);
        if (isValid == false) {
          value = 0
        }

        const updatedCharges = [...quoteEnterDefaultValue];
        const existingIndex = updatedCharges.findIndex(val => val.chargebasis_id === item.chargebasis_id);

        if (existingIndex !== -1) {
          // Update existing object
          if (type === "input") {
            updatedCharges[existingIndex].inputValue = Number(value);
          } else if (type === "dropdown") {
            updatedCharges[existingIndex].chargetype_rule_id = Number(value);
          }
        }

        debouncedSearch({ quoteEnterDefaultValue: updatedCharges, selfAssessmentCount: selfAssessmentCount, packageID: packageID, quoteIndividualSetValue: quoteIndividualSetValue, packages: packages });

        setQuoteEnterDefaultValue(updatedCharges);
      }
      else if (type === 'radio' || type === 'input') {



        const isValid = /^[0-9]+$/.test(value);
        if (type === 'input' && isValid == false) {
          value = 0
        }

        const match = name.match(/name_(\d+)_ind_(\d+)/);

        if (match) {
          const qIndexFromName = Number(match[1]);
          const indIndexFromName = Number(match[2]);

          const updatedQuoteIndividualSetValue = [...quoteIndividualSetValue];

          // Ab yahan deep level pe update karna hai
          if (type === 'radio') {
            updatedQuoteIndividualSetValue[qIndexFromName].individual[indIndexFromName].radio_option =
              value === "on" || value === "1" ? "1" : "0";
          } else if (type === 'input') {
            updatedQuoteIndividualSetValue[qIndexFromName].individual[indIndexFromName].inputValue = Number(value);
          }



          debouncedSearch({ quoteEnterDefaultValue: quoteEnterDefaultValue, selfAssessmentCount: selfAssessmentCount, packageID: packageID, quoteIndividualSetValue: updatedQuoteIndividualSetValue, packages: packages });


          setQuoteIndividualSetValue(updatedQuoteIndividualSetValue);
        }
      }
      else if (name.startsWith("hoursQuery_")) {

        setRateQtyChange(value)

        if (type == "rate") {
          const errorKey = `${serviceItem.id}_${currentChargeBasis.id}`;

          let price_rate = currentChargeBasis?.price_rate;

          if (Number(price_rate) === 0) {
            setRateError(prev => ({
              ...prev,
              [errorKey]:
                [1, 2].includes(Number(userDetails?.is_role))
                  ? (
                    <span>
                      Default rate is not set up. <br />
                      <span
                        className="text-primary text-decoration-underline"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/admin/pricing/all-services")}
                      >
                        Click here
                      </span> to set this up.
                    </span>
                  )
                  : (
                    <span>
                      Setup required. Please contact <br />
                      your administrator.
                    </span>
                  )
            }));

            return
          }


          const isValid = /^[0-9]+$/.test(value);
          if (isValid == false) {
            value = 0
          }


          setRateError(prev => ({
            ...prev,
            [errorKey]:
              (!["", undefined, null].includes(currentChargeBasis?.price_rate) &&
                Number(value) < Number(currentChargeBasis?.price_rate))
                ? (
                  <div
                    className="text-danger"
                    style={{
                      position: "absolute",
                      fontSize: "12px",
                      marginTop: "2px",
                      whiteSpace: "nowrap",
                      display: "block",
                    }}
                  >
                    Please enter the amount above
                    <span style={{ display: "block" }}>
                      the configured rate (£{currentChargeBasis?.price_rate})
                    </span>
                  </div>
                )
                : ""
          }));


          setPackagesServiceData(prev =>
            prev.map(item => {
              if (item?.service_id !== serviceItem.id) return item;

              return {
                ...item,
                Service: {
                  ...item.Service,
                  ServiceChargeBases: item?.Service?.ServiceChargeBases?.map(cb => {
                    if (cb.id !== currentChargeBasis.id) return cb;

                    const rate = parseFloat(value) || 0;
                    const qty = parseFloat(cb?.inputValueHour) || 0;

                    return {
                      ...cb,
                      rate: rate,
                      priceHourly: rate * qty
                    };
                  })
                },
                price:
                  (parseFloat(value) || 0) *
                  (parseFloat(currentChargeBasis?.inputValueHour) || 0)
              };
            })
          );




        } else if (type == "input") {

          const isValid = /^(\d+)?(\.(25|5|75)?)?$/.test(value);

          if (!isValid) {
            return;
          }

          setPackagesServiceData(prev =>
            prev.map(item => {
              if (item?.service_id !== serviceItem.id) return item;

              return {
                ...item,
                Service: {
                  ...item.Service,
                  ServiceChargeBases: item?.Service?.ServiceChargeBases?.map(cb => {
                    if (cb.id !== currentChargeBasis.id) return cb;

                    const rate = Number(cb?.rate || 0);
                    const qty = Number(value || 0);

                    return {
                      ...cb,
                      inputValueHour: value,
                      priceHourly: rate * qty
                    };
                  })
                },
                price: (parseFloat(value) || 0) * (parseFloat(currentChargeBasis?.rate) || 0)
              };
            })
          );

        } else {
          return
        }




      }
      if (packagesServiceData?.length > 0) {
        setPackagesServiceData((prev) =>
          prev.map((item) => {
            const price = servicePriceCalculation(item?.Service);
            return {
              ...item,
              price: Number.isFinite(price) ? Number(roundNumber(price)) : price,
            };
          })
        );
      }
      setPackageChangeEnterDefaultValue({})

    };

    // Added Service in Package
    if (packageChangeAddedService.type !== undefined && packageChangeAddedService.type === 'addService') {
      const { selectedOptions } = packageChangeAddedService;
      const selectedIds = selectedOptions.map((option) => parseInt(option.value));

      setServiceData(selectedOptions);
      const filteredServices = quoteData.services.filter((service) =>
        selectedIds.includes(parseInt(service.id))
      );


      const updatedServices_p = filteredServices
        .map((service) => {
          const existing = addedService.find(s => s.id === service.id);
          if (existing) {
            return existing;
          } else {
            const price = servicePriceCalculation(service);
            if (price === 'ChargeBasisNotExist') {
              return null;
            }
            return {
              ...service,
              price: Number.isFinite(price) ? Number(roundNumber(price)) : price,
              ServiceChargeBases: service?.ServiceChargeBases?.map(cb => ({
                ...cb,
                rate: cb?.price_rate ?? 0,
                inputValueHour: 0,
                priceHourly: 0
              })),
            };
          }
        })
        .filter(Boolean);

      const updatedServices = selectedIds.map(id =>
        updatedServices_p.find(item => item.id === id)
      ).filter(Boolean);

      // console.log("updatedServices -- ", updatedServices)

      if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
        const AllServicesWithoutPerHour = updatedServices.filter(service => {
          const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
          const matchingBasis = service.ServiceChargeBases.find(basis =>
            basis.chargebasis_id === defaultBasisId &&
            basis.ChargeBasis?.BasisType?.id === 2
          );
          return !matchingBasis;
        });

        const isExistOnGoing = AllServicesWithoutPerHour?.filter(service => Number(service?.servicetype_id) !== 2);
        const isExistOneoff = AllServicesWithoutPerHour?.filter(service => Number(service?.servicetype_id) === 2);

        if (isExistOnGoing.length > 0) {
          if (isExistOnGoing.length === 1) {
            if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_single)) {
              // setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_single));
              setDiscount(0);
            }
          } else if (isExistOnGoing.length > 1) {
            if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_multiple)) {
              //setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_multiple));
              setDiscount(0);
            }
          }
        }

        if (isExistOneoff.length > 0) {
          if (isExistOneoff.length === 1) {
            if (parseFloat(discountOneOff) > parseFloat(agentConfigSetting?.discount_oneoff_single)) {
              setDiscountOneOff(parseFloat(agentConfigSetting?.discount_oneoff_single));
            }
          } else if (isExistOneoff.length > 1) {
            if (parseFloat(discountOneOff) > parseFloat(agentConfigSetting?.discount_oneoff_multiple)) {
              setDiscount(parseFloat(agentConfigSetting?.discount_oneoff_multiple));
            }
          }
        } else {
          setDiscountOneOff(0);
        }

      }
      setAddedService(updatedServices);
    }

    setPackagesChangesModel(false);
  };

  // Quote Complexity Slider
  const [sliderValueComplexity, setSliderValueComplexity] = useState([0, 2]);
  const [selectedLabelComplexity, setSelectedLabelComplexity] = useState('Default');
  const [complexityValue, setComplexityValue] = useState(0);
  const levels = {
    Default: 2,
    Low: 34,
    Medium: 65,
    High: 99
  };

  const handleLabelComplexityClick = (label) => {
    if (Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true) {
      return
    }
    // console.log("agentConfigSetting", agentConfigSetting)
    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {

      if (label === 'Default') {
        setComplexityValue(0);
      } else if (label === 'Low') {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_low || 0));
      } else if (label === 'Medium') {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_medium || 0));
      } else if (label === 'High') {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_high || 0));
      }
      setSelectedLabelComplexity(label);
      setSliderValueComplexity([0, levels[label]]);
    } else {
      setComplexityValue(0);
      setSelectedLabelComplexity('Default');
      setSliderValueComplexity([0, 2]);
    }
  };

  const handleSliderComplexityClick = (e) => {
    if (Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true) {
      return
    }

    const sliderRect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - sliderRect.left;
    const sliderWidth = sliderRect.width;
    const percentage = (clickX / sliderWidth) * 100;
    // console.log("percentage", percentage);

    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {

      if (percentage < 32) {
        setComplexityValue(0);
        setSelectedLabelComplexity('Default');
        setSliderValueComplexity([0, 2]);
      }
      else if (percentage >= 32 && percentage < 61) {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_low || 0));
        setSelectedLabelComplexity('Low');
        setSliderValueComplexity([0, 34]);
      }
      else if (percentage >= 61 && percentage < 86) {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_medium || 0));
        setSelectedLabelComplexity('Medium');
        setSliderValueComplexity([0, 65]);
      }
      else if (percentage >= 86 && percentage < 100) {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_high || 0));
        setSelectedLabelComplexity('High');
        setSliderValueComplexity([0, 99]);
      }
    } else {
      setComplexityValue(0);
      setSelectedLabelComplexity('Default');
      setSliderValueComplexity([0, 2]);
    }
  }

  // Quote Risk Slider End
  const [sliderValueRisk, setSliderValueRisk] = useState([0, 2]);
  const [selectedLabelRisk, setSelectedLabelRisk] = useState('Default');
  const [riskValue, setRiskValue] = useState(0);

  const handleLabelRiskClick = (label) => {
    if (Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true) {
      return
    }
    // console.log("agentConfigSetting", agentConfigSetting)
    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
      if (label === 'Default') {
        setRiskValue(0);
      } else if (label === 'Low') {
        setRiskValue(parseFloat(agentConfigSetting.risk_low || 0));
      }
      else if (label === 'Medium') {
        setRiskValue(parseFloat(agentConfigSetting.risk_medium || 0));
      } else if (label === 'High') {
        setRiskValue(parseFloat(agentConfigSetting.risk_high || 0));
      }
      setSelectedLabelRisk(label);
      setSliderValueRisk([0, levels[label]]);
    }
    else {
      setRiskValue(0);
      setSelectedLabelRisk('Default');
      setSliderValueRisk([0, 2]);
    }
  }

  const handleSliderRiskClick = (e) => {
    if (Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true) {
      return
    }
    const sliderRect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - sliderRect.left;
    const sliderWidth = sliderRect.width;
    const percentage = (clickX / sliderWidth) * 100;
    // console.log("percentage", percentage);

    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
      if (percentage < 32) {
        setRiskValue(0);
        setSelectedLabelRisk('Default');
        setSliderValueRisk([0, 2]);
      }
      else if (percentage >= 32 && percentage < 61) {
        setRiskValue(parseFloat(agentConfigSetting.risk_low || 0));
        setSelectedLabelRisk('Low');
        setSliderValueRisk([0, 34]);
      }
      else if (percentage >= 61 && percentage < 86) {
        setRiskValue(parseFloat(agentConfigSetting.risk_medium || 0));
        setSelectedLabelRisk('Medium');
        setSliderValueRisk([0, 65]);
      }
      else if (percentage >= 86 && percentage < 100) {
        setRiskValue(parseFloat(agentConfigSetting.risk_high || 0));
        setSelectedLabelRisk('High');
        setSliderValueRisk([0, 99]);
      }
    } else {
      setRiskValue(0);
      setSelectedLabelRisk('Default');
      setSliderValueRisk([0, 2]);
    }

  }


  // Qulity of Data Slider End
  const [sliderValueQualityData, setSliderValueQualityData] = useState([0, 2]);
  const [selectedLabelQualityData, setSelectedLabelQualityData] = useState('Default');
  const [qualityDataValue, setQualityDataValue] = useState(0);

  const handleLabelQualityDataClick = (label) => {
    if (Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true) {
      return
    }
    // console.log("agentConfigSetting", agentConfigSetting)
    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
      if (label === 'Default') {
        setQualityDataValue(0);
      } else if (label === 'Low') {
        setQualityDataValue(parseFloat(agentConfigSetting.quality_data_low || 0));
      }
      else if (label === 'Medium') {
        setQualityDataValue(parseFloat(agentConfigSetting.quality_data_medium || 0));
      } else if (label === 'High') {
        setQualityDataValue(parseFloat(agentConfigSetting.quality_data_high || 0));
      }
      setSelectedLabelQualityData(label);
      setSliderValueQualityData([0, levels[label]]);
    }
    else {
      setQualityDataValue(0);
      setSelectedLabelQualityData('Default');
      setSliderValueQualityData([0, 2]);
    }
  }

  const handleSliderQualityDataClick = (e) => {
    if (Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true) {
      return
    }
    const sliderRect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - sliderRect.left;
    const sliderWidth = sliderRect.width;
    const percentage = (clickX / sliderWidth) * 100;
    // console.log("percentage", percentage);
    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
      if (percentage < 32) {
        setQualityDataValue(0);
        setSelectedLabelQualityData('Default');
        setSliderValueQualityData([0, 2]);
      }
      else if (percentage >= 32 && percentage < 61) {
        setQualityDataValue(parseFloat(agentConfigSetting.quality_data_low || 0));
        setSelectedLabelQualityData('Low');
        setSliderValueQualityData([0, 34]);
      }
      else if (percentage >= 61 && percentage < 86) {
        setQualityDataValue(parseFloat(agentConfigSetting.quality_data_medium || 0));
        setSelectedLabelQualityData('Medium');
        setSliderValueQualityData([0, 65]);
      }
      else if (percentage >= 86 && percentage < 100) {
        setQualityDataValue(parseFloat(agentConfigSetting.quality_data_high || 0));
        setSelectedLabelQualityData('High');
        setSliderValueQualityData([0, 99]);
      }
    } else {
      setQualityDataValue(0);
      setSelectedLabelQualityData('Default');
      setSliderValueQualityData([0, 2]);
    }
  }

  // FrequencyMeeting Slider End
  const [sliderValueFrequencyMeeting, setSliderValueFrequencyMeeting] = useState([0, 2]);
  const [selectedLabelFrequencyMeeting, setSelectedLabelFrequencyMeeting] = useState('Default');
  const [frequencyMeetingValue, setFrequencyMeetingValue] = useState(0);
  const handleLabelFrequencyMeetingClick = (label) => {
    if (Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true) {
      return
    }
    // console.log("agentConfigSetting", agentConfigSetting)
    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
      if (label === 'Default') {
        setFrequencyMeetingValue(0);
      } else if (label === 'Low') {
        setFrequencyMeetingValue(parseFloat(agentConfigSetting.frequency_meeting_low || 0));
      }
      else if (label === 'Medium') {
        setFrequencyMeetingValue(parseFloat(agentConfigSetting.frequency_meeting_medium || 0));
      } else if (label === 'High') {
        setFrequencyMeetingValue(parseFloat(agentConfigSetting.frequency_meeting_high || 0));
      }
      setSelectedLabelFrequencyMeeting(label);
      setSliderValueFrequencyMeeting([0, levels[label]]);
    }
    else {
      setFrequencyMeetingValue(0);
      setSelectedLabelFrequencyMeeting('Default');
      setSliderValueFrequencyMeeting([0, 2]);
    }
  }

  const handleSliderFrequencyMeetingClick = (e) => {
    if (Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true) {
      return
    }
    const sliderRect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - sliderRect.left;
    const sliderWidth = sliderRect.width;
    const percentage = (clickX / sliderWidth) * 100;
    // console.log("percentage", percentage);
    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
      if (percentage < 32) {
        setFrequencyMeetingValue(0);
        setSelectedLabelFrequencyMeeting('Default');
        setSliderValueFrequencyMeeting([0, 2]);
      }
      else if (percentage >= 32 && percentage < 61) {
        setFrequencyMeetingValue(parseFloat(agentConfigSetting.frequency_meeting_low || 0));
        setSelectedLabelFrequencyMeeting('Low');
        setSliderValueFrequencyMeeting([0, 34]);
      }
      else if (percentage >= 61 && percentage < 86) {
        setFrequencyMeetingValue(parseFloat(agentConfigSetting.frequency_meeting_medium || 0));
        setSelectedLabelFrequencyMeeting('Medium');
        setSliderValueFrequencyMeeting([0, 65]);
      }
      else if (percentage >= 86 && percentage < 100) {
        setFrequencyMeetingValue(parseFloat(agentConfigSetting.frequency_meeting_high || 0));
        setSelectedLabelFrequencyMeeting('High');
        setSliderValueFrequencyMeeting([0, 99]);
      }
    } else {
      setFrequencyMeetingValue(0);
      setSelectedLabelFrequencyMeeting('Default');
      setSliderValueFrequencyMeeting([0, 2]);
    }
  }

  // Access to Seniors Slider End
  const [sliderValueAccessSenior, setSliderValueAccessSenior] = useState([0, 2]);
  const [selectedLabelAccessSenior, setSelectedLabelAccessSenior] = useState('Default');
  const [accessSeniorValue, setAccessSeniorValue] = useState(0);
  const handleLabelAccessSeniorClick = (label) => {
    if (Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true) {
      return
    }
    // console.log("agentConfigSetting", agentConfigSetting)
    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
      if (label === 'Default') {
        setAccessSeniorValue(0);
      } else if (label === 'Low') {
        setAccessSeniorValue(parseFloat(agentConfigSetting.access_seniors_low || 0));
      }
      else if (label === 'Medium') {
        setAccessSeniorValue(parseFloat(agentConfigSetting.access_seniors_medium || 0));
      } else if (label === 'High') {
        setAccessSeniorValue(parseFloat(agentConfigSetting.access_seniors_high || 0));
      }
      setSelectedLabelAccessSenior(label);
      setSliderValueAccessSenior([0, levels[label]]);
    }
    else {
      setAccessSeniorValue(0);
      setSelectedLabelAccessSenior('Default');
      setSliderValueAccessSenior([0, 2]);
    }
  }

  const handleSliderAccessSeniorClick = (e) => {
    if (Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true) {
      return
    }
    const sliderRect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - sliderRect.left;
    const sliderWidth = sliderRect.width;
    const percentage = (clickX / sliderWidth) * 100;
    // console.log("percentage", percentage);
    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
      if (percentage < 32) {
        setAccessSeniorValue(0);
        setSelectedLabelAccessSenior('Default');
        setSliderValueAccessSenior([0, 2]);
      }
      else if (percentage >= 32 && percentage < 61) {
        setAccessSeniorValue(parseFloat(agentConfigSetting.access_seniors_low || 0));
        setSelectedLabelAccessSenior('Low');
        setSliderValueAccessSenior([0, 34]);
      }
      else if (percentage >= 61 && percentage < 86) {
        setAccessSeniorValue(parseFloat(agentConfigSetting.access_seniors_medium || 0));
        setSelectedLabelAccessSenior('Medium');
        setSliderValueAccessSenior([0, 65]);
      }
      else if (percentage >= 86 && percentage < 100) {
        setAccessSeniorValue(parseFloat(agentConfigSetting.access_seniors_high || 0));
        setSelectedLabelAccessSenior('High');
        setSliderValueAccessSenior([0, 99]);
      }
    } else {
      setAccessSeniorValue(0);
      setSelectedLabelAccessSenior('Default');
      setSliderValueAccessSenior([0, 2]);
    }
  }


  //  console.log("agentConfigSetting", agentConfigSetting)
  // console.log("selectedLabelComplexity", selectedLabelComplexity)
  // console.log("complexityValue", complexityValue)
  // console.log("riskValue", riskValue)
  // console.log("selectedLabelRisk", selectedLabelRisk)

  // discountvalue Calculation
  const discountValueFinal = parseFloat(cmDiscountOngoing || 0)
  const discountValueFinalOneOff = parseFloat(cmDiscountOneOff || 0)



  // increase premium calculation
  const increasePremiumFinal = parseFloat(complexityValue) + parseFloat(riskValue) + parseFloat(qualityDataValue) + parseFloat(frequencyMeetingValue) + parseFloat(accessSeniorValue) + parseFloat(premium || 0) + parseFloat(cmPremiumOngoing);

  const increasePremiumFinalOneOff = parseFloat(complexityValue) + parseFloat(riskValue) + parseFloat(qualityDataValue) + parseFloat(frequencyMeetingValue) + parseFloat(accessSeniorValue) + parseFloat(premiumOneOff || 0) + parseFloat(cmPremiumOneOff);

  // console.log("increasePremiumFinal", increasePremiumFinal)

  let containsGoCardless = false;
  let paymentTermTypeGetAgent = [];

  let containsGoCardlessOneOff = false;
  let paymentTermTypeGetAgentOneOff = [];
  if (agentData.agent_payment_settings != undefined) {
    //console.log("agentData agent_payment_settings --- ", JSON.parse(agentData.agent_payment_settings));
    let dataAgentPaymentSetting = JSON.parse(agentData.agent_payment_settings);
    containsGoCardless = Object.keys(dataAgentPaymentSetting).includes("GoCardless");
    // paymentTermTypeGetAgent = Object.keys(dataAgentPaymentSetting).filter(key => key !== "GoCardless");
    paymentTermTypeGetAgent = Object.entries(dataAgentPaymentSetting)
      .filter(([key]) => key !== "GoCardless")
      .map(([key, value]) => ({
        label: value.lable,
        value: key
      }));

    containsGoCardlessOneOff = Object.keys(dataAgentPaymentSetting).includes("GoCardless");
    paymentTermTypeGetAgentOneOff = Object.entries(dataAgentPaymentSetting)
      .filter(([key]) => key !== "GoCardless")
      .map(([key, value]) => ({
        label: value.lable,
        value: key
      }));
  }

  let paymentTypeLable = paymentTermTypeGetAgent?.find(item => item?.value === paymentTypeOfModal)?.label;
  let paymentTypeLableOneOff = paymentTermTypeGetAgentOneOff?.find(item => item?.value === paymentTypeOfModalOneOff)?.label;


  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
    }
  }, [textareaRef?.current?.scrollHeight, packageDescription]);

  useEffect(() => {
    if (textareaRef_payment.current) {
      textareaRef_payment.current.style.height = "auto";
      textareaRef_payment.current.style.height = textareaRef_payment.current.scrollHeight + "px";
    }
  }, [textareaRef_payment?.current?.scrollHeight, paymentTermDescription]);


  const OngoingInputDescription = (e) => {
    let { name, value } = e.target;
    if (name == 'package_description') {
      setPackageDescription(value);
    }
    else if (name == "payment_term_description") {
      setPaymentTermDescription(value);
    }
  }




  useEffect(() => {

    if (addedService?.length > 0) {
      setAddedService((prev) =>
        prev.map((item) => {
          const price = servicePriceCalculation(item);
          return {
            ...item,
            price: Number.isFinite(price) ? Number(roundNumber(price)) : price,
          };
        })
      );
    }

    if (packagesChanges == true) {
      if (packagesServiceData?.length > 0) {
        setPackagesServiceData((prev) =>
          prev.map((item) => {
            const price = servicePriceCalculation(item?.Service);
            return {
              ...item,
              price: Number.isFinite(price) ? Number(roundNumber(price)) : price,
            };
          })
        );
      }
    }

  }, [quoteEnterDefaultValue, quoteIndividualSetValue, selfAssessmentCount]);

  const getAgentList = async () => {
    const req = { agent_id: agent_id }
    await dispatch(agentDetails(req)).unwrap()
      .then(async (res) => {
        if (res.status) {
          setAgentData(res.data);
          if (res.data.adhoc_max_discount != null && res.data.adhoc_max_discount != undefined && res.data.adhoc_max_discount != "") {
            setMax_discountAgent(parseFloat(res.data.adhoc_max_discount));
          }
          let agent_authorised_users = res.data.agent_authorised_users
          if (agent_authorised_users !== null) {
            const parsedAuthorisedUsers = JSON.parse(agent_authorised_users);

            const authorisedArray = Array.isArray(parsedAuthorisedUsers)
              ? parsedAuthorisedUsers
              : [parsedAuthorisedUsers];

            setAgentListDataAuthorised(authorisedArray);
            setAgentListDataAuthorisedAll(authorisedArray)
          } else {
            setAgentListDataAuthorised([])
            setAgentListDataAuthorisedAll([])
          }
        }
        else {
        }
      })
      .catch((err) => {
        setAgentListDataAuthorised([])
        setAgentListDataAuthorisedAll([])
        console.log("Error", err)
      })
  }



  useEffect(() => {
    getAgentList();
    getQuoteCallFirstTime();
    //getQuoteAttachment();
  }, []);



  const ALLOWED_TYPES = {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  };

  const extractZipAndSetAttachment = async (zipBlob) => {
    const zip = await JSZip.loadAsync(zipBlob);
    const attachments = [];

    for (const fileName of Object.keys(zip.files)) {
      const zipEntry = zip.files[fileName];

      // folder skip
      if (zipEntry.dir) continue;

      const ext = fileName.split(".").pop().toLowerCase();

      // sirf allowed files
      if (ALLOWED_TYPES[ext]) {
        const fileBlob = await zipEntry.async("blob");

        const file = new File([fileBlob], fileName, {
          type: ALLOWED_TYPES[ext], // 🔥 dynamic MIME type
          lastModified: Date.now(),
        });

        attachments.push(file);
      }
    }

    // EXACT file-input behaviour
    setFormData((prev) => ({
      ...prev,
      attachments,
    }));
  };

  const getQuoteAttachment = async () => {
    const req = { id: Number(QuoteId), agent_id: agent_id, ongoing_onoff: 1, type: "attachment" };
    const res = await axios.post(
      Config.base_url + "get_contract",
      req,
      {
        responseType: "blob",
        validateStatus: () => true,
      }
    );

    // const blob = await res.data;

    // console.log("getQuoteAttachment blob -- ", blob)
    if (res.data.type === "application/json") {
      const text = await res.data.text();
      const json = JSON.parse(text);

      console.warn(json.message);
      return;
    }

    // 🔥 Safe to unzip
    await extractZipAndSetAttachment(res.data);
    // await extractZipAndSetAttachment(blob);



  };






  const UpdatedQuoteEnterDefualt = async (existingData, masterData) => {
    const updatedMasterData = masterData.map((item) => {
      // upar wale array me matching item dhundo
      const match = existingData.find((ex) =>
        ex.chargebasis_id === item.chargebasis_id
      );

      if (match) {
        return {
          ...item,
          inputValue: match.inputValue, // inputValue upar wale se lo
          chargetype_rule_id: match.chargetype_rule_id ?? item.chargetype_rule_id, // agar upar wale me chargetype_rule_id ho to overwrite
        };
      }

      return item; // agar match nahi mile to waise ka waise
    });
    setQuoteEnterDefaultValue(updatedMasterData);

    return updatedMasterData
    // Quote Enter Default Value Set ------------->
  }

  const UpdateIndividualSetValue = async (quoteIndividuals, allChargeBases) => {

    const flattened = [];

    quoteIndividuals.forEach(individual => {
      const name = individual.name;
      individual.ContractIndividualSetValues.forEach(setValue => {
        flattened.push({
          chargebases_id: setValue.chargebases_id,
          inputValue: setValue.inputValue,
          radio_option: setValue.radio_option,
          name: name
        });
      });
    });

    // Step 2: Group by chargebases_id
    const grouped = {};

    flattened.forEach(item => {
      if (!grouped[item.chargebases_id]) {
        grouped[item.chargebases_id] = {
          chargebases_id: item.chargebases_id,
          individual: []
        };
      }
      grouped[item.chargebases_id].individual.push({
        name: item.name,
        inputValue: item.inputValue,
        radio_option: item.radio_option
      });
    });

    // Step 3: Add name and basistypes_id using reference (like chargeBasis list)
    const transformed = Object.values(grouped).map(item => {
      const reference = allChargeBases.find(cb => cb.id === item.chargebases_id) || {};

      return {
        ...item,
        name: reference.name || null,
        basistypes_id: reference.basistypes_id || null
      };
    });



    setQuoteIndividualSetValue(transformed);

    return transformed

  }

  const UpdatedServiceOnly = async (input) => {

    // let serviceOnly = input.some(item => item.package_id == null);

    // if (serviceOnly == false) {
    //   return
    // }
    // Convert
    const output = input.map(item => {
      const service = { ...item.Service };

      service.ServiceChargeBases = service?.ServiceChargeBases.map(base => ({
        ...base,
        service_id: service.id,
        chargebasis_id: base.ChargeBasis.id,
        rate: item?.rate ?? base.price_rate,
        inputValueHour: item?.inputValueHour ?? 0,
        exist_price_rate: item?.exist_price_rate ?? base.price_rate,
      }));

      return {
        ...service,
        price: item.price,
        sell_chargebasis_id: item.sell_chargebasis_id
      };
    });

    setAddedService(output);
    setServiceData(output.map(item => ({
      value: item.id,
      label: item.name,
    })));


    //console.log("UpdatedServiceOnly -- ", output)

  }

  const UpdatedPackageService = async (input, res) => {

    let PackageService = input.some(item => item.package_id !== null);

    if (PackageService == false) {
      return
    }
    let package_id = input[0].package_id


    const output = input.map(item => {
      const service = item.Service;

      const transformedServiceChargeBases = service.ServiceChargeBases.map(scBase => ({
        id: scBase.id,
        service_id: service.id,
        chargebasis_id: scBase.ChargeBasis.id,
        price_rate: scBase.price_rate,
        incremental_price: scBase.incremental_price,
        min_base_price: scBase.min_base_price,
        chargebasis_asc_order: scBase.chargebasis_asc_order,
        operator: scBase.operator,
        ChargeBasis: {
          ...scBase.ChargeBasis,
          BasisType: {
            ...scBase.ChargeBasis.BasisType
          }
        },
        ServiceChargeBasisValues: scBase.ServiceChargeBasisValues.map(val => ({
          ...val,
          ChargeType: { ...val.ChargeType }
        })),
        rate: item?.rate ?? scBase.price_rate,
        inputValueHour: item?.inputValueHour ?? 0,
        exist_price_rate: item?.exist_price_rate ?? scBase.price_rate
      }));

      let price = item?.Package?.PackageServices?.find(ps => ps.service_id === service.id)?.price || 0;

      return {
        id: 18,
        agent_id: service.agent_id,
        package_id: item.package_id,
        service_id: item.service_id,
        //price: item.price,
        price: price,
        Service: {
          ...service,
          ServiceChargeBases: transformedServiceChargeBases,
          sell_chargebasis_id: item?.sell_chargebasis_id
        }
      };
    });




    if (!["", null, undefined].includes(package_id)) {
      // console.log("ffff",res.packages)
      let packageDetails = res.packages.find((item) => item.id == package_id);
      if (packageDetails != undefined) {
        //  console.log("packageDetails",packageDetails)
        setMax_discount(parseFloat(packageDetails.max_discount));
      }

      setPackageID(package_id);
      setDefaultPrice_exist(packageDetails?.default_price || 0);
      setPackagesServiceData(output);
    }

    return package_id

  }


  function adjust(contract, payment) {
    const total = contract + payment;
    return (total - 100) - 100;
  }

  const getQuoteCallFirstTime = async () => {
    setIsLoading(true)
    const req = { id: Number(QuoteId), agent_id: agent_id, ongoing_onoff: 1, type: "onlyIdData" };
    await dispatch(getContractData(req)).unwrap()
      .then(async (res) => {
        if (res.status) {

          if (Number(res?.quote?.request_higher_discount_ongoing) == 1 || Number(res?.quote?.request_higher_discount_oneoff) == 1) {
            setRequestHigherDiscountStatus(true)
          }
          setClientid(res?.quote?.client_id)
          if (!['', null, undefined].includes(res?.quote?.Agent?.ConfigSetting)) {
            setAgentConfigSetting(res?.quote?.Agent?.ConfigSetting);

            let payment_type_dd = res?.quote?.Agent?.ConfigSetting?.payment_type_dd;
            let payment_type_upfront = res?.quote?.Agent?.ConfigSetting?.payment_type_upfront;
            let contract_type_ongoing = res?.quote?.Agent?.ConfigSetting?.contract_type_ongoing;
            let contract_type_oneoff = res?.quote?.Agent?.ConfigSetting?.contract_type_oneoff;

            if (!['', null, undefined].includes(payment_type_dd) && !['', null, undefined].includes(contract_type_ongoing)) {
              // ongoing adjust Value
              let adjust_value_ongoing = adjust(parseFloat(contract_type_ongoing), parseFloat(payment_type_dd))
              if (adjust_value_ongoing >= 0) {
                setCmPremiumOngoing(adjust_value_ongoing);
              } else {
                adjust_value_ongoing = Math.abs(adjust_value_ongoing)
                setCmDiscountOngoing(adjust_value_ongoing);
              }

              // oneoff adjust Value
              let adjust_value_oneoff = adjust(parseFloat(contract_type_oneoff), parseFloat(payment_type_upfront))
              if (adjust_value_oneoff >= 0) {
                setCmPremiumOneOff(adjust_value_oneoff);
              } else {
                adjust_value_oneoff = Math.abs(adjust_value_oneoff)
                setCmDiscountOneOff(adjust_value_oneoff);
              }
            }
          }

          if (Number(res?.quote?.is_effected) === 1) {
            setIsLoading(false)
            getQuoteReSelect()

          } else {
            if (res?.quote?.ContractPackageServices?.length > 0) {
              let value = res.quote.contract_service_type;
              setServiceTypeForQuote(value);
              setAddedService([]);
              setPackageID(null);
              setPackagesServiceData([]);
              if (value == "1" || value == "2") {
                await getQuote(value)
              } else {
                setIsLoading(false)
                setServiceTypeForQuote("");
                setIsSelfAssessmentChargeBasis(false)
                setQuoteData({
                  quote: [],
                  chargeBasisQuery: [],
                  onOffServices: [],
                  onGoingServices: [],
                  packages: [],
                  ExistClientContract: null,
                });
              }
            } else {

              setIsLoading(false)
              getQuoteReSelect()
            }
          }




        } else {
          setIsLoading(false)
        }

      })
      .catch((err) => {
        setIsLoading(false)
        console.log("err", err);
      });

  };


  const getQuote = async (ongoing_onoff) => {

    const req = { id: Number(QuoteId), agent_id: agent_id, ongoing_onoff: ongoing_onoff };
    await dispatch(getContractData(req)).unwrap()
      .then(async (res) => {

        if (res.status) {

          setIsSelfAssessmentChargeBasis(res?.chargeBasisQuery?.some((item) => item.basistypes_id == 5))

          // Enter default values for charge basis
          const defaultValues = res?.chargeBasisQuery?.filter(item => [1, 2, 3, 4].includes(item.basistypes_id))?.map(item => {
            const isInput = [1, 2].includes(item.basistypes_id);
            const isSelect = [3, 4].includes(item.basistypes_id);
            return {
              chargebasis_id: item.id,
              chargetype_rule_id: isSelect ? item.ChargeTypes?.[0]?.id : null,
              inputValue: isInput ? 0 : null,
              pricing_queries: item?.pricing_queries,
              basistypes_id: item?.basistypes_id,
              ChargeTypes: item?.ChargeTypes,
            };
          });
          setQuoteEnterDefaultValue(defaultValues);

          //  <------------Updated Quote Enter Default Value Set ///
          if (res.quote.ContractEnterDefaultValues.length > 0) {
            await UpdatedQuoteEnterDefualt(res.quote.ContractEnterDefaultValues, defaultValues);
          }
          ////  -Updated Quote Enter Default Value Set----------> ///

          //  <------------Updated Quote UpdatedServiceOnly Value Set ///
          // if (res.quote.ContractPackageServices.length > 0) {
          //   await UpdatedServiceOnly(res.quote.ContractPackageServices)
          // }
          ////  -Updated Quote UpdatedServiceOnly Value Set----------> ///



          if (res.quote.ContractPackageServices.length > 0) {
            let PackageService = res.quote.ContractPackageServices.some(item => item.package_id !== null);
            if (PackageService != false && !['', undefined, null].includes(res.quote.ContractPackageServices[0].package_id)) {


              let PACKAGE_ID = await UpdatedPackageService(res.quote.ContractPackageServices.filter(item => Number(item.Service?.ServiceType?.id) !== 2), res)

              // let PACKAGE_ID = await UpdatedPackageService(
              //   res.quote.ContractPackageServices.filter(item => {
              //     const service = item.Service;
              //     let matchId = service.default_chargebasis_id;

              //     if (item.sell_chargebasis_id !== undefined) {
              //       matchId = item.sell_chargebasis_id;
              //     }
              //     const defaultBasis = service?.ServiceChargeBases?.find(
              //       b => b?.ChargeBasis?.id === matchId
              //     );
              //     // if (!defaultBasis) return false;
              //     const basisTypeId = defaultBasis?.ChargeBasis?.BasisType?.id;
              //     return Number(basisTypeId) !== 2;
              //   }),
              //   res
              // );

              setPackagesServiceHigherDiscount(res.quote.ContractPackageServices.filter(item => Number(item.Service?.ServiceType?.id) !== 2))

              await UpdatedServiceOnly(res.quote.ContractPackageServices.filter(item => Number(item.Service?.ServiceType?.id) === 2))

              // await UpdatedServiceOnly(
              //   res.quote.ContractPackageServices.filter(item => {
              //     const service = item.Service;
              //     let matchId = service.default_chargebasis_id;
              //     if (!['', null, undefined].includes(service.setDefaultId)) {
              //       matchId = service.setDefaultId;
              //     }
              //     if (service.sell_chargebasis_id !== undefined) {
              //       matchId = service.sell_chargebasis_id;
              //     }
              //     const defaultBasis = service?.ServiceChargeBases?.find(
              //       b => b?.ChargeBasis?.id === matchId
              //     );
              //     if (!defaultBasis) return false;
              //     const basisTypeId = defaultBasis?.ChargeBasis?.BasisType?.id;
              //     return Number(basisTypeId) === 2;
              //   })
              // );


              let packages_change_status = res?.quote?.package_change_status == "1" ? true : false;

              if (PACKAGE_ID != null && packages_change_status == false) {
                let existpackageDetals = res.PackageDetails.ContractPackageServices.find((val) => val.Package != null)
                if (existpackageDetals != undefined) {
                  setDiscount_exist(parseFloat(existpackageDetals.Package.default_discount || 0));
                }
                setPackageName(existpackageDetals?.Package?.name || "");

              }

            } else {
              await UpdatedServiceOnly(res.quote.ContractPackageServices)
            }
          }



          quoteData?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))


          const defaultValues_selfassessment = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))?.map(item => {
            const isInput = item.basistypes_id === 1;
            const isSelfAsscessment = item.basistypes_id === 5;
            return {
              chargebases_id: item.id,
              name: item.name,
              basistypes_id: item.basistypes_id,
              individual: [
                {
                  name: "Individual 1",
                  inputValue: isInput ? 0 : null,
                  radio_option: isSelfAsscessment ? "0" : "0",
                }
              ]

            };
          });

          setQuoteIndividualSetValue(defaultValues_selfassessment);

          //  <------------Updated UpdateIndividualSetValue Value Set ///
          if (res.quote.ContractIndividuals.length > 0) {
            const chargeBasisQuery = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))
            await UpdateIndividualSetValue(res.quote.ContractIndividuals, chargeBasisQuery)
          }
          ////  -Updated UpdateIndividualSetValue Value Set----------> ///




          setQuoteData({
            quote: res.quote,
            chargeBasisQuery: res.chargeBasisQuery,
            services: res.services,
            packages: res.packages,
            ExistClientContract: res.ExistClientContract,
          });

          // if (Number(ongoing_onoff) == 1) {
          //   setIsSelfAssessmentChargeBasis(res?.chargeBasisQuery?.some((item) => item.basistypes_id == 5))

          //   // Enter default values for charge basis
          //   const defaultValues = res?.chargeBasisQuery?.filter(item => [1, 2, 3, 4].includes(item.basistypes_id))?.map(item => {
          //     const isInput = [1, 2].includes(item.basistypes_id);
          //     const isSelect = [3, 4].includes(item.basistypes_id);
          //     return {
          //       chargebasis_id: item.id,
          //       chargetype_rule_id: isSelect ? item.ChargeTypes?.[0]?.id : null,
          //       inputValue: isInput ? 0 : null,
          //       pricing_queries: item?.pricing_queries,
          //       basistypes_id: item?.basistypes_id,
          //       ChargeTypes: item?.ChargeTypes,
          //     };
          //   });
          //   setQuoteEnterDefaultValue(defaultValues);


          //   let EnterDefault = []
          //   //  <------------Updated Quote Enter Default Value Set ///
          //   if (res.quote.ContractEnterDefaultValues.length > 0) {
          //     EnterDefault = await UpdatedQuoteEnterDefualt(res.quote.ContractEnterDefaultValues, defaultValues);
          //   }
          //   ////  -Updated Quote Enter Default Value Set----------> ///

          // let PACKAGE_ID = null
          // //  <------------Updated Quote UpdatedServiceOnly  Value Set ///
          // if (res.quote.ContractPackageServices.length > 0) {
          //   await UpdatedServiceOnly(res.quote.ContractPackageServices)

          //   // Package services
          //   PACKAGE_ID = await UpdatedPackageService(res.quote.ContractPackageServices, res)
          // }
          //   ////  -Updated Quote UpdatedServiceOnly Value Set----------> ///

          // if (PACKAGE_ID != null) {
          //   let existpackageDetals = res.PackageDetails.ContractPackageServices.find((val) => val.Package != null)
          //   if (existpackageDetals != undefined) {
          //     setDiscount_exist(parseFloat(existpackageDetals.Package.default_discount || 0));
          //   }

          // }



          //   quoteData?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))


          //   const defaultValues_selfassessment = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))?.map(item => {
          //     const isInput = item.basistypes_id === 1;
          //     const isSelfAsscessment = item.basistypes_id === 5;
          //     return {
          //       chargebases_id: item.id,
          //       name: item.name,
          //       basistypes_id: item.basistypes_id,
          //       individual: [
          //         {
          //           name: "Individual 1",
          //           inputValue: isInput ? 0 : null,
          //           radio_option: isSelfAsscessment ? "0" : "0",
          //         }
          //       ]


          //     };
          //   });
          //   setQuoteIndividualSetValue(defaultValues_selfassessment);



          //   //  <------------Updated UpdateIndividualSetValue Value Set ///
          //   let EnterIndividualSetValue = []
          //   if (res.quote.ContractIndividuals.length > 0) {
          //     const chargeBasisQuery = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))
          //     EnterIndividualSetValue = await UpdateIndividualSetValue(res.quote.ContractIndividuals, chargeBasisQuery)
          //   }
          //   ////  -Updated UpdateIndividualSetValue Value Set----------> ///


          //   let EnterIndividualSetValueReq = EnterIndividualSetValue.length > 0 ? EnterIndividualSetValue : defaultValues_selfassessment;
          //   let EnterDefaultReq = EnterDefault.length > 0 ? EnterDefault : defaultValues;

          //   debouncedSearch({ quoteEnterDefaultValue: EnterDefaultReq, selfAssessmentCount: Number(res.quote.self_assessment_need_input), packageID: PACKAGE_ID, quoteIndividualSetValue: EnterIndividualSetValueReq, packages: res.packages });

          //   // debouncedSearch({ quoteEnterDefaultValue: EnterDefault, selfAssessmentCount: Number(res.quote.self_assessment_need_input),packageID: PACKAGE_ID ,quoteIndividualSetValue: EnterIndividualSetValue ,packages:res.packages });

          //   setQuoteData({
          //     quote: res.quote,
          //     chargeBasisQuery: res.chargeBasisQuery,
          //     services: res.services,
          //     packages: res.packages,
          //   });




          // }
          // else if (Number(ongoing_onoff) == 2) {
          //   setIsSelfAssessmentChargeBasis(res?.chargeBasisQuery?.some((item) => item.basistypes_id == 5))

          //   // Enter default values for charge basis
          //   const defaultValues = res?.chargeBasisQuery?.filter(item => [1, 2, 3, 4].includes(item.basistypes_id))?.map(item => {
          //     const isInput = [1, 2].includes(item.basistypes_id);
          //     const isSelect = [3, 4].includes(item.basistypes_id);
          //     return {
          //       chargebasis_id: item.id,
          //       chargetype_rule_id: isSelect ? item.ChargeTypes?.[0]?.id : null,
          //       inputValue: isInput ? 0 : null,
          //       pricing_queries: item?.pricing_queries,
          //       basistypes_id: item?.basistypes_id,
          //       ChargeTypes: item?.ChargeTypes,
          //     };
          //   });
          //   setQuoteEnterDefaultValue(defaultValues);

          //   //  <------------Updated Quote Enter Default Value Set ///
          //   if (res.quote.ContractEnterDefaultValues.length > 0) {
          //     await UpdatedQuoteEnterDefualt(res.quote.ContractEnterDefaultValues, defaultValues);
          //   }
          //   ////  -Updated Quote Enter Default Value Set----------> ///

          //   //  <------------Updated Quote UpdatedServiceOnly Value Set ///
          //   if (res.quote.ContractPackageServices.length > 0) {
          //     await UpdatedServiceOnly(res.quote.ContractPackageServices)
          //   }
          //   ////  -Updated Quote UpdatedServiceOnly Value Set----------> ///


          //   // 
          //   quoteData?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))


          //   const defaultValues_selfassessment = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))?.map(item => {
          //     const isInput = item.basistypes_id === 1;
          //     const isSelfAsscessment = item.basistypes_id === 5;
          //     return {
          //       chargebases_id: item.id,
          //       name: item.name,
          //       basistypes_id: item.basistypes_id,
          //       individual: [
          //         {
          //           name: "Individual 1",
          //           inputValue: isInput ? 0 : null,
          //           radio_option: isSelfAsscessment ? "0" : "0",
          //         }
          //       ]

          //     };
          //   });
          //   setQuoteIndividualSetValue(defaultValues_selfassessment);



          //   //  <------------Updated UpdateIndividualSetValue Value Set ///
          //   if (res.quote.ContractIndividuals.length > 0) {
          //     const chargeBasisQuery = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))
          //     await UpdateIndividualSetValue(res.quote.ContractIndividuals, chargeBasisQuery)
          //   }
          //   ////  -Updated UpdateIndividualSetValue Value Set----------> ///


          //   setQuoteData({
          //     quote: res.quote,
          //     chargeBasisQuery: res.chargeBasisQuery,
          //     services: res.services,
          //     packages: [],
          //   });

          // }

          // set Quote value exist
          if (res.quote.ContractPackageServices.length > 0) {

            //await EditFunctionRun(res);
            setContractTypeOngoing(res?.quote?.contractTypeOngoing || 'contract_type_ongoing');
            setContractTypeOneOff(res?.quote?.contractTypeOneOff || 'contract_type_oneoff');

            setCmPremiumOngoing(res?.quote?.cmPremiumOngoing || 0);
            setCmPremiumOneOff(res?.quote?.cmPremiumOneOff || 0);
            setCmDiscountOngoing(res?.quote?.cmDiscountOngoing || 0);
            setCmDiscountOneOff(res?.quote?.cmDiscountOneOff || 0);

            setHigherDiscountStatus(res?.quote?.higher_discount_status || 0);
            setHigherDiscountCost(res?.quote?.higher_discount_cost || 0);

            setHigherDiscountStatusOneOff(res?.quote?.higher_discount_status_oneoff || 0);
            setHigherDiscountCostOneOff(res?.quote?.higher_discount_cost_oneoff || 0);
            // setPackageDescription(res.quote.package_description);
            // setPaymentTermDescription(res.quote.payment_term_description);


            setFormData(prev => ({
              ...prev,
              packageDescription: res?.quote?.package_description || "",
              paymentTermDescription: res?.quote?.payment_term_description || ""
            }));


            setSelfAssessmentCount(Number(res.quote.self_assessment_need_input));
            setShowAttachment(res?.quote?.attachment_status);
            setShowDiscount(res.quote.show_discount);
            setShowPrice(res.quote.show_price);
            setSelectedLabelComplexity(res?.quote?.complexity_label || 'Default');
            setSelectedLabelRisk(res?.quote?.risk_label || 'Default');
            setComplexityValue(res?.quote?.complexity_premium || 0);
            setRiskValue(res?.quote?.risk_premium || 0);
            setSliderValueComplexity([0, levels[res?.quote?.complexity_label || 'Default']]);
            setSliderValueRisk([0, levels[res?.quote?.risk_label || 'Default']]);

            setQualityDataValue(res?.quote?.quality_data_premium || 0);
            setSelectedLabelQualityData(res?.quote?.quality_data_label || 'Default');
            setSliderValueQualityData([0, levels[res?.quote?.quality_data_label || 'Default']]);

            setFrequencyMeetingValue(res?.quote?.frequency_meeting_premium || 0);
            setSelectedLabelFrequencyMeeting(res?.quote?.frequency_meeting_label || 'Default');
            setSliderValueFrequencyMeeting([0, levels[res?.quote?.frequency_meeting_label || 'Default']]);

            setAccessSeniorValue(res?.quote?.access_seniors_premium || 0);
            setSelectedLabelAccessSenior(res?.quote?.access_seniors_label || 'Default');
            setSliderValueAccessSenior([0, levels[res?.quote?.access_seniors_label || 'Default']]);
            let packages_change_status = res?.quote?.package_change_status == "1" ? true : false;
            setPackagesChanges(packages_change_status);



            // if (Number(ongoing_onoff) == 1) {
            //   setDiscount(parseFloat(res.quote.discount_ongoing || 0));
            //   setPremium(parseFloat(res.quote.premium_ongoing || 0));
            //   setPaymentTerm(res.quote.payment_term_ongoing);
            //   setPaymentTypeOfModal(res.quote.payment_type_ongoing);
            // } else if (Number(ongoing_onoff) == 2) {
            //   setDiscount(parseFloat(res.quote.discount_oneoff || 0));
            //   setPremium(parseFloat(res.quote.premium_oneoff || 0));
            //   setPaymentTerm(res.quote.payment_term_oneoff);
            //   setPaymentTypeOfModalOneOff(res.quote.payment_type_oneoff);
            // }


            setDiscount(parseFloat(res.quote.discount_ongoing || 0));
            setPremium(parseFloat(res.quote.premium_ongoing || 0));

            setPaymentTerm(res.quote.payment_term_ongoing || 'monthly_dd');
            setPaymentTypeOngoing(res.quote.payment_term_ongoing || 'monthly_dd')
            setPaymentTypeOfModal(res.quote.payment_type_ongoing);

            setDiscountOneOff(parseFloat(res.quote.discount_oneoff || 0));
            setPremiumOneOff(parseFloat(res.quote.premium_oneoff || 0));

            setPaymentTermOneOff(res.quote.payment_term_oneoff || '100_upfront');
            setPaymentTypeOneOff(res.quote.payment_term_oneoff || '100_upfront');

            setPaymentTypeOfModalOneOff(res.quote.payment_type_oneoff);
            setIsLoading(false)

          }
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })
      .catch((err) => {
        setIsLoading(false)
        console.log("err", err);
      });
  };

  const getQuoteReSelect = async (ongoing_onoff) => {
    const req = { id: Number(QuoteId), agent_id: agent_id, ongoing_onoff: ongoing_onoff };
    await dispatch(getContractData(req)).unwrap()
      .then(async (res) => {

        if (res.status) {

          setIsSelfAssessmentChargeBasis(res?.chargeBasisQuery?.some((item) => item.basistypes_id == 5))

          // Enter default values for charge basis
          const defaultValues = res?.chargeBasisQuery?.filter(item => [1, 2, 3, 4].includes(item.basistypes_id))?.map(item => {
            const isInput = [1, 2].includes(item.basistypes_id);
            const isSelect = [3, 4].includes(item.basistypes_id);
            return {
              chargebasis_id: item.id,
              chargetype_rule_id: isSelect ? item.ChargeTypes?.[0]?.id : null,
              inputValue: isInput ? 0 : null,
              pricing_queries: item?.pricing_queries,
              basistypes_id: item?.basistypes_id,
              ChargeTypes: item?.ChargeTypes,
            };
          });
          setQuoteEnterDefaultValue(defaultValues);



          const defaultValues_selfassessment = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))?.map(item => {
            const isInput = item.basistypes_id === 1;
            const isSelfAsscessment = item.basistypes_id === 5;
            return {
              chargebases_id: item.id,
              name: item.name,
              basistypes_id: item.basistypes_id,
              individual: [
                {
                  name: "Individual 1",
                  inputValue: isInput ? 0 : null,
                  radio_option: isSelfAsscessment ? "0" : "0",
                }
              ]


            };
          });
          setQuoteIndividualSetValue(defaultValues_selfassessment);

          setQuoteData({
            quote: res.quote,
            chargeBasisQuery: res.chargeBasisQuery,
            services: res.services,
            packages: res.packages,
            ExistClientContract: res.ExistClientContract,
          });

        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleNeedSelfChange = (e) => {

    let { name } = e.target;
    if (name == "yes") {
      let checked = e.target.checked;
      if (checked == true) {
        if (selfAssessmentCount == 0 || selfAssessmentCount == "") {
          setSelfAssessmentCount(1);
        }

      }
    }
    else if (name == "no") {
      let checked = e.target.checked;
      if (checked == true) {

        if (Number(selfAssessmentCount) > 0) {
          setSelfAssessmentCount(selfAssessmentCount);
        } else {
          setSelfAssessmentCount(0);
        }




        let removeIdSelfAssessment = addedService?.filter(service => Number(service.incremental_rule) === 1).map(service => service.id);

        setAddedService((prevServices) =>
          prevServices.filter(service => service.incremental_rule !== "1")
        );
        setServiceData((prev) =>
          prev.filter(item => !removeIdSelfAssessment.includes(item.value))
        );

      }
    }
  }

  const searchApiQualifyPackage = async (text) => {

    const req = { id: Number(QuoteId), agent_id: agent_id, ongoing_onoff: 1, type: "searchPackageQualify", searchQuery: text };

    await dispatch(getContractData(req)).unwrap()
      .then(async (res) => {
        //  console.log("res Qualify -- ", res);
        // setQualifyPackages(res?.packages || []);
        // if (text.packageID != null) {
        //   let packageDetails = [...text.packages, ...(quoteData.packages), ...(res?.packages)].find(
        //     (item) => item.id == Number(text.packageID)
        //   );
        //   //  console.log("packageDetails Qualify ", packageDetails)
        //   if (packageDetails == undefined) {
        //     setPackageID(null);
        //     setPackagesServiceData([]);
        //     setDiscount(0);
        //     setPremium(0);
        //     setDiscount_exist(0);
        //     setMax_discount(0);
        //     setPaymentTerm("monthly_dd");
        //   }

        // }

      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // debounce wrap
  const debouncedSearch = useCallback(
    debounce((text) => {
      searchApiQualifyPackage(text);
    }, 500), // 500ms delay
    []
  );

  const usedChargeBasis = new Set();
  const usedChargeBasisCopy = new Set();
  const usedChargeBasisSelfAssesment = new Set();

  const [rateError, setRateError] = useState({});

  // console.log("quoteIndividualSetValue -->> ", quoteIndividualSetValue);
  // console.log("usedChargeBasisSelfAssesment -->> ", usedChargeBasisSelfAssesment);

  const inputChangeChargeBasisFun = async (e, item, index, type, typ, serviceItem, currentChargeBasis) => {

    let { name, value } = e.target;

    if (packagesChanges == false) {
      if (typ === "package") {
        setPackageChangeEnterDefaultValue({ name: name, value: value, item: item, type: type, typ, serviceItem: serviceItem, currentChargeBasis: currentChargeBasis })
        setPackagesChangesModel(true);
        return;
      }
    }

    let packages = quoteData.packages;
    if (name == "needSelfAssessmentCount") {

      const isValid = /^[0-9]+$/.test(value);
      if (!isValid) {
        if (value == "") {
          debouncedSearch({ quoteEnterDefaultValue: quoteEnterDefaultValue, selfAssessmentCount: "", packageID: packageID, quoteIndividualSetValue: quoteIndividualSetValue });
          await stateManageQuoteIndividualSetValue(1, packages);
        }
        setSelfAssessmentCount("")
        return
      }
      if (value > 5) {
        Swal.fire({
          icon: "warning",
          title: "Oops...",
          text: "You can only add 5 individuals",
          confirmButtonText: "ok"
        });
        setSelfAssessmentCount(5)
        await stateManageQuoteIndividualSetValue(5, packages);
        return
      }


      setSelfAssessmentCount(value);
      await stateManageQuoteIndividualSetValue(value, packages);

    }
    // 2 Handle chargeBasisQuery dynamic inputs (chargeBasisQuery_0, chargeBasisQuery_1, etc.)
    else if (name.startsWith("chargeBasisQuery_")) {

      const isValid = /^[0-9]+$/.test(value);
      if (isValid == false) {
        value = 0
      }

      const updatedCharges = [...quoteEnterDefaultValue];
      const existingIndex = updatedCharges.findIndex(val => val.chargebasis_id === item.chargebasis_id);

      if (existingIndex !== -1) {
        // Update existing object
        if (type === "input") {
          updatedCharges[existingIndex].inputValue = Number(value);
        } else if (type === "dropdown") {
          updatedCharges[existingIndex].chargetype_rule_id = Number(value);
        }
      }

      debouncedSearch({ quoteEnterDefaultValue: updatedCharges, selfAssessmentCount: selfAssessmentCount, packageID: packageID, quoteIndividualSetValue: quoteIndividualSetValue, packages: packages });

      setQuoteEnterDefaultValue(updatedCharges);
    }
    else if (name.startsWith("hoursQuery_")) {
      setRateQtyChange(value)
      if (type == "rate") {

        const errorKey = `${serviceItem.id}_${currentChargeBasis.id}`;

        let price_rate = currentChargeBasis?.price_rate;

        if (Number(price_rate) === 0) {
          setRateError(prev => ({
            ...prev,
            [errorKey]:
              [1, 2].includes(Number(userDetails?.is_role))
                ? (
                  <span>
                    Default rate is not set up. <br />
                    <span
                      className="text-primary text-decoration-underline"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/admin/pricing/all-services")}
                    >
                      Click here
                    </span> to set this up.
                  </span>
                )
                : (
                  <span>
                    Setup required. Please contact <br />
                    your administrator.
                  </span>
                )
          }));

          return
        }


        // const isValid = /^[0-9]+$/.test(value);
        // if (isValid == false) {
        //   value = 0
        // }
        const isValid = /^[0-9]{0,6}$/.test(value);
        if (!isValid) {
          return;
        }


        setRateError(prev => ({
          ...prev,
          [errorKey]:
            (!["", undefined, null].includes(currentChargeBasis?.price_rate) &&
              Number(value) < Number(currentChargeBasis?.price_rate))
              ? (
                <div
                  className="text-danger"
                  style={{
                    position: "absolute",
                    fontSize: "12px",
                    marginTop: "2px",
                    whiteSpace: "nowrap",
                    display: "block",
                  }}
                >
                  Please enter the amount above
                  <span style={{ display: "block" }}>
                    the configured rate (£{currentChargeBasis?.price_rate})
                  </span>
                </div>
              )
              : ""
        }));


        if (typ === "service") {
          setAddedService(prev =>
            prev.map(item => {
              if (item.id !== serviceItem.id) return item;

              return {
                ...item,
                ServiceChargeBases: item?.ServiceChargeBases?.map(cb => {
                  if (cb.id !== currentChargeBasis.id) return cb;

                  const rate = parseFloat(value) || 0;
                  const qty = parseFloat(cb?.inputValueHour) || 0;

                  return {
                    ...cb,
                    rate: rate,
                    priceHourly: rate * qty
                  };
                }),
                price: (parseFloat(value) || 0) * (parseFloat(currentChargeBasis?.inputValueHour) || 0)

              };
            })
          );
        }
        else if (typ === "package") {

          setPackagesServiceData(prev =>
            prev.map(item => {
              if (item?.service_id !== serviceItem.id) return item;

              return {
                ...item,
                Service: {
                  ...item.Service,
                  ServiceChargeBases: item?.Service?.ServiceChargeBases?.map(cb => {
                    if (cb.id !== currentChargeBasis.id) return cb;

                    const rate = parseFloat(value) || 0;
                    const qty = parseFloat(cb?.inputValueHour) || 0;

                    return {
                      ...cb,
                      rate: rate,
                      priceHourly: rate * qty
                    };
                  })
                },
                price:
                  (parseFloat(value) || 0) *
                  (parseFloat(currentChargeBasis?.inputValueHour) || 0)
              };
            })
          );

        } else {
          return
        }

      }
      else if (type == "input") {

        const isValid = /^(\d+)?(\.(25|5|75)?)?$/.test(value);
        if (!isValid) {
          return;
        }

        if (typ === "service") {
          setAddedService(prev =>
            prev.map(item => {
              if (item.id !== serviceItem.id) return item;

              return {
                ...item,
                ServiceChargeBases: item.ServiceChargeBases.map(cb => {
                  if (cb.id !== currentChargeBasis.id) return cb;

                  const rate = Number(cb?.rate || 0);
                  const qty = Number(value || 0);

                  return {
                    ...cb,
                    inputValueHour: value,
                    priceHourly: rate * qty
                  };
                }),
                price: (parseFloat(value) || 0) * (parseFloat(currentChargeBasis?.rate) || 0)

              };
            })
          );
        } else if (typ === "package") {

          setPackagesServiceData(prev =>
            prev.map(item => {
              if (item?.service_id !== serviceItem.id) return item;

              return {
                ...item,
                Service: {
                  ...item.Service,
                  ServiceChargeBases: item?.Service?.ServiceChargeBases?.map(cb => {
                    if (cb.id !== currentChargeBasis.id) return cb;

                    const rate = Number(cb?.rate || 0);
                    const qty = Number(value || 0);

                    return {
                      ...cb,
                      inputValueHour: value,
                      priceHourly: rate * qty
                    };
                  })
                },
                price: (parseFloat(value) || 0) * (parseFloat(currentChargeBasis?.rate) || 0)
              };
            })
          );

        } else {
          return
        }

      }
      else {
        return
      }

    }
    else if (type === 'radio' || type === 'input') {

      const isValid = /^[0-9]+$/.test(value);
      if (type === 'input' && isValid == false) {
        value = 0
      }

      const match = name.match(/name_(\d+)_ind_(\d+)/);

      if (match) {
        const qIndexFromName = Number(match[1]);
        const indIndexFromName = Number(match[2]);

        const updatedQuoteIndividualSetValue = [...quoteIndividualSetValue];


        // Ab yahan deep level pe update karna hai
        if (type === 'radio') {
          updatedQuoteIndividualSetValue[qIndexFromName].individual[indIndexFromName].radio_option =
            value === "on" || value === "1" ? "1" : "0";
        } else if (type === 'input') {
          updatedQuoteIndividualSetValue[qIndexFromName].individual[indIndexFromName].inputValue = Number(value);
        }

        debouncedSearch({ quoteEnterDefaultValue: quoteEnterDefaultValue, selfAssessmentCount: selfAssessmentCount, packageID: packageID, quoteIndividualSetValue: updatedQuoteIndividualSetValue, packages: packages });


        setQuoteIndividualSetValue(updatedQuoteIndividualSetValue);
      }
    }


  }


  const stateManageQuoteIndividualSetValue = (value, packages) => {

    setQuoteIndividualSetValue(prevData =>
      prevData.map(item => {
        let updatedIndividual = [...item.individual];

        // If increased
        if (updatedIndividual.length < value) {
          const toAdd = value - updatedIndividual.length;
          for (let i = 0; i < toAdd; i++) {
            // console.log("item ", item)
            let input = item?.basistypes_id == 1 ? 0 : null;
            let radio = item?.basistypes_id == 5 ? "0" : "0";
            updatedIndividual.push({
              name: `Individual ${updatedIndividual.length + 1}`,
              inputValue: input,
              radio_option: radio,
            });
          }
        }
        // If decreased
        else if (updatedIndividual.length > value) {
          updatedIndividual = updatedIndividual.slice(0, value);
        }

        return {
          ...item,
          individual: updatedIndividual
        };
      })
    );
    const updatedData = quoteIndividualSetValue.map(item => {
      let updatedIndividual = [...item.individual];

      if (updatedIndividual.length < value) {
        const toAdd = value - updatedIndividual.length;
        for (let i = 0; i < toAdd; i++) {
          let input = item?.basistypes_id == 1 ? 0 : 0;
          let radio = item?.basistypes_id == 5 ? "0" : "0";
          updatedIndividual.push({
            name: `Individual ${updatedIndividual.length + 1}`,
            inputValue: input,
            radio_option: radio,
          });
        }
      } else if (updatedIndividual.length > value) {
        updatedIndividual = updatedIndividual.slice(0, value);
      }

      return {
        ...item,
        individual: updatedIndividual
      };
    });
    //console.log("updatedData -- ", updatedData)
    debouncedSearch({ quoteEnterDefaultValue: quoteEnterDefaultValue, selfAssessmentCount: Number(value), packageID: packageID, quoteIndividualSetValue: updatedData, packages: packages });
  }
  // Added Select Services
  const handleAddService = (selectedOptions) => {


    setReasonHigherDiscount("");
    setAgentListDataAuthorised(agentListDataAuthorisedAll);
    setDesiredPriceApproval(0);
    setEmailAuthorised("");

    const selectedIds = selectedOptions.map((option) => parseInt(option.value));

    const serviceId = selectedIds[selectedIds.length - 1];

    // console.log("selectedIds -- ", selectedIds)
    // console.log("quoteData?.services -- ", quoteData?.services)
    const oneOffService = quoteData?.services?.find((service) => Number(service?.id) == Number(serviceId) && service?.servicetype_id == 2)



    if (!['', null, undefined].includes(packageID) && oneOffService == undefined) {
      if (packagesChanges == false) {
        setPackageChangeAddedService({ selectedOptions: selectedOptions, type: 'addService' })
        setPackagesChangesModel(true);
        return;
      }
    }


    setServiceData(selectedOptions);
    const filteredServices = quoteData.services.filter((service) =>
      selectedIds.includes(parseInt(service.id))
    );


    const updatedServices_p = filteredServices
      .map((service) => {
        const existing = addedService.find(s => s.id === service.id);
        if (existing) {
          return existing;
        } else {
          const price = servicePriceCalculation(service);
          if (price === 'ChargeBasisNotExist') {
            return null;
          }
          return {
            ...service,
            price: Number.isFinite(price) ? Number(roundNumber(price)) : price,
            ServiceChargeBases: service?.ServiceChargeBases?.map(cb => ({
              ...cb,
              rate: cb?.price_rate ?? 0,
              inputValueHour: 0,
              priceHourly: 0
            })),
          };
        }
      })
      .filter(Boolean);

    const updatedServices = selectedIds.map(id =>
      updatedServices_p.find(item => item.id === id)
    ).filter(Boolean);

    // console.log("updatedServices -- ", updatedServices)

    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
      const AllServicesWithoutPerHour = updatedServices.filter(service => {
        const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
        const matchingBasis = service.ServiceChargeBases.find(basis =>
          basis.chargebasis_id === defaultBasisId &&
          basis.ChargeBasis?.BasisType?.id === 2
        );
        return !matchingBasis;
      });


      const isExistOnGoing = AllServicesWithoutPerHour?.filter(service => Number(service?.servicetype_id) !== 2);
      const isExistOneoff = AllServicesWithoutPerHour?.filter(service => Number(service?.servicetype_id) === 2);

      if (isExistOnGoing.length > 0) {
        if (isExistOnGoing.length === 1) {
          if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_single)) {
            setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_single));
          }
        } else if (isExistOnGoing.length > 1) {
          if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_multiple)) {
            setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_multiple));
          }
        }
      }

      if (isExistOneoff.length > 0) {
        if (isExistOneoff.length === 1) {
          if (parseFloat(discountOneOff) > parseFloat(agentConfigSetting?.discount_oneoff_single)) {
            setDiscountOneOff(parseFloat(agentConfigSetting?.discount_oneoff_single));
          }
        } else if (isExistOneoff.length > 1) {
          if (parseFloat(discountOneOff) > parseFloat(agentConfigSetting?.discount_oneoff_multiple)) {
            setDiscount(parseFloat(agentConfigSetting?.discount_oneoff_multiple));
          }
        }
      } else {
        setDiscountOneOff(0);
      }



    }

    setAddedService(updatedServices);

  };

  // Remove Service
  const handleDeleteService = async (index, type) => {

    if (type === 'package') {
      if (packagesChanges == false) {
        setPackageDeleteService({ index, type })
        setPackagesChangesModel(true);
        return;
      }

      const updatedServices = [...packagesServiceData];
      updatedServices.splice(index, 1);


      if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {


        const AllServicesWithoutPerHour = addedService.filter(service => {
          const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
          const matchingBasis = service.ServiceChargeBases.find(basis =>
            basis.chargebasis_id === defaultBasisId &&
            basis.ChargeBasis?.BasisType?.id === 2
          );
          return !matchingBasis;
        });


        const AllPackageServicesWithoutPerHour = updatedServices?.filter(service => {
          service = service.Service;
          const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
          const matchingBasis = service.ServiceChargeBases.find(basis =>
            basis.chargebasis_id === defaultBasisId &&
            basis.ChargeBasis?.BasisType?.id === 2
          );
          return !matchingBasis;
        });

        let AllServicesCombined = [];
        if (packagesChanges == true) {
          AllServicesCombined = [...AllServicesWithoutPerHour, ...AllPackageServicesWithoutPerHour];
        } else {
          AllServicesCombined = [...AllServicesWithoutPerHour];
        }


        const isExistOnGoing = AllServicesCombined?.filter(service => Number(service?.servicetype_id) !== 2);

        //console.log("isExistOnGoing -- ", isExistOnGoing);

        if (isExistOnGoing.length > 0) {
          if (isExistOnGoing.length === 1) {
            if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_single)) {
              setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_single));
            }
          } else if (isExistOnGoing.length > 1) {
            if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_multiple)) {
              setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_multiple));
            }
          }
        }
      }

      setPackagesServiceData(updatedServices);
      return;
    } else {


      const updatedServices = [...addedService];
      updatedServices.splice(index, 1); // Remove service at given index
      if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {


        const AllServicesWithoutPerHour = updatedServices.filter(service => {
          const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
          const matchingBasis = service.ServiceChargeBases.find(basis =>
            basis.chargebasis_id === defaultBasisId &&
            basis.ChargeBasis?.BasisType?.id === 2
          );
          return !matchingBasis;
        });


        const AllPackageServicesWithoutPerHour = packagesServiceData?.filter(service => {
          service = service.Service;
          const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
          const matchingBasis = service.ServiceChargeBases.find(basis =>
            basis.chargebasis_id === defaultBasisId &&
            basis.ChargeBasis?.BasisType?.id === 2
          );
          return !matchingBasis;
        });

        let AllServicesCombined = [];
        if (packagesChanges == true) {
          AllServicesCombined = [...AllServicesWithoutPerHour, ...AllPackageServicesWithoutPerHour];
        } else {
          AllServicesCombined = [...AllServicesWithoutPerHour];
        }

        const isExistOnGoing = AllServicesCombined?.filter(service => Number(service?.servicetype_id) !== 2);

        // console.log("isExistOnGoing -- ", isExistOnGoing);

        const isExistOneoff = AllServicesWithoutPerHour?.filter(service => Number(service?.servicetype_id) === 2);

        if (isExistOnGoing.length > 0) {
          if (isExistOnGoing.length === 1) {
            if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_single)) {
              setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_single));
            }
          } else if (isExistOnGoing.length > 1) {
            if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_multiple)) {
              setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_multiple));
            }
          }
        }

        if (isExistOneoff.length > 0) {
          if (isExistOneoff.length === 1) {
            if (parseFloat(discountOneOff) > parseFloat(agentConfigSetting?.discount_oneoff_single)) {
              setDiscountOneOff(parseFloat(agentConfigSetting?.discount_oneoff_single));
            }
          } else if (isExistOneoff.length > 1) {
            if (parseFloat(discountOneOff) > parseFloat(agentConfigSetting?.discount_oneoff_multiple)) {
              setDiscount(parseFloat(agentConfigSetting?.discount_oneoff_multiple));
            }
          }
        } else {
          setDiscountOneOff(0);
        }


      }

      setAddedService(updatedServices);
      setServiceData((prevState) => {
        const updatedServices = [...prevState];
        updatedServices.splice(index, 1); // Remove service at given index
        return updatedServices;
      });
      return;




    }


  }
  // Handle Change Charge Basis
  const handleChangeChargeBasis = (e, item, index, type) => {
    let { name } = e.target;
    let value = e.target.value;

    if (type === 'package') {

      if (packagesChanges == false) {
        setPackagehandleChangeChargeBasis({ name, value, item, index, type })
        setPackagesChangesModel(true);
        return;
      }

      // For Package Servieces
      if (name == "default") {
        const defaultBasis = item.ServiceChargeBases.find(
          b => Number(b.ChargeBasis.id) === Number(e.target.value)
        );
        const basisTypeId = defaultBasis?.ChargeBasis?.BasisType?.id;
        let price;
        if ([3, 4].includes(Number(basisTypeId))) {
          const inputValue = (() => {
            const matchedItem = quoteEnterDefaultValue.find(
              item => item.chargebasis_id === defaultBasis.ChargeBasis.id
            );
            if (!matchedItem) return null;
            const valueObj = defaultBasis.ServiceChargeBasisValues.find(
              v => v.chargetype_rule_id === matchedItem.chargetype_rule_id
            );
            return valueObj ? valueObj.value : null;
          })();

          if (inputValue != null) {
            price = parseFloat(inputValue);
          } else {
            price = '-';
          }
        }
        else if (Number(basisTypeId) === 2 || Number(basisTypeId) === 6) {
          price = defaultBasis.price_rate;
        }

        else {
          const inputValue = quoteEnterDefaultValue?.find(item => item?.chargebasis_id === defaultBasis?.ChargeBasis?.id)?.inputValue;


          if (inputValue != null && defaultBasis.price_rate != null) {

            // console.log("Both Not Null -- ");
            let calculatPrice = parseFloat(inputValue) * parseFloat(defaultBasis.price_rate);
            if (calculatPrice > 0) {
              if (calculatPrice < parseFloat(defaultBasis.min_base_price)) {
                price = defaultBasis.min_base_price;
              } else {
                price = calculatPrice;
              }
            } else {
              price = 0;
            }
          } else {
            price = '-';
          }

        }

        setPackagesServiceData((prevState) => {
          const updatedServices = [...prevState];
          updatedServices[index].Service.setDefaultId = Number(e.target.value);
          updatedServices[index].Service.sell_chargebasis_id = Number(e.target.value);
          price = servicePriceCalculation(updatedServices[index]?.Service);
          updatedServices[index].price = Number.isFinite(price) ? Number(roundNumber(price)) : price;
          return updatedServices;
        });




      }
      else if (name == "frequency") {

        setPackagesServiceData((prevState) => {
          const updatedServices = [...prevState];
          updatedServices[index].Service.setDefaultId = Number(e.target.value);
          updatedServices[index].Service.sell_chargebasis_id = Number(e.target.value);
          let price = servicePriceCalculation(updatedServices[index]?.Service)
          updatedServices[index].price = Number.isFinite(price) ? Number(roundNumber(price)) : price;
          return updatedServices;
        });



      }

    }
    else {
      // For Servieces
      if (name == "default") {
        const defaultBasis = item.ServiceChargeBases.find(
          b => Number(b.ChargeBasis.id) === Number(e.target.value)
        );
        const basisTypeId = defaultBasis?.ChargeBasis?.BasisType?.id;
        let price;
        if ([3, 4].includes(Number(basisTypeId))) {
          const inputValue = (() => {
            const matchedItem = quoteEnterDefaultValue.find(
              item => item.chargebasis_id === defaultBasis.ChargeBasis.id
            );
            if (!matchedItem) return null;
            const valueObj = defaultBasis.ServiceChargeBasisValues.find(
              v => v.chargetype_rule_id === matchedItem.chargetype_rule_id
            );
            return valueObj ? valueObj.value : null;
          })();

          if (inputValue != null) {
            price = parseFloat(inputValue);
          } else {
            price = '-';
          }
        }
        else if (Number(basisTypeId) === 2 || Number(basisTypeId) === 6) {
          price = defaultBasis.price_rate;
        }

        else {
          const inputValue = quoteEnterDefaultValue?.find(item => item?.chargebasis_id === defaultBasis?.ChargeBasis.id)?.inputValue;
          if (inputValue != null && defaultBasis.price_rate != null) {
            let calculatPrice = parseFloat(inputValue) * parseFloat(defaultBasis.price_rate);
            if (calculatPrice > 0) {
              if (calculatPrice < parseFloat(defaultBasis.min_base_price)) {
                price = defaultBasis.min_base_price;
              } else {
                price = calculatPrice;
              }
            } else {
              price = 0;
            }
          } else {
            price = '-';
          }

        }

        setAddedService((prevState) => {
          const updatedServices = [...prevState];
          updatedServices[index].setDefaultId = Number(e.target.value);
          updatedServices[index].price = Number.isFinite(price) ? Number(roundNumber(price)) : price;
          updatedServices[index].sell_chargebasis_id = Number(e.target.value);
          price = servicePriceCalculation(updatedServices[index])
          updatedServices[index].price = Number.isFinite(price) ? Number(roundNumber(price)) : price;
          return updatedServices;
        });


      }
      else if (name == "frequency") {

        setAddedService((prevState) => {
          const updatedServices = [...prevState];
          updatedServices[index].setDefaultId = Number(e.target.value);
          updatedServices[index].sell_chargebasis_id = Number(e.target.value);
          let price = servicePriceCalculation(updatedServices[index])
          updatedServices[index].price = Number.isFinite(price) ? Number(roundNumber(price)) : price;
          return updatedServices;
        });

      }
    }

  }

  function servicePriceCalculation(service) {

    //  console.log("servicePriceCalculation service -- ", service);

    //Case 1 Use Default Charge Basis Calculation
    if (service?.default_chargebasis_id != null && Number(service?.default_chargebasis_status) == 1) {


      // console.log("servicePriceCalculation service -- ", service.name , "id" ,service.id);


      let matchId = service?.default_chargebasis_id
      if (!['', null, undefined].includes(service?.setDefaultId)) {
        matchId = service?.setDefaultId
      }

      if (service.sell_chargebasis_id != undefined) {
        matchId = service?.sell_chargebasis_id
      }

      // const defaultBasis = service?.ServiceChargeBases.find(
      //   b => b?.ChargeBasis?.id === matchId
      // );


      // if (defaultBasis == undefined) {
      //   return 'ChargeBasisNotExist';
      // }

      let defaultBasis = service?.ServiceChargeBases.find(
        b => b?.ChargeBasis?.id === matchId
      );


      if (defaultBasis == undefined) {

        defaultBasis = service?.ServiceChargeBases.find(
          (b) => b.ChargeBasis.id === Number(service?.default_chargebasis_id),
        );

        if (defaultBasis == undefined) {
          return "ChargeBasisNotExist";
        }

      }

      const basisTypeId = defaultBasis?.ChargeBasis?.BasisType?.id;


      if ([3, 4].includes(Number(basisTypeId))) {
        const inputValue = (() => {
          const matchedItem = quoteEnterDefaultValue.find(
            item => item?.chargebasis_id === defaultBasis?.ChargeBasis.id
          );

          if (!matchedItem) return null;
          const valueObj = defaultBasis.ServiceChargeBasisValues.find(
            v => v.chargetype_rule_id === matchedItem.chargetype_rule_id
          );
          return valueObj ? valueObj.value : null;

        })();

        if (inputValue != null) {
          return parseFloat(inputValue);
        } else {
          return '-';
        }
      }
      else if (Number(basisTypeId) === 2) {

        const rate = ["", null, undefined].includes(defaultBasis?.rate) ? 0 : defaultBasis?.rate;
        const inputValueHour = ["", null, undefined].includes(defaultBasis?.inputValueHour) ? 0 : defaultBasis?.inputValueHour;

        return rate * inputValueHour;

      }
      else if (Number(basisTypeId) === 6) {
        return defaultBasis?.price_rate;
      }
      else {

        const inputValue = quoteEnterDefaultValue.find(item => item?.chargebasis_id === defaultBasis.ChargeBasis?.id)?.inputValue;

        let rate_cutoff = defaultBasis?.rate_cutoff || null;
        let add_on_price = defaultBasis?.add_on_price || null;

        let extraPrice = 0;

        if (rate_cutoff != null && inputValue > rate_cutoff) {
          let intervals = Math.ceil((inputValue - rate_cutoff) / rate_cutoff);
          extraPrice = intervals * add_on_price;
        }

        if (inputValue != null && defaultBasis.price_rate != null) {
          let calculatPrice = parseFloat(inputValue) * parseFloat(defaultBasis.price_rate);
          if (calculatPrice > 0) {
            if (calculatPrice < parseFloat(defaultBasis.min_base_price)) {
              if (rate_cutoff != null && Number(inputValue) > parseFloat(rate_cutoff)) {
                return defaultBasis.min_base_price + extraPrice;
              } else {
                return defaultBasis.min_base_price;
              }

            } else {
              if (rate_cutoff != null && Number(inputValue) > parseFloat(rate_cutoff)) {
                calculatPrice = parseFloat(rate_cutoff) * parseFloat(defaultBasis.price_rate);
                return calculatPrice + extraPrice;
              } else {
                return calculatPrice;
              }
            }
          } else {
            return 0;
          }
        } else {
          return '-';
        }

      }

    }

    // Case 2 Use Incremental Rule Calculation
    else if (Number(service.incremental_rule) === 1) {
      const filteredMap = {};

      service?.ServiceChargeBases?.forEach(base => {
        const match = quoteIndividualSetValue?.find(
          input => input.chargebases_id === base.ChargeBasis.id
        );

        if (!match) return;

        const individualArray = match?.individual || [];
        individualArray.forEach((ind, index) => {
          const inputVal = parseFloat(ind.inputValue);

          if (ind.radio_option === "1" || inputVal > 0) {
            const key = base.ChargeBasis.id;

            if (!filteredMap[key]) {
              filteredMap[key] = {
                id: base.id,
                service_id: base.service_id,
                chargebasis_id: base.chargebasis_id,
                price_rate: base.price_rate,
                incremental_price: base.incremental_price,
                min_base_price: base.min_base_price,
                chargebasis_asc_order: base.chargebasis_asc_order,
                operator: base.operator,
                ChargeBasis: base.ChargeBasis, // ✅ preserved
                ServiceChargeBasisValues: base.ServiceChargeBasisValues || [],
                selectedIndex: 0,
                individual: [],
                basisTypeId: match.basistypes_id
              };
            }

            filteredMap[key].individual.push({
              ...ind,
              inputValue: inputVal || null
            });
          }
        });
      });


      let filtered = Object.values(filteredMap);
      //console.log("filtered first --", filtered);

      filtered = filtered?.map(item => {
        const match = quoteIndividualSetValue?.find(ref => ref.chargebases_id === item.chargebasis_id);

        return {
          ...item,
          individual: match ? match.individual : item.individual
        };
      });

      // console.log("filtered second --", filtered);


      // Step 1: Flatten all individuals and attach metadata into `allIndividuals`
      const allIndividuals = [];

      filtered.forEach(item => {
        const basisTypeId = item.ChargeBasis.BasisType.id;
        const isPerUnit = basisTypeId === 1;
        const isSelfAssessment = basisTypeId === 5;

        item.individual.forEach((ind, index) => {
          allIndividuals.push({
            ...ind,
            chargeBasisId: item.chargebasis_id,
            min_base_price: item.min_base_price,
            incremental_price: item.incremental_price,
            price_rate: item.price_rate,
            basisTypeId,
            indexInGroup: index,
            isPerUnit,
            isSelfAssessment,
            radio_option: ind.radio_option
          });
        });
      });

      let total = 0;
      const uniqueNames = [...new Set(allIndividuals.map(ind => ind.name))];
      uniqueNames.forEach(name => {
        const individuals = allIndividuals.filter(ind => ind.name === name);
        // console.log("individuals -- ", individuals);
        const selfAssessIndividuals = individuals.filter(i => i.isSelfAssessment && i.radio_option === "1" || parseFloat(i.inputValue) > 0);
        // const type5Prices = selfAssessIndividuals.map(i => i.min_base_price || 0);
        const prices = selfAssessIndividuals
          .filter(i => i.basisTypeId === 5 || i.basisTypeId === 1)
          .filter(i => i.basisTypeId === 5)
          .map(i => i.min_base_price || 0);

        const type5Prices = prices.length > 0
          ? prices
          : selfAssessIndividuals
            .filter(i => i.basisTypeId === 1)
            .map(i => i.min_base_price || 0);


        const uniqueType5Prices = new Set(type5Prices);

        const isOnlyOneWithBasisTypePerUnit = (() => {
          if (individuals.length === 1 && individuals[0].basisTypeId === 1) {
            return parseFloat(individuals[0].inputValue) > 0;
          } else {
            const hasBasisType1WithInput = individuals.some(
              ind => ind.basisTypeId === 1 && parseFloat(ind.inputValue) > 0
            );
            const allOthersAreBasisType5WithRadio0 = individuals
              .filter(ind => ind.basisTypeId !== 1)
              .every(ind => ind.basisTypeId === 5 && ind.radio_option === "0");

            return hasBasisType1WithInput && allOthersAreBasisType5WithRadio0;
          }
        })();

        // const isOnlyOneWithBasisTypePerUnit = (() => {
        //   if (individuals.length === 1 && individuals[0].basisTypeId === 1) {
        //     return parseFloat(individuals[0].inputValue) > 0;
        //   } else {
        //     const hasBasisType1WithInput = individuals.some(
        //       ind => ind.basisTypeId === 1 && parseFloat(ind.inputValue) > 0
        //     );

        //     const allOthersAreBasisType5 = individuals
        //       .filter(ind => ind.basisTypeId !== 1)
        //       .every(ind => ind.basisTypeId === 5);

        //     return hasBasisType1WithInput && allOthersAreBasisType5;
        //   }
        // })();

        // console.log("isOnlyOneWithBasisTypePerUnit -- ", isOnlyOneWithBasisTypePerUnit);
        // console.log("selfAssessIndividuals -- ", selfAssessIndividuals);
        if (uniqueType5Prices.size === type5Prices.length) {
          //  console.log("SCENARIO 1: All base prices unique");
          // console.log("selfAssessIndividuals -- ", selfAssessIndividuals);
          // SCENARIO 1: All base prices unique
          const maxBase = Math.max(...type5Prices);

          selfAssessIndividuals.forEach(ind => {
            // console.log("ind --IFFF ", ind);
            let sub = 0;

            if (ind.min_base_price === maxBase) {
              sub = ind.min_base_price || 0;
            } else {
              sub = ind.incremental_price || 0;
            }

            if (ind.isPerUnit) {
              //  console.log("ind.inputValue -- IFF ", ind.inputValue)
              const val = parseFloat(ind.inputValue);
              if (val > 0) {
                const calc = val * ind.price_rate;
                sub = (isOnlyOneWithBasisTypePerUnit && calc < ind.min_base_price)
                  ? ind.min_base_price
                  : calc;
              }
            }

            total += sub;
          });

        } else {
          // console.log("SCENARIO 2: Some base prices are duplicated");
          // SCENARIO 2: Some base prices duplicated
          // const basePriceGroups = {};
          // selfAssessIndividuals.forEach(saInd => {
          //   const base = saInd.min_base_price;
          //   if (!basePriceGroups[base]) basePriceGroups[base] = [];
          //   basePriceGroups[base].push(saInd);
          // });

          const prices = selfAssessIndividuals
            .filter(i => i.basisTypeId === 5 || i.basisTypeId === 1) // सिर्फ 1 और 5
            .filter(i => i.basisTypeId === 5) // type 5 priority
            .map(i => i.min_base_price || 0);

          const selectedPrices = prices.length > 0
            ? prices
            : selfAssessIndividuals
              .filter(i => i.basisTypeId === 1)
              .map(i => i.min_base_price || 0);

          const basePriceGroups = {};
          selectedPrices.forEach(price => {
            if (!basePriceGroups[price]) {
              basePriceGroups[price] = [];
            }
            basePriceGroups[price] = selfAssessIndividuals.filter(i => (i.min_base_price || 0) === price);
          });

          const allBasePrices = Object.keys(basePriceGroups).map(Number);
          const maxBasePrice = Math.max(...allBasePrices);
          const maxBaseGroup = basePriceGroups[maxBasePrice];

          let baseEntry;
          if (maxBaseGroup.length === 1) {
            baseEntry = maxBaseGroup[0];
          } else {
            baseEntry = maxBaseGroup.reduce((lowest, item) =>
              (item.incremental_price || Infinity) < (lowest.incremental_price || Infinity)
                ? item
                : lowest
            );
          }

          const baseEntryId = baseEntry.chargeBasisId;

          selfAssessIndividuals.forEach(ind => {
            // console.log("ind --ELSE ", ind);
            let sub = 0;

            if (ind.chargeBasisId === baseEntryId) {
              sub = ind.min_base_price || 0;
            } else {
              sub = ind.incremental_price || ind.min_base_price || 0;
            }

            if (ind.isPerUnit) {
              // console.log("ind.inputValue -- EEE ", ind.inputValue)
              const val = parseFloat(ind.inputValue);
              if (val > 0) {
                const calc = val * ind.price_rate;
                sub = (isOnlyOneWithBasisTypePerUnit && calc < ind.min_base_price)
                  ? ind.min_base_price
                  : calc;
              }
            }

            total += sub;
          });
        }
      });

      return total;
    }

    // Case 3 Use Frequency Custom Rule Calculation
    else if (Number(service.custom_rule == 1) && Number(service.link_frequency_rule == 1)) {
      // return CustomRuleCalculateTotalPrice(service?.ServiceChargeBases?.filter((item) => Number(item?.ChargeBasis?.BasisType?.id) !== 2));
      return CustomRuleCalculateTotalPrice(service?.ServiceChargeBases);
    }

    // Case 4 Use Custom Rule Calculation
    else if (Number(service.custom_rule == 1)) {

      // Frequency Rule Calculation
      if (Number(service.frequency_status == 1)) {


        // const frequencyChargeBasisAll = service?.ServiceChargeBases?.filter(
        //   item =>

        //     (item.ChargeBasis.id) === service?.frequency_optional_chargebasis_id ||
        //     item?.ChargeBasis?.BasisType?.id === 4
        // );

        const frequencyChargeBasisAll = service?.ServiceChargeBases?.filter(item =>
          (
            item.ChargeBasis.id === (
              service?.sell_chargebasis_id !== undefined && service?.sell_chargebasis_id !== null
                ? service.sell_chargebasis_id
                : service?.frequency_optional_chargebasis_id
            )
          ) || item?.ChargeBasis?.BasisType?.id === 4
        );


        const singleFrequencyChargeBasis = frequencyChargeBasisAll?.find(item => item?.ChargeBasis?.BasisType?.id === 4);

        const otherFrequencyChargeBasis = frequencyChargeBasisAll?.find(item => item?.ChargeBasis?.BasisType?.id !== 4);

        let otherFrequencyChargeBasisPerHourBasisId = otherFrequencyChargeBasis?.ChargeBasis?.BasisType?.id;

        // if (Number(otherFrequencyChargeBasisPerHourBasisId) === 2) {
        //   return otherFrequencyChargeBasis.price_rate;
        // }
        if (Number(otherFrequencyChargeBasisPerHourBasisId) === 2) {
          return FrequencyRulePriceSingleChareBasis(otherFrequencyChargeBasis);
        }


        const singleFrequencyChargeBasisPrice = FrequencyRulePriceSingleChareBasis(singleFrequencyChargeBasis);



        const otherFrequencyChargeBasisPrice = FrequencyRulePriceSingleChareBasis(otherFrequencyChargeBasis);




        let extraPrice = 0;
        let otherFrequencyBasisTypeId = otherFrequencyChargeBasis?.ChargeBasis?.BasisType?.id;
        if (Number(otherFrequencyBasisTypeId) === 1) {
          const inputValue = quoteEnterDefaultValue.find(item => item.chargebasis_id === otherFrequencyChargeBasis.ChargeBasis.id)?.inputValue;
          // console.log("otherFrequencyChargeBasis  ", otherFrequencyChargeBasis)
          // console.log("otherFrequencyBasisTypeId  ", otherFrequencyBasisTypeId)
          // console.log("inputValue -- ppp  ", inputValue)

          let rate_cutoff = otherFrequencyChargeBasis?.rate_cutoff || null;
          let add_on_price = otherFrequencyChargeBasis?.add_on_price || null;

          if (rate_cutoff != null && inputValue > rate_cutoff) {
            let intervals = Math.ceil((inputValue - rate_cutoff) / rate_cutoff);
            extraPrice = intervals * add_on_price;
          }
        }


        if (singleFrequencyChargeBasisPrice != null && otherFrequencyChargeBasisPrice != null) {
          const operator = singleFrequencyChargeBasis.operator;
          const left = parseFloat(otherFrequencyChargeBasisPrice);
          const right = parseFloat(singleFrequencyChargeBasisPrice);




          switch (operator) {
            case '+':
              return (left + right) + extraPrice;
            case '-':
              return (left - right) + extraPrice;
            case '*':
              return (left * right) + extraPrice;
            case '/':
              return right !== 0 ? (left / right) + extraPrice : 0;
            default:
              return 0;
          }
        }


      } else {

        // return CustomRuleCalculateTotalPrice(service?.ServiceChargeBases?.filter((item) => Number(item?.ChargeBasis?.BasisType?.id) !== 2));
        return CustomRuleCalculateTotalPrice(service?.ServiceChargeBases);
      }
    }

  }
  //Frequency Custom Rule Calculation
  const FrequencyRulePriceSingleChareBasis = (singleFrequencyChargeBasis) => {
    const basisTypeId = singleFrequencyChargeBasis?.ChargeBasis?.BasisType?.id;
    let singleFrequencyChargeBasisPrice = 0;
    if ([3, 4].includes(Number(basisTypeId))) {
      const inputValue = (() => {
        const matchedItem = quoteEnterDefaultValue.find(
          item => Number(item.chargebasis_id) === Number(singleFrequencyChargeBasis.ChargeBasis.id)
        );
        if (!matchedItem) return null;
        const valueObj = singleFrequencyChargeBasis.ServiceChargeBasisValues.find(
          v => Number(v.chargetype_rule_id) === Number(matchedItem.chargetype_rule_id)
        );
        return valueObj ? valueObj.value : null;
      })();



      if (inputValue != null) {
        singleFrequencyChargeBasisPrice = parseFloat(inputValue);
      } else {
        singleFrequencyChargeBasisPrice = 0
      }
    }
    else if (Number(basisTypeId) === 2) {

      const rate = ["", null, undefined].includes(singleFrequencyChargeBasis?.rate) ? 0 : singleFrequencyChargeBasis?.rate;
      const inputValueHour = ["", null, undefined].includes(singleFrequencyChargeBasis?.inputValueHour) ? 0 : singleFrequencyChargeBasis?.inputValueHour;

      return rate * inputValueHour;

    }
    else if (Number(basisTypeId) === 6) {
      singleFrequencyChargeBasisPrice = singleFrequencyChargeBasis.price_rate
    }
    else {

      const inputValue = quoteEnterDefaultValue.find(item => item.chargebasis_id === singleFrequencyChargeBasis.ChargeBasis.id)?.inputValue;

      let rate_cutoff = singleFrequencyChargeBasis?.rate_cutoff || null;
      let add_on_price = singleFrequencyChargeBasis?.add_on_price || null;

      if (inputValue != null && singleFrequencyChargeBasis.price_rate != null) {
        if (parseInt(inputValue) > 0) {
          let calculatPrice = parseFloat(inputValue) * parseFloat(singleFrequencyChargeBasis.price_rate);
          if (calculatPrice < parseFloat(singleFrequencyChargeBasis.min_base_price)) {
            singleFrequencyChargeBasisPrice = singleFrequencyChargeBasis.min_base_price;
          } else {
            if (rate_cutoff != null && Number(inputValue) > parseFloat(rate_cutoff)) {
              calculatPrice = parseFloat(rate_cutoff) * parseFloat(singleFrequencyChargeBasis.price_rate);
              singleFrequencyChargeBasisPrice = calculatPrice;
            } else {
              singleFrequencyChargeBasisPrice = calculatPrice;
            }
          }
        } else {
          singleFrequencyChargeBasisPrice = 0
        }
      } else {
        singleFrequencyChargeBasisPrice = 0
      }

    }
    return singleFrequencyChargeBasisPrice
  }
  //Basic Custom Rule Calculation
  const CustomRuleCalculateTotalPrice = (serviceChargeBases) => {
    const sortedChargeBases = [...serviceChargeBases].sort(
      (a, b) => a.chargebasis_asc_order - b.chargebasis_asc_order
    );
    let total = null;
    let extraPrice = 0;
    sortedChargeBases.forEach((item, index) => {

      let otherFrequencyChargeBasis = item
      const price = FrequencyRulePriceSingleChareBasis(item);


      // console.log("gggg")
      // console.log("price",price)

      let otherFrequencyBasisTypeId = otherFrequencyChargeBasis?.ChargeBasis?.BasisType?.id;
      if (Number(otherFrequencyBasisTypeId) === 1) {
        const inputValue = quoteEnterDefaultValue.find(item1 => item1.chargebasis_id === otherFrequencyChargeBasis.ChargeBasis.id)?.inputValue;

        let rate_cutoff = otherFrequencyChargeBasis?.rate_cutoff || null;
        let add_on_price = otherFrequencyChargeBasis?.add_on_price || null;

        if (rate_cutoff != null && inputValue > rate_cutoff) {
          let intervals = Math.ceil((inputValue - rate_cutoff) / rate_cutoff);
          extraPrice += intervals * add_on_price;
        }
      }


      if (index === 0) {
        total = price;
      } else {
        const operator = item.operator;
        switch (operator) {
          case '+':
            total += price;
            break;
          case '-':
            total -= price;
            break;
          case '*':
            total *= price;
            break;
          case '/':
            total = price !== 0 ? total / price : total; // avoid divide by 0
            break;
          default:
            break;
        }
      }
    });
    return total !== null ? total + extraPrice : 0;
  };

  // Package Service Calculation process
  const handlePackageSelect = async (e) => {

    setReasonHigherDiscount("");
    setAgentListDataAuthorised(agentListDataAuthorisedAll);
    setDesiredPriceApproval(0);
    setEmailAuthorised("");

    if (e.target.value == "custom_package") {
      return;
    }

    setServiceData([]);
    setAddedService([]);

    if (e.target.value != "" && e.target.value != "Select an action" && e.target.value != "custom_package") {
      //let packageDetails = quoteData.packages.find((item) => item.id == e.target.value);
      let packageDetails = [...(quoteData.packages || []), ...(qualifyPackages || [])].find(
        (item) => item.id == e.target.value
      );

      setPackageName(packageDetails?.name);

      ////////////////////////////
      setSliderValueComplexity([0, 2]);
      setSelectedLabelComplexity('Default');
      setComplexityValue(0)

      setSliderValueRisk([0, 2]);
      setSelectedLabelRisk('Default');
      setRiskValue(0);

      setSliderValueQualityData([0, 2]);
      setSelectedLabelQualityData('Default');
      setQualityDataValue(0);

      setSliderValueFrequencyMeeting([0, 2]);
      setSelectedLabelFrequencyMeeting('Default');
      setFrequencyMeetingValue(0);

      setSliderValueAccessSenior([0, 2]);
      setSelectedLabelAccessSenior('Default');
      setAccessSeniorValue(0);

      setDiscountOneOff(0);
      setPremiumOneOff(0);
      setDiscount_existOneOff(0);
      setDefaultPrice_existOneOff(0);

      ////////////////////////////

      const calculation_self_assessment = packageDetails?.calculation_self_assessment || 1;
      setPremium(0);
      setDiscount(parseFloat(packageDetails.default_discount));
      setDiscount_exist(parseFloat(packageDetails.default_discount));
      setDefaultPrice_exist(parseFloat(packageDetails.default_price));
      setMax_discount(parseFloat(packageDetails.max_discount));
      setPackageID(e.target.value);
      setSelfAssessmentCount(calculation_self_assessment)
      await getPackageServices(e.target.value, calculation_self_assessment);
    } else {

      /////////////////////////////
      setSliderValueComplexity([0, 2]);
      setSelectedLabelComplexity('Default');
      setComplexityValue(0)

      setSliderValueRisk([0, 2]);
      setSelectedLabelRisk('Default');
      setRiskValue(0);

      setSliderValueQualityData([0, 2]);
      setSelectedLabelQualityData('Default');
      setQualityDataValue(0);

      setSliderValueFrequencyMeeting([0, 2]);
      setSelectedLabelFrequencyMeeting('Default');
      setFrequencyMeetingValue(0);

      setSliderValueAccessSenior([0, 2]);
      setSelectedLabelAccessSenior('Default');
      setAccessSeniorValue(0);

      setDiscountOneOff(0);
      setPremiumOneOff(0);
      setDiscount_existOneOff(0);
      setDefaultPrice_existOneOff(0);
      ///////////////////


      setPackagesChanges(false);
      setDiscount(0);
      setPremium(0);
      setDiscount_exist(0);
      setDefaultPrice_exist(0);
      setMax_discount(0);
      setPackageID(null);
      setPackagesServiceData([]);
      setSelfAssessmentCount(1);
      //getQuoteCallFirstTime()
      getQuoteReSelect();
    }
  }

  const getPackageServices = async (packageID, calculation_self_assessment) => {
    const req = { package_id: Number(packageID), agent_id: agent_id };
    if (packageID != "") {
      await dispatch(getSinglePackage(req)).unwrap()
        .then(async (res) => {
          if (res.status) {

            // console.log("quoteEnterDefaultValue -- ", quoteEnterDefaultValue);
            // console.log("res? -- ", res?.packageData?.PackageEnterDefaultValues);

            if (quoteEnterDefaultValue?.length > 0 && res?.packageData?.PackageEnterDefaultValues?.length > 0) {
              setQuoteEnterDefaultValue((prevState) => {
                const updated = prevState.map((item) => {
                  const match = res?.packageData?.PackageEnterDefaultValues?.find(
                    (x) => Number(x?.chargebases_id) === Number(item?.chargebasis_id)
                  );
                  if (match) {
                    return {
                      ...item,
                      chargetype_rule_id: match?.chargetype_rule_id ?? item.chargetype_rule_id,
                      inputValue: match?.inputValue ?? item.inputValue,
                    };
                  }
                  return item;
                });
                return updated;
              });
            }
            if (quoteIndividualSetValue?.length > 0 && res?.packageData?.PackageEnterDefaultValues?.length > 0) {

              setQuoteIndividualSetValue(prevState => {
                return prevState.map(upperItem => {
                  const match =
                    res?.packageData?.PackageEnterDefaultValues?.find(
                      lowerItem =>
                        Number(lowerItem.chargebases_id) === Number(upperItem.chargebases_id)
                    );

                  // sirf basistypes_id 1 & 5
                  if (![1, 5].includes(upperItem.basistypes_id)) {
                    return upperItem;
                  }

                  const radioOption = match?.radio_option ?? "0";
                  const inputValue =
                    upperItem.basistypes_id === 5
                      ? null
                      : match?.inputValue ?? 0;

                  return {
                    ...upperItem,
                    individual: Array.from({ length: calculation_self_assessment }, (_, i) => ({
                      name: `Individual ${i + 1}`,
                      radio_option: radioOption,
                      inputValue: inputValue,
                    })),
                  };
                });
              });
            }

            const updatedServices = res?.services?.map(service => ({
              ...service,
              Service: {
                ...service?.Service,
                ServiceChargeBases: service?.Service?.ServiceChargeBases?.map(cb => ({
                  ...cb,
                  rate: cb?.price_rate ?? 0,
                  inputValueHour: 0,
                  priceHourly: 0
                })) || []
              }
            }));

            setPackagesServiceData(updatedServices)
            //setPackagesServiceData(res?.services)
          }
          else {
            setPackagesServiceData([]);
          }
        })
        .catch((err) => {
          setPackagesServiceData([]);
          console.log("err", err);
        });
    } else {
      setPackagesServiceData([]);
    }
  }



  const [errorDiscount, setErrorDiscount] = useState(false);
  const [packageDefaultDiscount, setPackageDefaultDiscount] = useState(0);

  const InputChangeDiscountPremium = (e) => {

    isServicediscount.current = false;

    let { name, value } = e.target;

    if (value === '.') {
      value = "0.";
    }

    const isValid = /^\d*\.?\d*$/.test(value);
    if (isValid == false) {
      return
    }
    // max_discountAgent
    // console.log("packageID", packageID);

    if (!['', null, undefined].includes(packageID) && packagesChanges == false) {

      let packageDetails = quoteData?.packages?.find((item) => item.id == packageID);
      setPackageDefaultDiscount(parseFloat(packageDetails.default_discount));
      if (name == 'discount' && value != "" && parseFloat(value || 0) > max_discount) {
        value = parseFloat(max_discount);
        // Ongoing Set payment term
        if ((addedService?.find((item) => [1, 3].includes(Number(item?.servicetype_id))) != undefined || packagesServiceData?.length > 0) && (["", null, undefined].includes(paymentTypeOfModal) && ["", null, undefined].includes(paymentTerm))) {
          setPaymentTerm("100_upfront");
          setPaymentTypeOfModal("ManualPayment");
        }

        // One Off Set payment term
        if (addedService?.find((item) => [2].includes(Number(item?.servicetype_id))) != undefined && (["", null, undefined].includes(paymentTypeOfModalOneOff) && ["", null, undefined].includes(paymentTermOneOff))) {
          setPaymentTermOneOff("100_upfront");
          setPaymentTypeOfModalOneOff("ManualPayment");
        }

        setShowModal(true);
      }

      // Package Minimum Discount Validation

      if (name == 'discount' && value != "" && parseFloat(value || 0) < parseFloat(packageDetails.default_discount)) {
        setErrorDiscount(true);
      } else {
        setErrorDiscount(false);
      }

    } else {
      let max_discountAgentConfig = null
      if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {

        // const AllServicesWithoutPerHour = addedService.filter(service => {
        //   const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
        //   const matchingBasis = service.ServiceChargeBases.find(basis =>
        //     basis.chargebasis_id === defaultBasisId &&
        //     basis.ChargeBasis?.BasisType?.id === 2
        //   );
        //   return !matchingBasis;
        // });
        const AllServicesWithoutPerHour = addedService;

        // const AllPackageServicesWithoutPerHour = packagesServiceData?.filter(service => {
        //   service = service.Service;
        //   const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
        //   const matchingBasis = service.ServiceChargeBases.find(basis =>
        //     basis.chargebasis_id === defaultBasisId &&
        //     basis.ChargeBasis?.BasisType?.id === 2
        //   );
        //   return !matchingBasis;
        // });
        const AllPackageServicesWithoutPerHour = packagesServiceData;

        let AllServicesCombined = [];
        if (packagesChanges == true) {
          AllServicesCombined = [...AllServicesWithoutPerHour, ...AllPackageServicesWithoutPerHour];
        } else {
          AllServicesCombined = [...AllServicesWithoutPerHour];
        }

        const isExistOnGoing = AllServicesCombined?.filter(service => Number(service?.servicetype_id) !== 2);


        if (isExistOnGoing?.length === 1) {
          max_discountAgentConfig = agentConfigSetting?.discount_ongoing_single;
        } else if (isExistOnGoing?.length > 1) {
          max_discountAgentConfig = agentConfigSetting?.discount_ongoing_multiple;
        }
      }

      if (name == 'discount' && max_discountAgentConfig == null) {
        value = value == "" ? "" : value;
      }
      else if (name == 'discount' && value != "" && parseFloat(value || 0) > max_discountAgentConfig) {
        value = parseFloat(max_discountAgentConfig);

        // Ongoing Set payment term
        if ((addedService?.find((item) => [1, 3].includes(Number(item?.servicetype_id))) != undefined || packagesServiceData?.length > 0) && (["", null, undefined].includes(paymentTypeOfModal) && ["", null, undefined].includes(paymentTerm))) {
          setPaymentTerm("100_upfront");
          setPaymentTypeOfModal("ManualPayment");
        }

        // One Off Set payment term
        if (addedService?.find((item) => [2].includes(Number(item?.servicetype_id))) != undefined && (["", null, undefined].includes(paymentTypeOfModalOneOff) && ["", null, undefined].includes(paymentTermOneOff))) {
          setPaymentTermOneOff("100_upfront");
          setPaymentTypeOfModalOneOff("ManualPayment");
        }


        setShowServiceHigherDiscount('ongoing');
        isServicediscount.current = true;
        setShowModal(true);
        //alert("Discount can't be more than " + max_discountAgentConfig);
      }

    }

    if ((name == 'premium') && parseFloat(value || 0) < 0) {
      value = 0;
    }

    if ((name == 'discount') && value != "" && parseFloat(value || 0) > 100) {
      value = 100;
    }

    if (name == 'discount') {
      setDiscount(value);
    } else if (name == 'premium') {
      setPremium(value);
    }

  };

  const InputChangeDiscountPremiumOneOff = (e) => {
    isServicediscount.current = false;
    let { name, value } = e.target;

    if (value === '.') {
      value = "0.";
    }
    const isValid = /^\d*\.?\d*$/.test(value);
    if (isValid == false) {
      return
    }

    let max_discountAgentConfig = null
    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {

      // const AllServicesWithoutPerHour = addedService.filter(service => {
      //   const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
      //   const matchingBasis = service.ServiceChargeBases.find(basis =>
      //     basis.chargebasis_id === defaultBasisId &&
      //     basis.ChargeBasis?.BasisType?.id === 2
      //   );
      //   return !matchingBasis;
      // });

      const AllServicesWithoutPerHour = addedService;


      const isExistOneoff = AllServicesWithoutPerHour?.filter(service => Number(service?.servicetype_id) === 2);

      if (isExistOneoff?.length === 1) {
        max_discountAgentConfig = agentConfigSetting?.discount_oneoff_single;
      } else if (isExistOneoff?.length > 1) {
        max_discountAgentConfig = agentConfigSetting?.discount_oneoff_multiple;
      }

    }

    if (name == 'discount' && max_discountAgentConfig == null) {
      value = value == "" ? "" : value;
    }
    else if (name == 'discount' && value != "" && parseFloat(value || 0) > max_discountAgentConfig) {
      value = parseFloat(max_discountAgentConfig);

      // Ongoing Set payment term
      if ((addedService?.find((item) => [1, 3].includes(Number(item?.servicetype_id))) != undefined || packagesServiceData?.length > 0) && (["", null, undefined].includes(paymentTypeOfModal) && ["", null, undefined].includes(paymentTerm))) {
        setPaymentTerm("100_upfront");
        setPaymentTypeOfModal("ManualPayment");
      }

      // One Off Set payment term
      if (addedService?.find((item) => [2].includes(Number(item?.servicetype_id))) != undefined && (["", null, undefined].includes(paymentTypeOfModalOneOff) && ["", null, undefined].includes(paymentTermOneOff))) {
        setPaymentTermOneOff("100_upfront");
        setPaymentTypeOfModalOneOff("ManualPayment");
      }

      setShowServiceHigherDiscount('oneoff');
      isServicediscount.current = true;
      setShowModal(true);
    }




    if ((name == 'premium') && parseFloat(value || 0) < 0) {
      value = 0;
    }

    if ((name == 'discount') && value != "" && parseFloat(value || 0) > 100) {
      value = 100;
    }


    if (name == 'discount') {
      setDiscountOneOff(value);
    } else if (name == 'premium') {
      setPremiumOneOff(value);
    }

  };


  /////////////////////------ Start Calculate OnGoing Services-------/////////////////////////// 



  // const PriceArrayServiceArray = addedService.filter(service => {
  //   if (![1, 3].includes(Number(service.servicetype_id))) return false;
  //   const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
  //   const matchingBasis = service.ServiceChargeBases.find(basis =>
  //     basis.chargebasis_id === defaultBasisId &&
  //     basis.ChargeBasis?.BasisType?.id === 2
  //   );
  //   return !matchingBasis;
  // });

  const PriceArrayServiceArray = addedService.filter(service => {
    if (![1, 3].includes(Number(service.servicetype_id))) {
      return false;
    }
    return true;
  });


  const finalPackageServices = packagesServiceData.length > 0
    ? packagesServiceData.map(pkg => ({
      ...pkg.Service,
      price: pkg.price
    }))
    : [];

  /////////////////// Hourly Billing Array

  const HourlyBillingArray = [...finalPackageServices, ...addedService];
  /////////////////////

  // merge arrya finalPackageServices and PriceArrayServiceArray
  const PriceArray = [...finalPackageServices, ...PriceArrayServiceArray];
  // const PriceArray = packageID != null ? packagesServiceData : PriceArrayServiceArray

  const totalCost1 = PriceArray.length
    ? PriceArray.reduce((acc, value) => acc + ((value.price + (value.price * increasePremiumFinal / 100)) || 0), 0)
    : 0;

  const totalCost = totalCost1 * (1 - discountValueFinal / 100);


  let totalCostWithDiscount = totalCost - (totalCost * ((discount || 0) / 100));


  if (Number(higherDiscountStatus) === 1) {
    totalCostWithDiscount = higherDiscountCost
  }


  if (packageID != null && packagesChanges == false && parseFloat(discount) === parseFloat(discount_exist) && parseFloat(increasePremiumFinal) === 0 && parseFloat(discountValueFinal) === 0) {

    totalCostWithDiscount = defaultPrice_exist;
  }


  function toTwoDecimalNum(num) {
    return Math.trunc(num * 100) / 100;
  }


  // totalCostWithDiscount = toTwoDecimalNum(totalCostWithDiscount);
  totalCostWithDiscount = Number(totalCostWithDiscount.toFixed(2));



  const netVAT20Amount = PriceArray.length
    ?
    PriceArray.filter((service) => service.vat_exempt === "0").reduce((acc, service) => acc + ((service.price + (service.price * increasePremiumFinal / 100)) || 0), 0)
    : 0;

  let netVAT20 = netVAT20Amount - (netVAT20Amount * ((discount || 0) / 100));
  netVAT20 = toTwoDecimalNum(netVAT20);
  const netNoVATAmount = PriceArray.length
    ?
    PriceArray.filter((service) => service.vat_exempt === "1").reduce((acc, service) => acc + ((service.price + (service.price * increasePremiumFinal / 100)) || 0), 0)
    : 0;


  // Apply discount on netNoVAT
  let netNoVAT = netNoVATAmount - (netNoVATAmount * ((discount || 0) / 100));
  netNoVAT = toTwoDecimalNum(netNoVAT);


  if (netNoVAT === 0 && Number(higherDiscountStatus) === 1) {
    netVAT20 = higherDiscountCost;
  }


  if (netVAT20 === 0 && Number(higherDiscountStatus) === 1) {
    netNoVAT = higherDiscountCost;
  }



  if (netNoVAT === 0 && packageID != null && parseFloat(discount) === parseFloat(discount_exist) && parseFloat(increasePremiumFinal) === 0) {
    netVAT20 = defaultPrice_exist;
  }

  if (netVAT20 === 0 && packageID != null && parseFloat(discount) === parseFloat(discount_exist) && parseFloat(increasePremiumFinal) === 0) {
    netNoVAT = defaultPrice_exist;
  }



  let final_vat_amount = totalCostWithDiscount
  let adminCharge = 0;
  let adminChargeAmount = 0;
  // if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
  //   if (Number(agentConfigSetting.admin_charge) === 1) {
  //     if (paymentTerm === "manual_payment_monthly") {
  //       adminCharge = Math.max((totalCostWithDiscount * 10) / 100, 50);

  //       adminChargeAmount = adminCharge

  //       if (600 > adminCharge) {
  //         adminChargeAmount = 600
  //       }

  //       final_vat_amount += adminChargeAmount;

  //     } else if (paymentTerm === "manual_payment_quarterly") {
  //       adminCharge = Math.max((totalCostWithDiscount * 10) / 100, 50);

  //       adminChargeAmount = adminCharge
  //       if (200 > adminCharge) {
  //         adminChargeAmount = 200
  //       }

  //       final_vat_amount += adminChargeAmount;
  //     }
  //   }

  // }



  // let vat = (netVAT20 * 20) / 100;
  // vat = toTwoDecimalNum(vat);

  // console.log("final_vat_amount -- ", final_vat_amount)

  let vat = (final_vat_amount * 20) / 100;
  vat = toTwoDecimalNum(vat);

  // console.log("vat -- ", vat)
  // let totalIncludingVATAmount = netVAT20 + vat + netNoVAT;

  let totalIncludingVATAmount = roundNumber(final_vat_amount) + roundNumber(vat);


  if (agentData && agentData?.vat_registered != undefined && agentData?.vat_registered == "NO") {
    totalIncludingVATAmount = totalCostWithDiscount;
    netVAT20 = 0;
    vat = 0;
    netNoVAT = 0;
  }




  const totalIncludingVAT = totalIncludingVATAmount

  // console.log("totalIncludingVAT -- ", totalIncludingVAT)

  let paymentDivisors = {
    monthly_dd: 12,
    quarterly_dd: 4,
    '100_upfront': 1,
    '50_upfront': 2,
    '100_post_completion': 1,
    manual_payment_monthly: 12,
    manual_payment_quarterly: 4,
  };


  let totalMonthlyCost = totalIncludingVAT / (paymentDivisors[paymentTerm] || 1);

  // let totalMonthlyCostExcluding = totalCostWithDiscount / (paymentDivisors[paymentTerm] || 1);
  let totalMonthlyCostExcluding = final_vat_amount / (paymentDivisors[paymentTerm] || 1);
  // Apply extra admin charge for manual payments

  // let adminCharge = 0;
  // if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
  //   if (Number(agentConfigSetting.admin_charge) === 1) {
  //     if (paymentTerm === "manual_payment_monthly") {
  //       adminCharge = Math.max((totalIncludingVAT * 10) / 100, 50);
  //       totalMonthlyCost += adminCharge;
  //     } else if (paymentTerm === "manual_payment_quarterly") {
  //       adminCharge = Math.max((totalIncludingVAT * 10) / 100, 50);
  //       totalMonthlyCost += adminCharge;
  //     }
  //   }

  // }

  /////////////////////------ End Calculate OnGoing Services-------///////////////////////////



  /////////////////////------ Start Calculate One-Off Services-------/////////////////////////// 


  // const PriceArrayServiceArrayOneOff = addedService.filter(service => {
  //   if (![2].includes(Number(service.servicetype_id))) return false;
  //   const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
  //   const matchingBasis = service.ServiceChargeBases.find(basis =>
  //     basis.chargebasis_id === defaultBasisId &&
  //     basis.ChargeBasis?.BasisType?.id === 2
  //   );
  //   return !matchingBasis;
  // });

  const PriceArrayServiceArrayOneOff = addedService.filter(service => {
    if (![2].includes(Number(service.servicetype_id))) {
      return false;
    }
    return true;
  });

  const PriceArrayOneOff = PriceArrayServiceArrayOneOff

  const totalCostOneOff1 = PriceArrayOneOff.length
    ? PriceArrayOneOff.reduce((acc, value) => acc + ((value.price + (value.price * increasePremiumFinalOneOff / 100)) || 0), 0)
    : 0;


  const totalCostOneOff = totalCostOneOff1 * (1 - discountValueFinalOneOff / 100);


  let totalCostWithDiscountOneOff = totalCostOneOff - (totalCostOneOff * ((discountOneOff || 0) / 100));


  // Check for higher discount status Apply condition
  if (Number(higherDiscountStatusOneOff) === 1) {
    totalCostWithDiscountOneOff = higherDiscountCostOneOff
  }


  function toTwoDecimalNum(num) {
    return Math.trunc(num * 100) / 100;
  }

  // console.log("totalCostWithDiscount -- ", totalCostWithDiscount);
  totalCostWithDiscountOneOff = toTwoDecimalNum(totalCostWithDiscountOneOff);


  const netVAT20AmountOneOff = PriceArrayOneOff?.length
    ?
    PriceArrayOneOff.filter((service) => service.vat_exempt === "0").reduce((acc, service) => acc + ((service.price + (service.price * increasePremiumFinalOneOff / 100)) || 0), 0)
    : 0;

  let netVAT20OneOff = netVAT20AmountOneOff - (netVAT20AmountOneOff * ((discountOneOff || 0) / 100));
  netVAT20OneOff = toTwoDecimalNum(netVAT20OneOff);




  const netNoVATAmountOneOff = PriceArrayOneOff?.length
    ?
    PriceArrayOneOff.filter((service) => service.vat_exempt === "1").reduce((acc, service) => acc + ((service.price + (service.price * increasePremiumFinalOneOff / 100)) || 0), 0)
    : 0;


  // Apply discount on netNoVAT
  let netNoVATOneOff = netNoVATAmountOneOff - (netNoVATAmountOneOff * ((discountOneOff || 0) / 100));
  netNoVATOneOff = toTwoDecimalNum(netNoVATOneOff);

  // Check for higher discount status Apply condition
  // if (netNoVATOneOff === 0 && Number(higherDiscountStatus) === 1) {
  //   netVAT20OneOff = higherDiscountCost;
  // }


  // if (netVAT20OneOff === 0 && Number(higherDiscountStatus) === 1) {
  //   netNoVATOneOff = higherDiscountCost;
  // }


  // let vatOneOff = (netVAT20OneOff * 20) / 100;
  let vatOneOff = (totalCostWithDiscountOneOff * 20) / 100;
  vatOneOff = toTwoDecimalNum(vatOneOff);



  // let totalIncludingVATAmountOneOff = netVAT20OneOff + vatOneOff + netNoVATOneOff;
  let totalIncludingVATAmountOneOff = roundNumber(totalCostWithDiscountOneOff) + roundNumber(vatOneOff);


  if (agentData && agentData?.vat_registered != undefined && agentData?.vat_registered == "NO") {
    totalIncludingVATAmountOneOff = totalCostWithDiscountOneOff;
    netVAT20OneOff = 0;
    vatOneOff = 0;
    netNoVATOneOff = 0;
  }

  const totalIncludingVATOneOff = totalIncludingVATAmountOneOff

  // console.log("totalIncludingVAT -- ", totalIncludingVAT)

  let paymentDivisorsOneOff = {
    monthly_dd: 12,
    quarterly_dd: 4,
    '100_upfront': 1,
    '50_upfront': 2,
    '100_post_completion': 1,
    manual_payment_monthly: 12,
    manual_payment_quarterly: 4,
  };


  let totalMonthlyCostOneOff = totalIncludingVATOneOff / (paymentDivisorsOneOff[paymentTermOneOff] || 1);
  let adminChargeOneOff = 0;

  let totalMonthlyCostExcludingOneOff = totalCostWithDiscountOneOff / (paymentDivisorsOneOff[paymentTermOneOff] || 1);
  // Apply extra admin charge for manual payments

  // if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {

  //   if (Number(agentConfigSetting.admin_charge) === 1) {
  //     if (paymentTermOneOff === "manual_payment_monthly") {
  //       adminChargeOneOff = Math.max((totalIncludingVATOneOff * 10) / 100, 50);
  //       totalMonthlyCostOneOff += adminChargeOneOff;
  //     } else if (paymentTermOneOff === "manual_payment_quarterly") {
  //       adminChargeOneOff = Math.max((totalIncludingVATOneOff * 10) / 100, 50);
  //       totalMonthlyCostOneOff += adminChargeOneOff;
  //     }
  //   }

  // }

  /////////////////////------ End Calculate One-Off Services-------///////////////////////////


  const paymentTermModal = (e) => {
    let { name, value } = e.target;

    if (['100_upfront', '50_upfront', '100_post_completion', 'manual_payment_monthly', 'manual_payment_quarterly'].includes(value)) {
      if (paymentTermTypeGetAgent.length > 0) {
        setPaymentTypeOfModal(paymentTermTypeGetAgent[0].value);
      }
      setShowModalPaymentTerm(true);
    }
    else if (['monthly_dd', 'quarterly_dd'].includes(value)) {
      setPaymentTypeOfModal("GoCardless");
    }
    else if (value == "") {
      setShowModalPaymentTerm(false);
      setPaymentTypeOfModal("");
    }
  }

  const paymentTermModalOneOff = (e) => {
    let { name, value } = e.target;

    if (['100_upfront', '50_upfront', '100_post_completion', 'manual_payment_monthly', 'manual_payment_quarterly'].includes(value)) {
      if (paymentTermTypeGetAgentOneOff.length > 0) {
        setPaymentTypeOfModalOneOff(paymentTermTypeGetAgentOneOff[0].value);
      }
      setShowModalPaymentTermOneOff(true);
    }
    else if (['monthly_dd', 'quarterly_dd'].includes(value)) {
      setPaymentTypeOfModalOneOff("GoCardless");
    }
    else if (value == "") {
      setShowModalPaymentTermOneOff(false);
      setPaymentTypeOfModalOneOff("");
    }
  }

  const handleCombinedMultiplier = (e, type, field) => {
    const { name, value } = e.target;
    console.log('agentConfigSetting', agentConfigSetting)
    console.log('value', value)
    console.log('type', type)
    console.log('field', field)



    // mapping between your val and object keys
    const keyMapping = {
      quarterly_dd: "quarterly_dd",
      manual_payment_monthly: "payment_type_non_dd",
      monthly_dd: "payment_type_dd",
      "100_upfront": "payment_type_upfront",
      "50_upfront": "payment_type_50_50",
      contract_type_ongoing: "contract_type_ongoing",
      contract_type_oneoff: "contract_type_oneoff",
      contract_type_payg: "contract_type_payg"
    };
    //const result = agentConfigSetting[keyMapping[value]];

    if (type === "ongoing") {
      setCmPremiumOngoing(0);
      setCmDiscountOngoing(0);
      if (field === "payment") {
        const vals = [value, contractTypeOngoing];
        const results = vals.map(v => agentConfigSetting[keyMapping[v]]);
        let adjust_value = adjust(parseFloat(results[0]), parseFloat(results[1]))
        if (adjust_value >= 0) {
          setCmPremiumOngoing(adjust_value);
        } else {
          adjust_value = Math.abs(adjust_value)
          setCmDiscountOngoing(adjust_value);
        }


      } else if (field === "contract") {
        const vals = [paymentTypeOngoing, value];
        const results = vals.map(v => agentConfigSetting[keyMapping[v]]);
        let adjust_value = adjust(parseFloat(results[0]), parseFloat(results[1]))
        if (adjust_value >= 0) {
          setCmPremiumOngoing(adjust_value);
        } else {
          adjust_value = Math.abs(adjust_value)
          setCmDiscountOngoing(adjust_value);
        }

      }
    } else if (type === "oneoff") {
      setCmPremiumOneOff(0);
      setCmDiscountOneOff(0);
      if (field === "payment") {
        const vals = [value, contractTypeOneOff];
        const results = vals.map(v => agentConfigSetting[keyMapping[v]]);
        let adjust_value = adjust(parseFloat(results[0]), parseFloat(results[1]))
        if (adjust_value >= 0) {
          setCmPremiumOneOff(adjust_value);
        } else {
          adjust_value = Math.abs(adjust_value)
          setCmDiscountOneOff(adjust_value);
        }

      } else if (field === "contract") {
        console.log('paymentTypeOneOff', paymentTypeOneOff)
        console.log('value', value)
        const vals = [paymentTypeOneOff, value];
        const results = vals.map(v => agentConfigSetting[keyMapping[v]]);
        console.log('results', results)
        let adjust_value = adjust(parseFloat(results[0]), parseFloat(results[1]))
        console.log('adjust_value', adjust_value)
        if (adjust_value >= 0) {
          setCmPremiumOneOff(adjust_value);
        } else {
          adjust_value = Math.abs(adjust_value)
          setCmDiscountOneOff(adjust_value);
        }

      }
    }
  }

  useEffect(() => {


    ///////////////-----Package Service-----/////////////////
    const updatedPackageServices = packagesServiceData && packagesServiceData?.map((service) => {
      // const basePrice = service?.price || 0;


      let basePrice = parseFloat(
        (Math.floor(
          (service?.price * (1 + increasePremiumFinal / 100) * (1 - discountValueFinal / 100)) * 100
        ) / 100).toFixed(2)
      );


      //const basePrice = parseFloat(parseFloat((service?.price + (service?.price * increasePremiumFinal / 100)) * (1 - discountValueFinal / 100)).toFixed(2));

      // const defaultBasisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
      // const matchingBasis = service?.ServiceChargeBases?.find(basis =>
      //   basis?.chargebasis_id === defaultBasisId &&
      //   basis?.ChargeBasis?.BasisType?.id === 2
      // );
      const defaultBasisId = service?.Service?.sell_chargebasis_id || service?.Service?.default_chargebasis_id;
      const matchingBasis = service?.Service?.ServiceChargeBases?.find(basis =>
        basis?.chargebasis_id === defaultBasisId &&
        basis?.ChargeBasis?.BasisType?.id === 2
      );

      let rate = null;
      let inputValueHour = null;
      let exist_price_rate = null;


      if (matchingBasis != undefined) {

        rate = ["", undefined, null].includes(matchingBasis?.rate) ? 0 : matchingBasis?.rate
        inputValueHour = ["", undefined, null].includes(matchingBasis?.inputValueHour) ? 0 : matchingBasis?.inputValueHour

        exist_price_rate = ["", undefined, null].includes(matchingBasis?.price_rate) ? 0 : matchingBasis?.price_rate
        // basePrice = service?.price || 0;
      }


      let price_afterpremimum = basePrice + (basePrice * ((premium || 0) / 100));

      // let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100)) + (basePrice * ((premium || 0) / 100));
      let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100));

      let vat_applied = "0";
      let price_aftervat = "0";
      if (service.Service.vat_exempt === "0") {
        vat_applied = "20";
        price_aftervat = basePriceWithDiscount + ((basePriceWithDiscount * 20) / 100);
      }

      // if (matchingBasis != undefined) {
      //   basePriceWithDiscount = basePrice
      // }



      return {
        ...service,
        price: basePrice,
        service_id: service.Service.id,
        package_id: packageID != null ? packageID : null,
        mode: "ongoing",
        service_type: "1",
        package_flag: "1",
        premium_applied: premium || 0,
        price_afterpremimum: price_afterpremimum,
        discount_rate: discount || 0,
        price_afterdiscount: parseFloat(basePriceWithDiscount?.toFixed(2)),
        status_discount: "1",
        vat_applied: vat_applied,
        price_aftervat: price_aftervat,
        sell_chargebasis_id: service?.Service?.sell_chargebasis_id == undefined ? service?.Service?.default_chargebasis_id : service?.Service?.sell_chargebasis_id,
        rate: rate,
        inputValueHour: inputValueHour,
        exist_price_rate: exist_price_rate
      };
    });

    setPackagesServiceHigherDiscount(updatedPackageServices);

    ///////////////-----OnGoing Service-----/////////////////
    const updatedServicesOngoing = addedService && addedService?.filter(item => [1, 3].includes(Number(item?.servicetype_id)))?.map((service) => {
      // const basePrice = service?.price || 0;

      let basePrice = parseFloat(
        (Math.floor(
          (service?.price * (1 + increasePremiumFinal / 100) * (1 - discountValueFinal / 100)) * 100
        ) / 100).toFixed(2)
      );
      // let basePrice = parseFloat(parseFloat((service?.price + (service?.price * increasePremiumFinal / 100)) * (1 - discountValueFinal / 100)).toFixed(2));


      const defaultBasisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
      const matchingBasis = service?.ServiceChargeBases?.find(basis =>
        basis?.chargebasis_id === defaultBasisId &&
        basis?.ChargeBasis?.BasisType?.id === 2
      );

      let rate = null;
      let inputValueHour = null;
      let exist_price_rate = null;


      if (matchingBasis != undefined) {
        console.log("matchingBasis", matchingBasis)
        rate = ["", undefined, null].includes(matchingBasis?.rate) ? 0 : matchingBasis?.rate
        inputValueHour = ["", undefined, null].includes(matchingBasis?.inputValueHour) ? 0 : matchingBasis?.inputValueHour

        exist_price_rate = ["", undefined, null].includes(matchingBasis?.price_rate) ? 0 : matchingBasis?.price_rate
        // basePrice = service?.price || 0;
      }

      // console.log("matchingBasis -- ", matchingBasis)




      let price_afterpremimum = basePrice + (basePrice * ((premium || 0) / 100));
      // let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100)) + (basePrice * ((premium || 0) / 100));
      let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100));

      let vat_applied = "0";
      let price_aftervat = "0";
      if (service.vat_exempt === "0") {
        vat_applied = "20";
        price_aftervat = basePriceWithDiscount + ((basePriceWithDiscount * 20) / 100);
      }


      // if (matchingBasis != undefined) {
      //   if (quoteData?.quote?.ContractPackageServices.length > 0
      //     && quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis?.service_id)?.higher_discount_status === 1
      //   ) {
      //     basePriceWithDiscount = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.approval_price || basePrice;
      //     basePrice = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.price || basePrice;

      //   } else {
      //     basePriceWithDiscount = service?.price || 0;
      //     basePrice = service?.price || 0;
      //   }

      // }


      return {
        ...service,
        price: basePrice,
        package_id: null,
        service_id: service.id,
        mode: [1, 3].includes(Number(service?.servicetype_id)) ? "ongoing" : "one-off",
        service_type: [1, 3].includes(Number(service?.servicetype_id)) ? "1" : "0",
        package_flag: "1",
        premium_applied: premium || 0,
        price_afterpremimum: price_afterpremimum,
        discount_rate: discount || 0,
        price_afterdiscount: parseFloat(basePriceWithDiscount?.toFixed(2)),
        status_discount: "1",
        vat_applied: vat_applied,
        price_aftervat: price_aftervat,
        sell_chargebasis_id: service.sell_chargebasis_id == undefined ? service.default_chargebasis_id : service.sell_chargebasis_id,
        rate: rate,
        inputValueHour: inputValueHour,
        exist_price_rate: exist_price_rate
      };
    });

    let finalOngoingPackageservices = [...updatedPackageServices, ...updatedServicesOngoing];
    setOngoingServicesHigherDiscount(finalOngoingPackageservices);


    ///////////////-----OneOff Service-----/////////////////
    const updatedServicesOneOff = addedService && addedService?.filter(item => [2].includes(Number(item?.servicetype_id)))?.map((service) => {
      // const basePrice = service?.price || 0;

      let basePrice = parseFloat(
        (Math.floor(
          (service?.price * (1 + increasePremiumFinalOneOff / 100) * (1 - discountValueFinalOneOff / 100)) * 100
        ) / 100).toFixed(2)
      );

      //  let basePrice = parseFloat(parseFloat((service?.price + (service?.price * increasePremiumFinalOneOff / 100)) * (1 - discountValueFinalOneOff / 100)).toFixed(2));

      const defaultBasisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
      const matchingBasis = service?.ServiceChargeBases?.find(basis =>
        basis?.chargebasis_id === defaultBasisId &&
        basis?.ChargeBasis?.BasisType?.id === 2
      );



      let rate = null
      let inputValueHour = null
      let exist_price_rate = null


      if (matchingBasis != undefined) {
        console.log("matchingBasis", matchingBasis)
        rate = ["", undefined, null].includes(matchingBasis?.rate) ? 0 : matchingBasis?.rate
        inputValueHour = ["", undefined, null].includes(matchingBasis?.inputValueHour) ? 0 : matchingBasis?.inputValueHour
        // basePrice = service?.price || 0;
        exist_price_rate = ["", undefined, null].includes(matchingBasis?.price_rate) ? 0 : matchingBasis?.price_rate
      }

      // console.log("matchingBasis -- ", matchingBasis)

      let price_afterpremimum = basePrice + (basePrice * ((premiumOneOff || 0) / 100));
      // let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100)) + (basePrice * ((premium || 0) / 100));
      let basePriceWithDiscount = basePrice - (basePrice * ((discountOneOff || 0) / 100));

      let vat_applied = "0";
      let price_aftervat = "0";
      if (service.vat_exempt === "0") {
        vat_applied = "20";
        price_aftervat = basePriceWithDiscount + ((basePriceWithDiscount * 20) / 100);
      }


      // if (matchingBasis != undefined) {
      //   if (quoteData?.quote?.ContractPackageServices.length > 0
      //     && quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis?.service_id)?.higher_discount_status === 1
      //   ) {
      //     basePriceWithDiscount = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.approval_price || basePrice;
      //     basePrice = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.price || basePrice;

      //   } else {
      //     basePriceWithDiscount = service?.price || 0;
      //     basePrice = service?.price || 0;
      //   }

      // }

      return {
        ...service,
        price: basePrice,
        package_id: null,
        service_id: service.id,
        mode: [1, 3].includes(Number(service?.servicetype_id)) ? "ongoing" : "one-off",
        service_type: [1, 3].includes(Number(service?.servicetype_id)) ? "1" : "0",
        package_flag: "1",
        premium_applied: premiumOneOff || 0,
        price_afterpremimum: price_afterpremimum,
        discount_rate: discountOneOff || 0,
        price_afterdiscount: parseFloat(basePriceWithDiscount?.toFixed(2)),
        status_discount: "1",
        vat_applied: vat_applied,
        price_aftervat: price_aftervat,
        sell_chargebasis_id: service.sell_chargebasis_id == undefined ? service.default_chargebasis_id : service.sell_chargebasis_id,
        rate: rate,
        inputValueHour: inputValueHour,
        exist_price_rate: exist_price_rate
      };
    });
    setOneoffServicesHigherDiscount(updatedServicesOneOff);


  }, [addedService, discountOneOff, discount, packagesServiceData, packagesChanges]);

  const submitReqHigherDiscount = async (e) => {
    // if (parseFloat(desiredHigherDiscount || 0) <= parseFloat(currentPackageDiscount)) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Warning..",
    //     text: "Please Enter Higher Discount Than Current Discount",
    //     timer: 2000,
    //     timerProgressBar: true,
    //   });
    //   return;
    // }

    // if (errorDiscount == true) {
    //   return;
    // }




    if (errorDiscountValue == true) {
      return;
    }

    if (['', null, undefined].includes(emailAuthorised)) {

      Swal.fire({
        icon: "warning",
        title: "Warning..",
        text: "Please  Select Approval Email",
        timer: 5000,
        timerProgressBar: true,
      });
      return;

    }


    if (!['', null, undefined].includes(packageID) && packagesChanges === false && isServicediscount.current == false) {
      if (errorDiscountValue == true) {
        return;
      }
      if (parseFloat(desiredPriceApproval) === 0) {
        Swal.fire({
          icon: "warning",
          title: "Warning..",
          text: "Please Enter Desired Price Approval",
          timer: 5000,
          timerProgressBar: true,
        });
        return;
      }
    }

    let errorShow = Object.values(approvalErrors).every(value => value === '');

    if (!errorShow) {
      return
    }






    // const services = contractPackageServicesAll || [];
    const services = showServiceHigherDiscount == "ongoing" ? ongoingServicesHigherDiscount : showServiceHigherDiscount == "oneoff" ? oneoffServicesHigherDiscount : [];
    const getChargeBasisId = (item) =>
      item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

    const isExcluded = (item) => {
      const chargeBasisId = getChargeBasisId(item);

      const serviceChargeBases =
        item?.ServiceChargeBases ||
        item?.Service?.ServiceChargeBases ||
        [];
      return chargeBasisId && serviceChargeBases?.some(
        (cb) =>
          cb.ChargeBasis?.id === chargeBasisId &&
          (cb.ChargeBasis?.BasisType?.id === 2 && parseFloat(item?.price) === 0)
      );
    };

    // 👉 1. Calculate current_cost (based on item.price)
    const current_cost = services.reduce((sum, item) => {
      if (isExcluded(item)) return sum;
      return sum + (parseFloat(item.price) || 0);
    }, 0).toFixed(2);

    // 👉 2. Calculate cost (based on approval_price or price_afterdiscount)
    const cost = services.reduce((sum, item) => {
      if (isExcluded(item)) return sum;
      const price =
        item.approval_price !== undefined && item.approval_price !== null
          ? parseFloat(item.approval_price || 0)
          : parseFloat(item.price_afterdiscount || 0);
      return sum + price;
    }, 0).toFixed(2);

    const discount_price_cost = services.reduce((sum, item) => {
      if (isExcluded(item)) return sum;
      return sum + (parseFloat(item.price_afterdiscount) || 0);
    }, 0).toFixed(2);



    // 👉 3. Get current_discount from first non-excluded item
    const current_discount = services.find((item) => {
      return !isExcluded(item) && item.discount_rate !== undefined;
    })?.discount_rate || 0;

    // 👉 4. Calculate discount percentage
    const discount1 =
      parseFloat(current_cost) && parseFloat(cost)
        ? (((parseFloat(current_cost) - parseFloat(cost)) / parseFloat(current_cost)) * 100).toFixed(2)
        : "0.00";

    let ongoingServicesHigherDiscountData = ongoingServicesHigherDiscount?.filter(val => {
      const basisId =
        val?.sell_chargebasis_id ||
        val?.Service?.default_chargebasis_id;

      const serviceChargeBases =
        val?.ServiceChargeBases ||
        val?.Service?.ServiceChargeBases ||
        [];

      const matched = serviceChargeBases?.find(
        chargeBase =>
          chargeBase?.ChargeBasis?.id === basisId &&
          chargeBase?.ChargeBasis?.BasisType?.id === 2
      );
      if (matched && parseFloat(val?.price) === 0) {
        return false;
      }
      return true;
    });


    let oneoffServicesHigherDiscountData = oneoffServicesHigherDiscount?.filter((val, index) => {
      const basisId = val?.sell_chargebasis_id || val?.default_chargebasis_id;
      const matched = val?.ServiceChargeBases?.find(
        chargeBase =>
          chargeBase?.ChargeBasis?.id === basisId &&
          chargeBase?.ChargeBasis?.BasisType?.id === 2
      );

      if (matched && parseFloat(val?.price) === 0) {
        return false;
      }
      return true;
    });



    if (!['', null, undefined].includes(packageID) && packagesChanges === false && isServicediscount.current == false) {
      // Package
    } else {
      // Service
      if (parseFloat(discount_price_cost) === parseFloat(cost)) {
        // confirm box swerart
        Swal.fire({
          title: "Approval Request Cannot Be Sent",
          text: "No changes have been made in the Higher Discount Approver popup. Please modify at least one value before selecting an approver and sending the approval request.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          //cancelButtonColor: "#d33",
          showCancelButton: false,
          confirmButtonText: "Ok",
        })
        return;
      }

    }


    let req = {
      type: 2,
      contract_id: Number(QuoteId),
      agent_id: agent_id,
      user_id: userDetails.id,
      client_id: clientid,
      email: emailAuthorised,
      current_discount: current_discount,
      current_cost: current_cost,
      discount: discount1 || 0,
      cost: cost,
      discount_price_cost: discount_price_cost,
      //contractPackageServicesAll: showServiceHigherDiscount == "ongoing" ? ongoingServicesHigherDiscount : showServiceHigherDiscount == "oneoff" ? oneoffServicesHigherDiscount : [],
      contractPackageServicesAll: showServiceHigherDiscount == "ongoing" ? ongoingServicesHigherDiscountData : showServiceHigherDiscount == "oneoff" ? oneoffServicesHigherDiscountData : [],
      reason_higher_discount: reasonHigherDiscount,
      request_higher_discount_ongoing: showServiceHigherDiscount == "ongoing" ? "1" : "0",
      request_higher_discount_oneoff: showServiceHigherDiscount == "oneoff" ? "1" : "0",
    }

    if (!['', null, undefined].includes(packageID) && packagesChanges === false && isServicediscount.current == false) {
      req = {
        type: 1,
        contract_id: Number(QuoteId),
        agent_id: agent_id,
        user_id: userDetails.id,
        client_id: clientid,
        email: emailAuthorised,
        package_id: packageID,
        current_discount: discount || 0,
        current_cost: totalCostWithDiscount,
        discount: desiredHigherDiscount || 0,
        cost: parseFloat(desiredPriceApproval),
        discount_price_cost: discount_price_cost,
        reason_higher_discount: reasonHigherDiscount,
        request_higher_discount_ongoing: "1",
        request_higher_discount_oneoff: "0",
      }
    }


    setIsLoading(true)
    await handleSubmit1()
    setRequestHigherDiscountStatus(true)


    await dispatch(requestHigherDiscount(req)).unwrap()
      .then(async (res) => {

        if (res.status) {
          setDesiredHigherDiscount(0);
          setDesiredPriceApproval(0);
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Higher Discount Request Sent Successfully",
            timer: 4000,
            timerProgressBar: true,
          }).then(() => {
            setShowModal(false);
            //getQuote();
            sessionStorage.clear();
            navigate("/admin/contracts/contracts-dashboard");
          });

        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            timer: 3000,
            timerProgressBar: true,
          });
        }

      })
      .catch((err) => {
        console.log("Error", err)
      }).finally(() => {
        setIsLoading(false);
      });
  }


  const handleSubmit = async () => {


    // console.log("handleSubmit called", formData.attachments);

    // if (formData.attachments && formData.attachments.length > 0) {
    //   let reqAttached = { agent_id, agent_id, id: Number(QuoteId), formData: formData, type: 'contract' };
    //   await upload_contract_attachment(reqAttached)
    // }

    let errorService = null;
    let errorChargeBasis = null;


    addedService?.forEach(service => {
      const defaultId = service?.default_chargebasis_id;
      const sellId = service?.sell_chargebasis_id;

      const cb = service?.ServiceChargeBases?.find(cb =>
        [defaultId, sellId].includes(cb?.chargebasis_id) &&
        Number(cb?.price_rate) === 0
      );



      if (cb && cb?.ChargeBasis?.BasisType?.id === 2) {
        errorService = service;
        errorChargeBasis = cb;
      }
    });


    if (errorService && errorChargeBasis) {

      const errorKey = `${errorService.id}_${errorChargeBasis.id}`;

      setRateError(prev => ({
        ...prev,
        [errorKey]:
          [1, 2].includes(Number(userDetails?.is_role))
            ? (
              <span>
                Default rate is not set up. <br />
                <span
                  className="text-primary text-decoration-underline"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/admin/pricing/all-services")}
                >
                  Click here
                </span> to set this up.
              </span>
            )
            : (
              <span>
                Setup required. Please contact <br />
                your administrator.
              </span>
            )
      }));

      return;
    }

    const hasError = Object.values(rateError).some(
      error => error !== "" && error !== null && error !== undefined
    );

    if (hasError) {
      return;
    }

    if (addedService?.length == 0 && packageID == null) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please select at least one service or package",
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    if (errorDiscount == true) {
      return;
    }

    if ((addedService?.find((item) => [1, 3].includes(Number(item?.servicetype_id))) != undefined || packagesServiceData?.length > 0) && (["", null, undefined].includes(paymentTypeOfModal) && ["", null, undefined].includes(paymentTerm))) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please Select Ongoing Payment Types ",
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    if (addedService?.find((item) => [2].includes(Number(item?.servicetype_id))) != undefined && (["", null, undefined].includes(paymentTypeOfModalOneOff) && ["", null, undefined].includes(paymentTermOneOff))) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please Select One-Off Payment Types ",
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }



    const updatedPackageServices = packagesServiceData && packagesServiceData?.map((service) => {
      // const basePrice = service?.price || 0;

      let basePrice = parseFloat(
        (Math.floor(
          (service?.price * (1 + increasePremiumFinal / 100) * (1 - discountValueFinal / 100)) * 100
        ) / 100).toFixed(2)
      );
      //let basePrice = parseFloat(parseFloat((service?.price + (service?.price * increasePremiumFinal / 100)) * (1 - discountValueFinal / 100)).toFixed(2));


      // const defaultBasisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
      // const matchingBasis = service?.ServiceChargeBases?.find(basis =>
      //   basis?.chargebasis_id === defaultBasisId &&
      //   basis?.ChargeBasis?.BasisType?.id === 2
      // );

      const defaultBasisId = service?.Service?.sell_chargebasis_id || service?.Service?.default_chargebasis_id;
      const matchingBasis = service?.Service?.ServiceChargeBases?.find(basis =>
        basis?.chargebasis_id === defaultBasisId &&
        basis?.ChargeBasis?.BasisType?.id === 2
      );

      let rate = null;
      let inputValueHour = null;
      let exist_price_rate = null;


      if (matchingBasis != undefined) {

        rate = ["", undefined, null].includes(matchingBasis?.rate) ? 0 : matchingBasis?.rate
        inputValueHour = ["", undefined, null].includes(matchingBasis?.inputValueHour) ? 0 : matchingBasis?.inputValueHour

        exist_price_rate = ["", undefined, null].includes(matchingBasis?.price_rate) ? 0 : matchingBasis?.price_rate
        // basePrice = service?.price || 0;
      }


      let price_afterpremimum = basePrice + (basePrice * ((premium || 0) / 100));

      // let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100)) + (basePrice * ((premium || 0) / 100));
      let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100));

      let vat_applied = "0";
      let price_aftervat = "0";
      if (service.Service.vat_exempt === "0") {
        vat_applied = "20";
        price_aftervat = basePriceWithDiscount + ((basePriceWithDiscount * 20) / 100);
      }

      // if (matchingBasis != undefined) {
      //   basePriceWithDiscount = basePrice
      // }



      return {
        ...service,
        price: basePrice,
        service_id: service.Service.id,
        package_id: packageID != null ? packageID : null,
        mode: "ongoing",
        service_type: "1",
        package_flag: "1",
        premium_applied: premium || 0,
        price_afterpremimum: price_afterpremimum,
        discount_rate: discount || 0,
        price_afterdiscount: basePriceWithDiscount,
        status_discount: "1",
        vat_applied: vat_applied,
        price_aftervat: price_aftervat,
        sell_chargebasis_id: service?.Service?.sell_chargebasis_id == undefined ? service?.Service?.default_chargebasis_id : service?.Service?.sell_chargebasis_id,
        rate: rate,
        inputValueHour: inputValueHour,
        exist_price_rate: exist_price_rate
      };
    });

    //const updatedServices = addedService && addedService.map((service) => {
    const updatedServicesOngoing = addedService && addedService?.filter(item => [1, 3].includes(Number(item?.servicetype_id)))?.map((service) => {
      // const basePrice = service?.price || 0;

      let basePrice = parseFloat(
        (Math.floor(
          (service?.price * (1 + increasePremiumFinal / 100) * (1 - discountValueFinal / 100)) * 100
        ) / 100).toFixed(2)
      );

      //let basePrice = parseFloat(parseFloat((service?.price + (service?.price * increasePremiumFinal / 100)) * (1 - discountValueFinal / 100)).toFixed(2));

      const defaultBasisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
      const matchingBasis = service?.ServiceChargeBases?.find(basis =>
        basis?.chargebasis_id === defaultBasisId &&
        basis?.ChargeBasis?.BasisType?.id === 2
      );

      let rate = null;
      let inputValueHour = null;
      let exist_price_rate = null;


      if (matchingBasis != undefined) {

        rate = ["", undefined, null].includes(matchingBasis?.rate) ? 0 : matchingBasis?.rate
        inputValueHour = ["", undefined, null].includes(matchingBasis?.inputValueHour) ? 0 : matchingBasis?.inputValueHour

        exist_price_rate = ["", undefined, null].includes(matchingBasis?.price_rate) ? 0 : matchingBasis?.price_rate
        // basePrice = service?.price || 0;
      }




      let price_afterpremimum = basePrice + (basePrice * ((premium || 0) / 100));
      // let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100)) + (basePrice * ((premium || 0) / 100));
      let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100));

      let vat_applied = "0";
      let price_aftervat = "0";
      if (service.vat_exempt === "0") {
        vat_applied = "20";
        price_aftervat = basePriceWithDiscount + ((basePriceWithDiscount * 20) / 100);
      }


      // if (matchingBasis != undefined) {
      //   if (quoteData?.quote?.ContractPackageServices.length > 0
      //     && quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis?.service_id)?.higher_discount_status === 1
      //   ) {
      //     basePriceWithDiscount = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.approval_price || basePrice;
      //     basePrice = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.price || basePrice;

      //   } else {
      //     basePriceWithDiscount = service?.price || 0;
      //     basePrice = service?.price || 0;
      //   }

      // }


      return {
        ...service,
        price: basePrice,
        package_id: null,
        service_id: service.id,
        mode: [1, 3].includes(Number(service?.servicetype_id)) ? "ongoing" : "one-off",
        service_type: [1, 3].includes(Number(service?.servicetype_id)) ? "1" : "0",
        package_flag: "1",
        premium_applied: premium || 0,
        price_afterpremimum: price_afterpremimum,
        discount_rate: discount || 0,
        price_afterdiscount: basePriceWithDiscount,
        status_discount: "1",
        vat_applied: vat_applied,
        price_aftervat: price_aftervat,
        sell_chargebasis_id: service.sell_chargebasis_id == undefined ? service.default_chargebasis_id : service.sell_chargebasis_id,
        rate: rate,
        inputValueHour: inputValueHour,
        exist_price_rate: exist_price_rate
      };
    });


    const updatedServicesOneOff = addedService && addedService?.filter(item => [2].includes(Number(item?.servicetype_id)))?.map((service) => {
      // const basePrice = service?.price || 0;

      let basePrice = parseFloat(
        (Math.floor(
          (service?.price * (1 + increasePremiumFinalOneOff / 100) * (1 - discountValueFinalOneOff / 100)) * 100
        ) / 100).toFixed(2)
      );
      //let basePrice = parseFloat(parseFloat((service?.price + (service?.price * increasePremiumFinalOneOff / 100)) * (1 - discountValueFinalOneOff / 100)).toFixed(2));

      const defaultBasisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
      const matchingBasis = service?.ServiceChargeBases?.find(basis =>
        basis?.chargebasis_id === defaultBasisId &&
        basis?.ChargeBasis?.BasisType?.id === 2
      );



      let rate = null
      let inputValueHour = null
      let exist_price_rate = null


      if (matchingBasis != undefined) {
        console.log("matchingBasis", matchingBasis)
        rate = ["", undefined, null].includes(matchingBasis?.rate) ? 0 : matchingBasis?.rate
        inputValueHour = ["", undefined, null].includes(matchingBasis?.inputValueHour) ? 0 : matchingBasis?.inputValueHour
        // basePrice = service?.price || 0;
        exist_price_rate = ["", undefined, null].includes(matchingBasis?.price_rate) ? 0 : matchingBasis?.price_rate
      }

      // console.log("matchingBasis -- ", matchingBasis)

      let price_afterpremimum = basePrice + (basePrice * ((premiumOneOff || 0) / 100));
      // let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100)) + (basePrice * ((premium || 0) / 100));
      let basePriceWithDiscount = basePrice - (basePrice * ((discountOneOff || 0) / 100));

      let vat_applied = "0";
      let price_aftervat = "0";
      if (service.vat_exempt === "0") {
        vat_applied = "20";
        price_aftervat = basePriceWithDiscount + ((basePriceWithDiscount * 20) / 100);
      }


      // if (matchingBasis != undefined) {
      //   if (quoteData?.quote?.ContractPackageServices.length > 0
      //     && quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis?.service_id)?.higher_discount_status === 1
      //   ) {
      //     basePriceWithDiscount = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.approval_price || basePrice;
      //     basePrice = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.price || basePrice;

      //   } else {
      //     basePriceWithDiscount = service?.price || 0;
      //     basePrice = service?.price || 0;
      //   }

      // }


      return {
        ...service,
        price: basePrice,
        package_id: null,
        service_id: service.id,
        mode: [1, 3].includes(Number(service?.servicetype_id)) ? "ongoing" : "one-off",
        service_type: [1, 3].includes(Number(service?.servicetype_id)) ? "1" : "0",
        package_flag: "1",
        premium_applied: premiumOneOff || 0,
        price_afterpremimum: price_afterpremimum,
        discount_rate: discountOneOff || 0,
        price_afterdiscount: basePriceWithDiscount,
        status_discount: "1",
        vat_applied: vat_applied,
        price_aftervat: price_aftervat,
        sell_chargebasis_id: service.sell_chargebasis_id == undefined ? service.default_chargebasis_id : service.sell_chargebasis_id,
        rate: rate,
        inputValueHour: inputValueHour,
        exist_price_rate: exist_price_rate
      };
    });


    let finalquotepackageservices = [...updatedPackageServices, ...updatedServicesOngoing, ...updatedServicesOneOff];

    const data = {
      ...formData,
    };

    // console.log("paymentTerm -- ", paymentTerm)
    // console.log("paymentTermOneOff -- ", paymentTermOneOff)
    // console.log("paymentTypeOfModal -- ", paymentTypeOfModal)
    // console.log("paymentTypeOfModalOneOff -- ", paymentTypeOfModalOneOff)



    // Payment Frequency
    const paymentDivisorsFreguencyOngoing = {
      monthly_dd: 'Monthly',
      quarterly_dd: 'Quarterly',
      '100_upfront': 'Yearly',
      '50_upfront': 'Yearly',
      '100_post_completion': 'Yearly',
      manual_payment_monthly: "Monthly",
      manual_payment_quarterly: 'Quarterly',
    };
    let payment_frequency = (paymentDivisorsFreguencyOngoing[paymentTerm])

    let payment_frequencyOneOff = (paymentDivisorsFreguencyOngoing[paymentTermOneOff])

    const req = {
      quotepackageservices: finalquotepackageservices,
      id: Number(QuoteId),
      step: 2,
      packageID: packageID,
      agent_id: agent_id,
      quoteEnterDefaultValue: quoteEnterDefaultValue.filter((item) => item.basistypes_id != 2),
      quoteIndividualSetValue: Number(selfAssessmentCount) > 0 ? quoteIndividualSetValue : [],
      individuals: Number(selfAssessmentCount) > 0 ? individuals : [],


      // Ongoing Services
      discount_ongoing: discount || 0,
      premium_ongoing: premium || 0,
      status_discount_ongoing: "1",
      payment_term_ongoing: paymentTerm || null,
      total_including_ongoing: totalIncludingVAT || null,
      total_monthly_ongoing: totalMonthlyCost || null,
      payment_type_ongoing: paymentTypeOfModal || null,
      payment_frequency_ongoing: payment_frequency || null,
      net20vat_ongoing: netVAT20 || null,
      vat_ongoing: vat || null,
      netnovat_ongoing: netNoVAT || null,
      admin_charge_ongoing: adminChargeAmount,
      admin_charge_status: adminCharge > 0 ? "1" : "0",
      total_monthly_excluding_ongoing: totalMonthlyCostExcluding || null,
      // payment_term_description: paymentTermDescription,
      // package_description: packageDescription,
      payment_term_description: ["<p><br></p>"].includes(formData.paymentTermDescription) ? null : formData.paymentTermDescription,
      package_description: ["<p><br></p>"].includes(formData.packageDescription) ? null : formData.packageDescription,
      package_change_status: packagesChanges == true ? "1" : "0",

      // One-Off Services
      discount_oneoff: discountOneOff || 0,
      premium_oneoff: premiumOneOff || 0,
      payment_term_oneoff: paymentTermOneOff || null,
      total_including_oneoff: totalIncludingVATOneOff || null,
      total_monthly_oneoff: totalMonthlyCostOneOff || null,
      payment_type_oneoff: paymentTypeOfModalOneOff || null,
      payment_frequency_oneoff: payment_frequencyOneOff || null,
      net20vat_oneoff: netVAT20OneOff || null,
      vat_oneoff: vatOneOff || null,
      netnovat_oneoff: netNoVATOneOff || null,
      total_monthly_excluding_oneoff: totalMonthlyCostExcludingOneOff || null,


      // selectedService: selectedService,
      // recurring: Number(serviceTypeForQuote) == 1 ? "1" : "0",
      // one_off: Number(serviceTypeForQuote) == 2 ? "1" : "0",

      recurring: addedService?.find(item => [1, 3].includes(Number(item?.servicetype_id))) != undefined || packagesServiceData?.length > 0 ? "1" : "0",
      one_off: addedService?.find(item => [2].includes(Number(item?.servicetype_id))) != undefined ? "1" : "0",

      // extra Input
      // attachment_status:showAttachment,
      show_discount: showDiscount,
      show_price: showPrice,
      self_assessment_need_status: ["", undefined, null, "0"].includes(selfAssessmentCount) ? "0" : "1",
      self_assessment_need_input: selfAssessmentCount == "" ? 0 : selfAssessmentCount,
      // contract_service_type: serviceTypeForQuote,
      contract_service_type: "1",

      // Comlexity and Risk
      complexity_label: selectedLabelComplexity,
      complexity_premium: complexityValue,
      risk_label: selectedLabelRisk,
      risk_premium: riskValue,

      quality_data_label: selectedLabelQualityData,
      quality_data_premium: qualityDataValue,
      frequency_meeting_label: selectedLabelFrequencyMeeting,
      frequency_meeting_premium: frequencyMeetingValue,
      access_seniors_label: selectedLabelAccessSenior,
      access_seniors_premium: accessSeniorValue,

      cmPremiumOngoing: cmPremiumOngoing,
      cmPremiumOneOff: cmPremiumOneOff,
      cmDiscountOngoing: cmDiscountOngoing,
      cmDiscountOneOff: cmDiscountOneOff,

      contractTypeOngoing: contractTypeOngoing,
      contractTypeOneOff: contractTypeOneOff,

      is_effected: "0",

      backupQuoteId: backupQuoteId
    }

    console.log("req", req);
    //return



    sessionStorage.setItem("contract_id", backupQuoteId);
    await dispatch(createContract(req)).unwrap()
      .then((res) => {

        if (res.status) {
          let stepStatus = false;
          // if (updatedPackageServices.length > 0) {
          //   stepStatus = true;
          // }

          if (Number(res.contractid) > 0) {
            sessionStorage.setItem("contract_id", res.contractid);
            nextStep(stepStatus, { contractid: res.contractid })
          }

          // nextStep(stepStatus);
        }
        else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }).catch((err) => {
        console.log("err", err);
      })
  }

  const handleSubmit1 = async () => {

    if (addedService?.length == 0 && packageID == null) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please select at least one service or package",
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }


    // if (errorDiscount == true) {
    //   return;
    // }



    // if ((addedService?.find((item) => [1, 3].includes(Number(item?.servicetype_id))) != undefined || packagesServiceData?.length > 0) && (paymentTypeOfModal == "" && paymentTerm == "")) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Warning",
    //     text: "Please Select Ongoing Payment Types ",
    //     timer: 3000,
    //     timerProgressBar: true,
    //   });
    //   return;
    // }

    // if (addedService?.find((item) => [2].includes(Number(item?.servicetype_id))) != undefined && (paymentTypeOfModalOneOff == "" && paymentTermOneOff == "")) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Warning",
    //     text: "Please Select One-Off Payment Types ",
    //     timer: 3000,
    //     timerProgressBar: true,
    //   });
    //   return;
    // }

    const updatedPackageServices = packagesServiceData && packagesServiceData?.map((service) => {
      // const basePrice = service?.price || 0;

      let basePrice = parseFloat(
        (Math.floor(
          (service?.price * (1 + increasePremiumFinal / 100) * (1 - discountValueFinal / 100)) * 100
        ) / 100).toFixed(2)
      );
      // const basePrice = parseFloat(parseFloat((service?.price + (service?.price * increasePremiumFinal / 100)) * (1 - discountValueFinal / 100)).toFixed(2));

      // const defaultBasisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
      // const matchingBasis = service?.ServiceChargeBases?.find(basis =>
      //   basis?.chargebasis_id === defaultBasisId &&
      //   basis?.ChargeBasis?.BasisType?.id === 2
      // );

      const defaultBasisId = service?.Service?.sell_chargebasis_id || service?.Service?.default_chargebasis_id;
      const matchingBasis = service?.Service?.ServiceChargeBases?.find(basis =>
        basis?.chargebasis_id === defaultBasisId &&
        basis?.ChargeBasis?.BasisType?.id === 2
      );

      let rate = null;
      let inputValueHour = null;
      let exist_price_rate = null;


      if (matchingBasis != undefined) {

        rate = ["", undefined, null].includes(matchingBasis?.rate) ? 0 : matchingBasis?.rate
        inputValueHour = ["", undefined, null].includes(matchingBasis?.inputValueHour) ? 0 : matchingBasis?.inputValueHour

        exist_price_rate = ["", undefined, null].includes(matchingBasis?.price_rate) ? 0 : matchingBasis?.price_rate
        // basePrice = service?.price || 0;
      }


      let price_afterpremimum = basePrice + (basePrice * ((premium || 0) / 100));

      // let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100)) + (basePrice * ((premium || 0) / 100));
      let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100));

      let vat_applied = "0";
      let price_aftervat = "0";
      if (service.Service.vat_exempt === "0") {
        vat_applied = "20";
        price_aftervat = basePriceWithDiscount + ((basePriceWithDiscount * 20) / 100);
      }

      // if (matchingBasis != undefined) {
      //   basePriceWithDiscount = basePrice
      // }



      return {
        ...service,
        price: basePrice,
        service_id: service.Service.id,
        package_id: packageID != null ? packageID : null,
        mode: "ongoing",
        service_type: "1",
        package_flag: "1",
        premium_applied: premium || 0,
        price_afterpremimum: price_afterpremimum,
        discount_rate: discount || 0,
        price_afterdiscount: basePriceWithDiscount,
        status_discount: "1",
        vat_applied: vat_applied,
        price_aftervat: price_aftervat,
        sell_chargebasis_id: service?.Service?.sell_chargebasis_id == undefined ? service?.Service?.default_chargebasis_id : service?.Service?.sell_chargebasis_id,
        rate: rate,
        inputValueHour: inputValueHour,
        exist_price_rate: exist_price_rate
      };
    });


    //const updatedServices = addedService && addedService.map((service) => {
    const updatedServicesOngoing = addedService && addedService?.filter(item => [1, 3].includes(Number(item?.servicetype_id)))?.map((service) => {
      // const basePrice = service?.price || 0;

      let basePrice = parseFloat(
        (Math.floor(
          (service?.price * (1 + increasePremiumFinal / 100) * (1 - discountValueFinal / 100)) * 100
        ) / 100).toFixed(2)
      );
      //let basePrice = parseFloat(parseFloat((service?.price + (service?.price * increasePremiumFinal / 100)) * (1 - discountValueFinal / 100)).toFixed(2));
      const defaultBasisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
      const matchingBasis = service?.ServiceChargeBases?.find(basis =>
        basis?.chargebasis_id === defaultBasisId &&
        basis?.ChargeBasis?.BasisType?.id === 2
      );

      let rate = null;
      let inputValueHour = null;
      let exist_price_rate = null;


      if (matchingBasis != undefined) {
        console.log("matchingBasis", matchingBasis)
        rate = ["", undefined, null].includes(matchingBasis?.rate) ? 0 : matchingBasis?.rate
        inputValueHour = ["", undefined, null].includes(matchingBasis?.inputValueHour) ? 0 : matchingBasis?.inputValueHour

        exist_price_rate = ["", undefined, null].includes(matchingBasis?.price_rate) ? 0 : matchingBasis?.price_rate
        // basePrice = service?.price || 0;
      }

      // console.log("matchingBasis -- ", matchingBasis)




      let price_afterpremimum = basePrice + (basePrice * ((premium || 0) / 100));
      // let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100)) + (basePrice * ((premium || 0) / 100));
      let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100));

      let vat_applied = "0";
      let price_aftervat = "0";
      if (service.vat_exempt === "0") {
        vat_applied = "20";
        price_aftervat = basePriceWithDiscount + ((basePriceWithDiscount * 20) / 100);
      }


      // if (matchingBasis != undefined) {
      //   if (quoteData?.quote?.ContractPackageServices.length > 0
      //     && quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis?.service_id)?.higher_discount_status === 1
      //   ) {
      //     basePriceWithDiscount = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.approval_price || basePrice;
      //     basePrice = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.price || basePrice;

      //   } else {
      //     basePriceWithDiscount = service?.price || 0;
      //     basePrice = service?.price || 0;
      //   }

      // }


      return {
        ...service,
        price: basePrice,
        package_id: null,
        service_id: service.id,
        mode: [1, 3].includes(Number(service?.servicetype_id)) ? "ongoing" : "one-off",
        service_type: [1, 3].includes(Number(service?.servicetype_id)) ? "1" : "0",
        package_flag: "1",
        premium_applied: premium || 0,
        price_afterpremimum: price_afterpremimum,
        discount_rate: discount || 0,
        price_afterdiscount: basePriceWithDiscount,
        status_discount: "1",
        vat_applied: vat_applied,
        price_aftervat: price_aftervat,
        sell_chargebasis_id: service.sell_chargebasis_id == undefined ? service.default_chargebasis_id : service.sell_chargebasis_id,
        rate: rate,
        inputValueHour: inputValueHour,
        exist_price_rate: exist_price_rate
      };
    });


    const updatedServicesOneOff = addedService && addedService?.filter(item => [2].includes(Number(item?.servicetype_id)))?.map((service) => {


      let basePrice = parseFloat(
        (Math.floor(
          (service?.price * (1 + increasePremiumFinalOneOff / 100) * (1 - discountValueFinalOneOff / 100)) * 100
        ) / 100).toFixed(2)
      );

      // let basePrice = parseFloat(parseFloat((service?.price + (service?.price * increasePremiumFinalOneOff / 100)) * (1 - discountValueFinalOneOff / 100)).toFixed(2));
      const defaultBasisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
      const matchingBasis = service?.ServiceChargeBases?.find(basis =>
        basis?.chargebasis_id === defaultBasisId &&
        basis?.ChargeBasis?.BasisType?.id === 2
      );



      let rate = null
      let inputValueHour = null
      let exist_price_rate = null


      if (matchingBasis != undefined) {
        console.log("matchingBasis", matchingBasis)
        rate = ["", undefined, null].includes(matchingBasis?.rate) ? 0 : matchingBasis?.rate
        inputValueHour = ["", undefined, null].includes(matchingBasis?.inputValueHour) ? 0 : matchingBasis?.inputValueHour
        // basePrice = service?.price || 0;
        exist_price_rate = ["", undefined, null].includes(matchingBasis?.price_rate) ? 0 : matchingBasis?.price_rate
      }

      // console.log("matchingBasis -- ", matchingBasis)

      let price_afterpremimum = basePrice + (basePrice * ((premiumOneOff || 0) / 100));
      // let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100)) + (basePrice * ((premium || 0) / 100));
      let basePriceWithDiscount = basePrice - (basePrice * ((discountOneOff || 0) / 100));

      let vat_applied = "0";
      let price_aftervat = "0";
      if (service.vat_exempt === "0") {
        vat_applied = "20";
        price_aftervat = basePriceWithDiscount + ((basePriceWithDiscount * 20) / 100);
      }


      // if (matchingBasis != undefined) {
      //   if (quoteData?.quote?.ContractPackageServices.length > 0
      //     && quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis?.service_id)?.higher_discount_status === 1
      //   ) {
      //     basePriceWithDiscount = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.approval_price || basePrice;
      //     basePrice = quoteData?.quote?.ContractPackageServices.find(service => service?.service_id === matchingBasis.service_id)?.price || basePrice;

      //   } else {
      //     basePriceWithDiscount = service?.price || 0;
      //     basePrice = service?.price || 0;
      //   }

      // }


      return {
        ...service,
        price: basePrice,
        package_id: null,
        service_id: service.id,
        mode: [1, 3].includes(Number(service?.servicetype_id)) ? "ongoing" : "one-off",
        service_type: [1, 3].includes(Number(service?.servicetype_id)) ? "1" : "0",
        package_flag: "1",
        premium_applied: premiumOneOff || 0,
        price_afterpremimum: price_afterpremimum,
        discount_rate: discountOneOff || 0,
        price_afterdiscount: basePriceWithDiscount,
        status_discount: "1",
        vat_applied: vat_applied,
        price_aftervat: price_aftervat,
        sell_chargebasis_id: service.sell_chargebasis_id == undefined ? service.default_chargebasis_id : service.sell_chargebasis_id,
        rate: rate,
        inputValueHour: inputValueHour,
        exist_price_rate: exist_price_rate
      };
    });


    let finalquotepackageservices = [...updatedPackageServices, ...updatedServicesOngoing, ...updatedServicesOneOff];

    const data = {
      ...formData,
    };

    const paymentDivisorsFreguencyOngoing = {
      monthly_dd: 'Monthly',
      quarterly_dd: 'Quarterly',
      '100_upfront': 'Yearly',
      '50_upfront': 'Yearly',
      '100_post_completion': 'Yearly',
      manual_payment_monthly: "Monthly",
      manual_payment_quarterly: 'Quarterly',
    };
    let payment_frequency = (paymentDivisorsFreguencyOngoing[paymentTerm])

    let payment_frequencyOneOff = (paymentDivisorsFreguencyOngoing[paymentTermOneOff])


    const req = {
      quotepackageservices: finalquotepackageservices,
      id: Number(QuoteId),
      step: 2,
      packageID: packageID,
      agent_id: agent_id,
      quoteEnterDefaultValue: quoteEnterDefaultValue.filter((item) => item.basistypes_id != 2),
      quoteIndividualSetValue: Number(selfAssessmentCount) > 0 ? quoteIndividualSetValue : [],
      individuals: Number(selfAssessmentCount) > 0 ? individuals : [],


      // Ongoing Services
      discount_ongoing: discount || 0,
      premium_ongoing: premium || 0,
      status_discount_ongoing: "1",
      payment_term_ongoing: paymentTerm || null,
      total_including_ongoing: totalIncludingVAT || null,
      total_monthly_ongoing: totalMonthlyCost || null,
      payment_type_ongoing: paymentTypeOfModal || null,
      payment_frequency_ongoing: payment_frequency || null,
      net20vat_ongoing: netVAT20 || null,
      vat_ongoing: vat || null,
      netnovat_ongoing: netNoVAT || null,
      admin_charge_ongoing: adminChargeAmount,
      admin_charge_status: adminCharge > 0 ? "1" : "0",
      total_monthly_excluding_ongoing: totalMonthlyCostExcluding || null,
      // payment_term_description: paymentTermDescription,
      // package_description: packageDescription,
      payment_term_description: ["<p><br></p>"].includes(formData.paymentTermDescription) ? null : formData.paymentTermDescription,
      package_description: ["<p><br></p>"].includes(formData.packageDescription) ? null : formData.packageDescription,
      package_change_status: packagesChanges == true ? "1" : "0",

      // One-Off Services
      discount_oneoff: discountOneOff || 0,
      premium_oneoff: premiumOneOff || 0,
      payment_term_oneoff: paymentTermOneOff || null,
      total_including_oneoff: totalIncludingVATOneOff || null,
      total_monthly_oneoff: totalMonthlyCostOneOff || null,
      payment_type_oneoff: paymentTypeOfModalOneOff || null,
      payment_frequency_oneoff: payment_frequencyOneOff || null,
      net20vat_oneoff: netVAT20OneOff || null,
      vat_oneoff: vatOneOff || null,
      netnovat_oneoff: netNoVATOneOff || null,
      total_monthly_excluding_oneoff: totalMonthlyCostExcludingOneOff || null,


      // selectedService: selectedService,
      // recurring: Number(serviceTypeForQuote) == 1 ? "1" : "0",
      // one_off: Number(serviceTypeForQuote) == 2 ? "1" : "0",

      recurring: addedService?.find(item => [1, 3].includes(Number(item?.servicetype_id))) != undefined || packagesServiceData?.length > 0 ? "1" : "0",
      one_off: addedService?.find(item => [2].includes(Number(item?.servicetype_id))) != undefined ? "1" : "0",

      // extra Input
      // attachment_status:showAttachment,
      show_discount: showDiscount,
      show_price: showPrice,
      self_assessment_need_status: ["", undefined, null, "0"].includes(selfAssessmentCount) ? "0" : "1",
      self_assessment_need_input: selfAssessmentCount == "" ? 0 : selfAssessmentCount,
      // contract_service_type: serviceTypeForQuote,
      contract_service_type: "1",

      // Comlexity and Risk
      complexity_label: selectedLabelComplexity,
      complexity_premium: complexityValue,
      risk_label: selectedLabelRisk,
      risk_premium: riskValue,

      quality_data_label: selectedLabelQualityData,
      quality_data_premium: qualityDataValue,
      frequency_meeting_label: selectedLabelFrequencyMeeting,
      frequency_meeting_premium: frequencyMeetingValue,
      access_seniors_label: selectedLabelAccessSenior,
      access_seniors_premium: accessSeniorValue,

      cmPremiumOngoing: cmPremiumOngoing,
      cmPremiumOneOff: cmPremiumOneOff,
      cmDiscountOngoing: cmDiscountOngoing,
      cmDiscountOneOff: cmDiscountOneOff,

      contractTypeOngoing: contractTypeOngoing,
      contractTypeOneOff: contractTypeOneOff,

      is_effected: "0",

      backupQuoteId: backupQuoteId
    }

    sessionStorage.setItem("contract_id", backupQuoteId);
    await dispatch(createContract(req)).unwrap()
      .then((res) => {

        if (res.status) {
          return true
        }
        else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }).catch((err) => {
        console.log("err", err);
      })
  }


  let countChargeBsasis = 0;
  let shownIncrementalInput = false;

  function CustomPlaceholder(props) {
    return (
      <components.Placeholder {...props}>
        <span style={{ color: "#3d3d3d", fontSize: "14px" }}>Services</span>

        {/* Pink badge */}
        <span
          style={{
            background: "#ff00aa",
            color: "white",
            padding: "2px 8px",
            borderRadius: "12px",
            fontSize: "12px",
            marginLeft: "8px",
          }}
        >
          {
            packagesServiceData.length + props.selectProps.value?.length
            || 0
          }
        </span>
      </components.Placeholder>
    );
  }




  // ✅ Step 1: Condition
  const isCustomPackage =
    (
      !['', null, undefined].includes(packageID) &&
      addedService?.find(item =>
        [1, 3].includes(Number(item?.servicetype_id))
      ) !== undefined
    ) ||
    packagesChanges === true;


  // ✅ Step 2: Options
  const packageOptions = isCustomPackage
    ? [
      { value: 'custom_package', label: 'Custom Package' },
      { value: '', label: 'Select package' },
    ]
    : [
      { value: '', label: 'Select package' },
      ...[...(quoteData?.packages || []), ...(qualifyPackages || [])]
        .filter(item => item?.status == "1")
        .map(item => ({
          value: item.id,
          label: item.name,
        })),
    ];


  // ✅ Step 3: Selected Value (AUTO SELECT)
  const selectedValue = isCustomPackage
    ? { value: 'custom_package', label: 'Custom Package' }
    : packageOptions.find(opt => opt.value === packageID) || null;




  const handleAttachmentChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData({
      ...formData,
      attachments: [...formData.attachments, ...files],
    });
  };

  const handleRemoveAttachment = (index) => {
    const updatedAttachments = formData.attachments.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, attachments: updatedAttachments });
  };




  // const filterWithoutPerHourBasis = (data) => {
  //   return data
  //     ?.filter((item) => {
  //       let matchId = item?.sell_chargebasis_id;

  //       if (['', null, undefined].includes(matchId)) {
  //         matchId = item?.default_chargebasis_id;
  //       }
  //       if (!matchId) return true;
  //       return item?.ServiceChargeBases?.some(
  //         (cb) =>
  //           cb.ChargeBasis?.id === matchId &&
  //           cb.ChargeBasis?.BasisType?.id !== 2
  //       );
  //     })
  // };

  const filterWithoutPerHourBasis = (data, type) => {

    return data?.filter((item) => {
      let price = item?.price || 0;
      if (type == "package") {
        item = item?.Service ? item?.Service : item
      }


      let matchId = item?.sell_chargebasis_id;

      if (['', null, undefined].includes(matchId)) {
        matchId = item?.default_chargebasis_id;
      }


      const basisId =
        item?.sell_chargebasis_id || item?.default_chargebasis_id;

      const matched = item?.ServiceChargeBases?.find(
        (chargeBase) =>
          chargeBase.ChargeBasis?.id === basisId &&
          chargeBase.ChargeBasis?.BasisType?.id === 2
      );

      if (matched && parseFloat(price) === 0) {
        return false;
      } else {
        return true
      }


    });

  };
  // const filterPerHourBasis = (data) => {
  //   return data
  //     ?.filter((item) => {
  //       let matchId = item?.sell_chargebasis_id;

  //       if (['', null, undefined].includes(matchId)) {
  //         matchId = item?.default_chargebasis_id;
  //       }
  //       if (!matchId) return false;
  //       return item?.ServiceChargeBases?.some(
  //         (cb) =>
  //           cb.ChargeBasis?.id === matchId &&
  //           cb.ChargeBasis?.BasisType?.id === 2
  //       );
  //     })
  //     ?.map((item) => ({
  //       ...item,
  //       vat_label: Number(item?.vat_exempt) === 0 ? " + VAT" : "",
  //     }));
  // };


  const filterPerHourBasis = (data, type) => {

    return data?.filter((item) => {

      let price = item?.price || 0;
      if (type == "package") {
        item = item?.Service ? item?.Service : item
      }

      let matchId = item?.sell_chargebasis_id;

      if (['', null, undefined].includes(matchId)) {
        matchId = item?.default_chargebasis_id;
      }

      if (!matchId) return false;

      const matched = item?.ServiceChargeBases?.find(
        (cb) =>
          cb.ChargeBasis?.id === matchId &&
          cb.ChargeBasis?.BasisType?.id === 2
      );

      // New condition (remove if price = 0)
      if (matched && parseFloat(price) === 0) {
        return true;
      } else {
        return false
      }

    })
      ?.map((item) => ({
        ...item,
        vat_label: Number(item?.vat_exempt) === 0 ? " + VAT" : "",
      }));
  };


  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: '',
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: 'transparent',
        backdrop: 'rgba(229, 233, 236, 0.2)',
        // timer: 8000,
        customClass: {
          popup: 'no-shadow',
        }
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);


  let ongoing_label = contractTypeOngoing == 'contract_type_ongoing' ? 'Ongoing' : contractTypeOngoing == 'contract_type_oneoff' ? 'One-Off' : 'Pay As You Go';

  let oneoff_label = contractTypeOneOff == 'contract_type_ongoing' ? 'Ongoing' : contractTypeOneOff == 'contract_type_oneoff' ? 'One-Off' : 'Pay As You Go';


  //////////////////////////////////////////

  let totalCostCurrento_ongoing = 0;
  let totalCostCurrento_oneoff = 0;
  // Pichle (current) contract ki service id -> entry ka Map — sirf contract badalne par rebuild hota hai
  const existingServiceMap = useMemo(() => {
    const map = new Map();
    for (const ser of quoteData?.ExistClientContract?.ContractPackageServices || []) {
      if (ser?.Service?.id != null) map.set(Number(ser.Service.id), ser);
    }
    return map;
  }, [quoteData?.ExistClientContract?.ContractPackageServices]);

  // Service pichle contract me thi ya nahi — thi to koi badge nahi, warna "NEW"
  const isExistingService = useCallback(
    (serviceId) => serviceId != null && serviceId !== "" && existingServiceMap.has(Number(serviceId)),
    [existingServiceMap]
  );

  // Pichle contract ka amount — normal service me "price", hourly me "rate"
  // Service nahi thi ya value invalid hai to null
  const getExistingServiceAmount = useCallback(
    (serviceId, field = "price") => {
      if (serviceId == null || serviceId === "") return null;
      const value = Number(existingServiceMap.get(Number(serviceId))?.[field]);
      return Number.isFinite(value) ? value : null;
    },
    [existingServiceMap]
  );

  // Premium + discount lagne ke baad ki proposed price
  const getProposedPrice = useCallback(
    (price, servicetypeId) => {
      const isOneOff = Number(servicetypeId) === 2;
      const premium = isOneOff ? increasePremiumFinalOneOff : increasePremiumFinal;
      const discount = isOneOff ? discountValueFinalOneOff : discountValueFinal;
      return roundNumber((Number(price) || 0) * (1 + premium / 100) * (1 - discount / 100));
    },
    [increasePremiumFinal, discountValueFinal, increasePremiumFinalOneOff, discountValueFinalOneOff]
  );

  // "was £X" sirf tab jab purana amount mile aur naye se alag ho
  const renderWasPrice = useCallback(
    (serviceId, newAmount, field = "price") => {
      const oldAmount = getExistingServiceAmount(serviceId, field);
      if (oldAmount == null) return null;
      const oldRounded = roundNumber(oldAmount);
      if (oldRounded === roundNumber(newAmount)) return null;
      return <div className="was">was £{oldRounded}</div>;
    },
    [getExistingServiceAmount]
  );

  // Proposed side ki new price serviceId ke hisaab se — current side ka spacer decide karne ke liye
  const proposedPriceMap = useMemo(() => {
    const map = new Map();
    for (const val of packagesServiceData || []) {
      const svc = val?.Service;
      if (svc?.id != null) map.set(Number(svc.id), getProposedPrice(val?.price, svc?.servicetype_id));
    }
    for (const item of addedService || []) {
      if ([1, 2, 3].includes(Number(item?.servicetype_id)) && item?.id != null) {
        map.set(Number(item.id), getProposedPrice(item?.price, item?.servicetype_id));
      }
    }
    return map;
  }, [packagesServiceData, addedService, getProposedPrice]);

  // Hourly (Pay As You Go) proposed side ki rate serviceId ke hisaab se
  const proposedRateMap = useMemo(() => {
    const map = new Map();
    for (const item of HourlyBillingArray || []) {
      const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
      const matched = item?.ServiceChargeBases?.find(chargeBase =>
        chargeBase?.ChargeBasis?.id === basisId &&
        chargeBase?.ChargeBasis?.BasisType?.id === 2
      );
      if (matched && item?.id != null) map.set(Number(item.id), roundNumber(matched?.rate));
    }
    return map;
  }, [HourlyBillingArray]);

  // Current side me "was" nahi dikhana, par jab proposed side me "was" aata hai to
  // rows ki height barabar rakhne ke liye utni hi height ka invisible spacer daal do
  const renderWasSpacer = useCallback(
    (serviceId, field = "price") => {
      const oldAmount = getExistingServiceAmount(serviceId, field);
      if (oldAmount == null) return null;
      const proposed = field === "rate"
        ? proposedRateMap.get(Number(serviceId))
        : proposedPriceMap.get(Number(serviceId));
      if (proposed == null) return null;
      if (roundNumber(oldAmount) === roundNumber(proposed)) return null;
      return <div className="was" style={{ visibility: "hidden" }} aria-hidden="true">was £0</div>;
    },
    [getExistingServiceAmount, proposedPriceMap, proposedRateMap]
  );







  const currentContractValue = useMemo(() => {
    if (!addedService?.length && !packagesServiceData?.length) return 0;

    const existing = quoteData?.ExistClientContract;
    const serviceTypes = new Set(addedService.map((item) => Number(item?.servicetype_id)));

    const hasOngoing = packagesServiceData?.length > 0 || serviceTypes.has(1) || serviceTypes.has(3);
    const hasOneOff = serviceTypes.has(2);

    const ongoing = hasOngoing ? roundNumber(existing?.total_including_ongoing) / 12 : 0;
    const oneOff = hasOneOff ? roundNumber(existing?.total_including_oneoff) / 12 : 0;

    // roundNumber(undefined) === NaN, isliye fallback
    return roundNumber(ongoing || 0) + roundNumber(oneOff || 0);
  }, [addedService, packagesServiceData, quoteData?.ExistClientContract]);

  // const ProposedContractValue = useMemo(() => {
  //   if (!addedService?.length && !packagesServiceData?.length) return 0;


  //   const serviceTypes = new Set(addedService.map((item) => Number(item?.servicetype_id)));
  //   const hasOngoing = packagesServiceData?.length > 0 || serviceTypes.has(1) || serviceTypes.has(3);
  //   const hasOneOff = serviceTypes.has(2);

  //   const ongoing = hasOngoing ? roundNumber(totalIncludingVAT) / 12 : 0;
  //   const oneOff = hasOneOff ? roundNumber(totalIncludingVATOneOff) / 12 : 0;

  //   // roundNumber(undefined) === NaN, isliye fallback
  //   return roundNumber(ongoing || 0) + roundNumber(oneOff || 0);
  // }, [addedService, packagesServiceData ,discountOneOff, discount ,contractTypeOngoing,contractTypeOneOff,paymentTerm,paymentTermOneOff ]);


  function ProposedContractValue() {
    if (!addedService?.length && !packagesServiceData?.length) return 0;


    const serviceTypes = new Set(addedService.map((item) => Number(item?.servicetype_id)));
    const hasOngoing = packagesServiceData?.length > 0 || serviceTypes.has(1) || serviceTypes.has(3);
    const hasOneOff = serviceTypes.has(2);

    const ongoing = hasOngoing ? roundNumber(totalIncludingVAT) / 12 : 0;
    const oneOff = hasOneOff ? roundNumber(totalIncludingVATOneOff) / 12 : 0;

    return roundNumber(ongoing || 0) + roundNumber(oneOff || 0);
  }


  return (
    <div className="">
      <div className="row mb-4">
        <div className="col">
          <h4 className="page-title">
            <Link to="/admin/contracts/contracts-dashboard"
              onClick={() => sessionStorage.clear()}
            >
              <i className='bx bx-arrow-back text-pink pe-1'></i>
            </Link>
            New Contract
          </h4>
        </div>
      </div>

      {
        currentContractValue < ProposedContractValue() &&
        (packagesServiceData?.length > 0 || addedService.length > 0) && ![null, undefined, ""].includes(quoteData?.ExistClientContract) &&
        (
          <>
            <div className="ccb-bar">
              <div className="ccb-context">
                <span className="ccb-eyebrow">Comparing Against</span>
                <span className="ccb-context-line">
                  Current contract · {quoteData?.ExistClientContract?.Client?.client_name} · dated {formatOrdinalDate(quoteData?.ExistClientContract?.contract_signed_date)}
                </span>
              </div>

              <div className="ccb-prices">
                <div className="ccb-price-group">

                  {/* <span className="ccb-price-label">Current  {getPaymentTermFrequency(quoteData?.ExistClientContract?.payment_term_ongoing)}  (Inc. VAT)</span> */}
                  <span className="ccb-price-label">Current Monthly (Inc. VAT)</span>
                  <span className="ccb-price-old">£{currentContractValue}</span>

                </div>

                <span className="ccb-arrow">→</span>
                <div className="ccb-price-group">
                  {/* <span className="ccb-price-label">Proposed {getPaymentTermFrequency(paymentTerm)}  (Inc. VAT)</span> */}
                  <span className="ccb-price-label">Proposed Monthly (Inc. VAT)</span>
                  <span className="ccb-price-new">£{ProposedContractValue()}</span>
                </div>

                {(() => {
                  const priceChange = getPriceChange(
                    currentContractValue,
                    ProposedContractValue()
                  );
                  if (!priceChange) return null;
                  console.log("priceChange.isIncrease => ", priceChange.isIncrease)
                  return (
                    <span className={`ccb-badge ${!priceChange.isIncrease ? "" : "ccb-badge-down"}`}>
                      {priceChange.label}
                    </span>
                  );
                })()}
              </div>
            </div>
          </>
        )
      }








      <div className="px-0 py-4 contract-cards">
        <div className="card pt-3">
          <div className="card-body ">
            <h4 className="page-title" >
              Select Services And/Or Packages
            </h4>

            <div className="form-group pt-4">

              <div className="row">
                <div className="col-md-2"> <label className="col-form-label">Add Package
                  {/* <span className="text-pink ps-2">+</span>`  1q */}
                </label></div>
                <div className="col-md-4 d-flex">
                  <div className="col-md-12">
                    <Select
                      classNamePrefix="custom-select"
                      isDisabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                      options={packageOptions}
                      value={selectedValue}
                      onChange={(selected) =>
                        handlePackageSelect({
                          target: { value: selected?.value }
                        })
                      }
                      placeholder="Select package"
                      menuPlacement="bottom"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}

                    />
                  </div>
                  <div className="col-md-2 ms-2 mt-1">
                    <div className="tooltip-custom-div">
                      {
                        packageID != null ?
                          <>
                            <Info
                              size={18}
                              style={{ cursor: "pointer" }}
                            />
                          </>
                          : ""
                      }
                      <div className="tooltip-custom">
                        <div className="tootltip-custom-table-head">
                          <div className="tooltip-custom-sno">S.No</div>
                          <div className="tooltip-custom-service">Services</div>
                        </div>
                        <div className="tootltip-custom-table-body">

                          {
                            (addedService.length > 0 && addedService?.find(item => [1, 3].includes(Number(item?.servicetype_id)))) || packagesServiceData.length > 0 ?
                              <>
                                {
                                  packagesServiceData && packagesServiceData?.map((item, index) => {
                                    let val = item;
                                    item = item?.Service;

                                    return (
                                      <div className="tootltip-custom-table-body-div">
                                        <div className="tooltip-custom-sno">{index + 1}</div>
                                        <div className="tooltip-custom-service">{item.name}</div>
                                      </div>
                                    )
                                  })
                                }

                                {
                                  addedService && addedService?.filter(item => [1, 3].includes(Number(item.servicetype_id)))
                                    .map((item, index) => {
                                      const offset = packagesServiceData?.length || 0;

                                      return (
                                        <div className="tootltip-custom-table-body-div" key={`add-${index}`}>
                                          <div className="tooltip-custom-sno">{offset + index + 1}</div>
                                          <div className="tooltip-custom-service">{item.name}</div>
                                        </div>
                                      );
                                    })
                                }
                              </>

                              :
                              ""
                          }
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <div className="row ">
                    <div className="col-md-4"> <label className="col-form-label">Add Individual Services</label></div>
                    <div className="col-md-8">
                      <Select
                        classNamePrefix="custom-select"
                        components={{ Placeholder: CustomPlaceholder }}
                        // options={quoteData.services
                        //   ?.map((data) => ({
                        //     label: data.name,
                        //     value: data.id
                        //   }))}
                        options={
                          quoteData?.services
                            ?.filter(s =>
                              !(packagesServiceData?.map(item => item?.Service?.id) || [])
                                .includes(s.id)
                            )
                            .map(s => ({
                              label: s.name,
                              value: s.id
                            }))
                        }
                        isMulti
                        menuPortalTarget={document.body}
                        className="w-100 basic-multi-select z-index-999"
                        name="services"
                        closeMenuOnSelect={false}
                        placeholder="Select Services111"
                        controlShouldRenderValue={false}
                        value={serviceData}
                        onChange={handleAddService}
                        isDisabled={requestHigherDiscountStatus === true ? true : false}
                      />
                    </div>
                  </div>
                </div>
              </div>



            </div>


          </div>

        </div>

        {
          packageID != null || addedService.length > 0 ?
            <>
              <div className="card p-3">
                <div className="card-header border-0 bg-transparent">
                  <div className="row">
                    <div className="col-md-6">
                      <h4 className="page-title" >
                        Breakdown
                      </h4>

                    </div>
                    {/* <div className="col-md-6">
                <div className="row justify-content-end">
                  <div className="col-md-4"> <label className="col-form-label">Add Individual Services</label></div>
                  <div className="col-md-6">
                    <Select
                      options={quoteData.services
                        ?.map((data) => ({
                          label: data.name,
                          value: data.id
                        }))}
                      isMulti
                      menuPortalTarget={document.body}
                      className="w-100 basic-multi-select z-index-999"
                      name="services"
                      closeMenuOnSelect={false}
                      placeholder="Select Services"
                      controlShouldRenderValue={false}
                      value={serviceData}
                      onChange={handleAddService}

                    />
                  </div>
                </div>
              </div> */}
                  </div>
                </div>
                {/* {
            console.log("addedService -- ", addedService)
          }

          {
            console.log("packagesServiceData -- ", packagesServiceData)
          } */}

                {
                  packageID && packagesServiceData && packagesServiceData?.map((item, index) => {
                    let val = item;
                    item = item.Service;

                    return (
                      <div className="card-body pt-1">
                        <div className="card service-card mb-4 pink-card">
                          <div className="card-body pt-1 ">


                            <div className="d-flex justify-content-between align-items-center mb-3 pt-3">
                              <h6 className="service-name-new-heading text-pink">{item.name}</h6>

                            </div>


                            <div className="row g-3 align-items-end">


                              <div className="col-lg-3 col-md-6">
                                <label className="col-form-label">



                                  {(() => {


                                    const serviceBasisIds = new Set(
                                      item?.ServiceChargeBases?.map(s => s.ChargeBasis.id)
                                    );

                                    const basisToShow = quoteEnterDefaultValue?.filter(b => {
                                      if (!serviceBasisIds.has(b.chargebasis_id)) return false;
                                      if (usedChargeBasisCopy.has(b.chargebasis_id)) return false;

                                      usedChargeBasisCopy.add(b.chargebasis_id);
                                      return true;
                                    });

                                    const isSelfAsscessment = item?.ServiceChargeBases?.find(
                                      item => item?.ChargeBasis?.BasisType?.id === 5
                                    ) || null;

                                    // console.log("isSelfAsscessment -- ", isSelfAsscessment);
                                    return isSelfAsscessment === null ? "Basis" : null;

                                    //return basisToShow?.length > 0 ? "Basis" : null;
                                  })()}

                                </label>

                                {item.default_chargebasis_status === "1" && item.default_chargebasis_id ? (
                                  <select
                                    disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                    name="default"
                                    className="form-select fs-8 select-pink"
                                    value={item.sell_chargebasis_id != undefined ? val.sell_chargebasis_id : item.default_chargebasis_id}
                                    onChange={(e) => handleChangeChargeBasis(e, item, index, 'package')}
                                  >
                                    {item.ServiceChargeBases.map((chargeBase) => (
                                      <option
                                        key={chargeBase.id}
                                        value={chargeBase.ChargeBasis.id}
                                        selected={
                                          item.sell_chargebasis_id != undefined ? item.sell_chargebasis_id === chargeBase.ChargeBasis.id :
                                            chargeBase.ChargeBasis.id === item.default_chargebasis_id
                                        }
                                      >
                                        {chargeBase.ChargeBasis.name}
                                      </option>
                                    ))}
                                  </select>
                                ) :
                                  Number(item.frequency_status) === 1 && Number(item.link_frequency_rule) === 1 ?

                                    (

                                      ""
                                    )
                                    :

                                    item.frequency_status === "1" && item.frequency_optional_chargebasis_id ?
                                      (

                                        <select
                                          disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                          name="frequency"
                                          className="form-select fs-8 select-pink"
                                          onChange={(e) => handleChangeChargeBasis(e, item, index, 'package')}
                                        >
                                          {item.ServiceChargeBases.map((chargeBase) => (

                                            chargeBase.ChargeBasis.BasisType.id === 4 ? null : (
                                              <option
                                                key={chargeBase.id}
                                                value={chargeBase.ChargeBasis.id}
                                                selected={
                                                  item.sell_chargebasis_id != undefined ? item.sell_chargebasis_id === chargeBase.ChargeBasis.id :
                                                    chargeBase.ChargeBasis.id === item.frequency_optional_chargebasis_id
                                                }
                                              >
                                                {chargeBase.ChargeBasis.name}
                                              </option>
                                            )
                                          ))}
                                        </select>
                                      )
                                      :
                                      (
                                        ""
                                      )}
                              </div>

                              {
                                (() => {
                                  let perhourFrequencyCondition = true;
                                  const renderChargeBasis = () =>
                                    Number(item.incremental_rule) === 0 &&
                                    quoteEnterDefaultValue
                                      ?.filter((b) => {
                                        const serviceBasisIds = new Set(
                                          item?.ServiceChargeBases?.map(s => s.ChargeBasis.id)
                                        );

                                        // if (serviceBasisIds.has(b.chargebasis_id)) {
                                        //   if (usedChargeBasis.has(b.chargebasis_id)) return false;
                                        //   usedChargeBasis.add(b.chargebasis_id);
                                        //   return true;
                                        // }
                                        // return false;
                                        if (serviceBasisIds.has(b.chargebasis_id)) {
                                          if (b.basistypes_id === 2) {
                                            return true;
                                          } else {
                                            if (usedChargeBasis.has(b.chargebasis_id)) return false;
                                            usedChargeBasis.add(b.chargebasis_id);
                                            return true;
                                          }
                                        }
                                        return false;
                                      })
                                      ?.map((itemChargeBasis, index) => {

                                        const currentChargeBasis = item?.ServiceChargeBases?.find(chargeBasis => chargeBasis.ChargeBasis.id === itemChargeBasis?.chargebasis_id);


                                        const showInput = [1].includes(itemChargeBasis.basistypes_id);
                                        const showSelect = [3, 4].includes(itemChargeBasis.basistypes_id);
                                        const showInputHour = [2].includes(itemChargeBasis?.basistypes_id);

                                        if (item.frequency_status === "1" && item.frequency_optional_chargebasis_id != null && showInputHour) {
                                          perhourFrequencyCondition = false;
                                        }

                                        const chargeBasisId = itemChargeBasis.chargebasis_id;
                                        if (!showInput && !showSelect && !showInputHour) return null;
                                        countChargeBsasis++
                                        return (

                                          <div className="col-lg-4 col-md-6" key={index}>
                                            {
                                              showInputHour ?
                                                ""
                                                :
                                                perhourFrequencyCondition === false ?
                                                  ""
                                                  :
                                                  <label className="fcol-form-label align-center">
                                                    {itemChargeBasis?.pricing_queries}
                                                  </label>

                                            }
                                            {
                                              showSelect && perhourFrequencyCondition ? (
                                                <select className="form-select custom-select-pink"
                                                  disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                  name={`chargeBasisQuery_${index}`}
                                                  //value={quoteEnterDefaultValue?.[index]?.chargetype_rule_id}
                                                  value={quoteEnterDefaultValue?.find(v => v.chargebasis_id == chargeBasisId)?.chargetype_rule_id}
                                                  onChange={(e) => inputChangeChargeBasisFun(e, itemChargeBasis, index, 'dropdown', 'package')}
                                                >
                                                  {
                                                    itemChargeBasis?.ChargeTypes?.map((option, index1) => {
                                                      return (
                                                        <option key={index1} value={option.id}>
                                                          {option.name}
                                                        </option>
                                                      );
                                                    })
                                                  }
                                                </select>
                                              )
                                                :
                                                showInput ?
                                                  (
                                                    <input type="text"
                                                      disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                      className="form-control custom-input-pink"
                                                      name={`chargeBasisQuery_${index}`}
                                                      // value={quoteEnterDefaultValue?.[index]?.inputValue}
                                                      value={quoteEnterDefaultValue?.find(v => v.chargebasis_id == chargeBasisId)?.inputValue}

                                                      onChange={(e) => inputChangeChargeBasisFun(e, itemChargeBasis, index, 'input', 'package')}
                                                    />
                                                  )
                                                  :

                                                  showInputHour ?
                                                    (
                                                      <>

                                                        <div className="d-flex gap-4 ">
                                                          <div className="position-relative  ">

                                                            <div className="tooltip-custom-div d-flex gap-2">
                                                              <div className="tooltip-custom-rate">
                                                                Rate can be adjusted as required.
                                                              </div>
                                                              <label >
                                                                Rate
                                                              </label>
                                                              <Info
                                                                size={16}
                                                                style={{ cursor: "pointer" }}
                                                              />

                                                            </div>


                                                            <input type="text"
                                                              disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                              className="form-control custom-input-pink"
                                                              name={`hoursQuery_${index}`}
                                                              value={currentChargeBasis?.rate}
                                                              onChange={(e) => inputChangeChargeBasisFun(e, itemChargeBasis, index, 'rate', "package", item, currentChargeBasis)}
                                                            />

                                                            {
                                                              rateError[item.id + '_' + currentChargeBasis.id] &&
                                                              <div className="text-danger"
                                                                style={{
                                                                  position: "absolute",
                                                                  fontSize: "12px",
                                                                  marginTop: "2px",
                                                                  whiteSpace: "nowrap",
                                                                  display: "block",

                                                                }}>
                                                                {rateError[item.id + '_' + currentChargeBasis.id]}
                                                              </div>

                                                            }

                                                          </div>

                                                          <div className="position-relative ">

                                                            <div className="tooltip-custom-div d-flex gap-2">
                                                              <label>
                                                                {itemChargeBasis?.pricing_queries}
                                                              </label>

                                                              <Info
                                                                size={16}

                                                                style={{ cursor: "pointer" }}
                                                              />
                                                              <div className="tooltip-custom-rate-1">
                                                                Enter '0' hours to keep the Time & Fees billing model. If you want Fixed Fees billing, enter the required number of hours to set a fixed hour limit.
                                                              </div>
                                                            </div>

                                                            <input type="text"
                                                              disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                              className="form-control custom-input-pink"
                                                              name={`hoursQuery_${index}`}
                                                              value={currentChargeBasis?.inputValueHour}
                                                              onChange={(e) => inputChangeChargeBasisFun(e, itemChargeBasis, index, 'input', "package", item, currentChargeBasis)}
                                                            />

                                                            {/* Validation Message */}
                                                            {["", undefined, null].includes(currentChargeBasis?.inputValueHour) && (
                                                              <div
                                                                className="text-danger"
                                                                style={{
                                                                  position: "absolute",
                                                                  fontSize: "12px",
                                                                  marginTop: "2px",
                                                                  whiteSpace: "nowrap",
                                                                  display: "block"
                                                                }}
                                                              >
                                                                Please enter the value.
                                                              </div>
                                                            )}
                                                          </div>

                                                        </div>


                                                      </>
                                                    )
                                                    :
                                                    ""
                                            }
                                          </div>
                                        );
                                      });

                                  if (
                                    item?.default_chargebasis_id != null &&
                                    Number(item?.default_chargebasis_status) === 1
                                  ) {
                                    let matchId = item?.default_chargebasis_id;

                                    if (!['', null, undefined].includes(item?.setDefaultId)) {
                                      matchId = item?.setDefaultId;
                                    }


                                    if (!['', null, undefined].includes(item?.sell_chargebasis_id)) {
                                      matchId = item?.sell_chargebasis_id;
                                    }

                                    const defaultBasis = item?.ServiceChargeBases?.find(
                                      b => b?.ChargeBasis?.id === matchId
                                    );

                                    //  BasisType 6 → hide
                                    if (defaultBasis?.ChargeBasis?.BasisType?.id === 6) {
                                      return null;
                                    }


                                    const service = item;
                                    item = {
                                      ...item,
                                      ServiceChargeBases: service?.ServiceChargeBases.filter(cb =>
                                        cb.ChargeBasis?.id === matchId
                                      )
                                    };
                                    return renderChargeBasis();
                                  } else {
                                    // Frequency Condition show charge Basis
                                    const service = item;
                                    if (Number(service?.custom_rule == 1) && Number(service?.frequency_status == 1) && Number(service?.link_frequency_rule) === 0) {
                                      let matchId = service?.frequency_optional_chargebasis_id;


                                      if (!['', null, undefined].includes(item?.sell_chargebasis_id)) {
                                        matchId = item?.sell_chargebasis_id;
                                      }

                                      item = {
                                        ...service,
                                        ServiceChargeBases: service?.ServiceChargeBases.filter(cb =>
                                          cb.ChargeBasis?.id === matchId ||
                                          cb.ChargeBasis?.BasisType?.id === 4
                                        )
                                      };
                                      return renderChargeBasis();
                                    } else {
                                      // custom rule condition Show Charge Basis
                                      return renderChargeBasis();
                                    }

                                  }
                                  // return renderChargeBasis();
                                })()
                              }


                              {/* Self Assesment Service Chargebasis */}

                              {
                                Number(item.incremental_rule) === 1 ?
                                  <div className="table-responsive px-4">

                                    {
                                      Number(item.incremental_rule) === 1 && !shownIncrementalInput && (
                                        (() => {
                                          shownIncrementalInput = true;
                                          return (
                                            <div className="col-md-6 pe-lg-5 mb-3">
                                              <label className="col-form-label">
                                                How many self assessments do you need?
                                              </label>
                                              <input
                                                disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                type="text"
                                                className="form-control"
                                                name="needSelfAssessmentCount"
                                                value={selfAssessmentCount}
                                                onChange={(e) => inputChangeChargeBasisFun(e, null, null, 'selfAssessmentCount', 'package')}
                                                placeholder="Enter number of self assessments"
                                              />
                                            </div>
                                          );
                                        })()
                                      )
                                    }


                                    <table className="table border">
                                      <thead>
                                        <tr>
                                          <td
                                            style={{
                                              background: "#F5F5F5",
                                              color: "#4E4E4E",
                                              fontSize: "14px",
                                            }}
                                          >
                                            Queries
                                          </td>
                                          {individuals.map((name, idx) => (
                                            <td
                                              width={"300px"}
                                              key={idx}
                                              style={{
                                                background: "#F5F5F5",
                                                color: "#4E4E4E",
                                                fontSize: "14px",

                                              }}
                                            >
                                              {name}
                                            </td>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {

                                          quoteIndividualSetValue
                                            ?.map((b, originalIndex) => {
                                              const serviceBasisIds = new Set(
                                                item?.ServiceChargeBases?.map(s => s.ChargeBasis.id)
                                              );
                                              if (!serviceBasisIds.has(b.chargebases_id)) return null;
                                              if (usedChargeBasisSelfAssesment.has(b.chargebases_id)) return null;
                                              usedChargeBasisSelfAssesment.add(b.chargebases_id);
                                              return { ...b, originalIndex };
                                            })
                                            ?.filter(row => row !== null)
                                            ?.map((q) => (
                                              <tr key={q.originalIndex}>
                                                <td className="fs-14">
                                                  <div style={{ width: '300px' }}>{q.name}</div>
                                                </td>

                                                {selfAssessmentCount !== '' &&
                                                  q?.individual?.map((ind_item, indIndex) => (

                                                    <td className="fs-14" key={indIndex}>
                                                      <div style={{ width: '150px', padding: '0px 15px 0 0' }}>

                                                        {Number(q.basistypes_id === 5) ? (
                                                          <div className="d-flex">

                                                            <div className="form-check">
                                                              <input
                                                                disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`name_${q.originalIndex}_ind_${indIndex}`}
                                                                id={`yes_q${q.originalIndex}_i${indIndex}`}
                                                                checked={ind_item.radio_option === "1"}
                                                                onChange={(e) =>
                                                                  inputChangeChargeBasisFun(e, q, q.originalIndex, 'radio', 'package')
                                                                }
                                                              />
                                                              <label
                                                                className="form-check-label"
                                                                htmlFor={`yes_q${q.originalIndex}_i${indIndex}`}
                                                              >
                                                                Yes
                                                              </label>
                                                            </div>

                                                            <div className="form-check ms-3">
                                                              <input
                                                                disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`name_${q.originalIndex}_ind_${indIndex}`}
                                                                id={`no_q${q.originalIndex}_i${indIndex}`}
                                                                value="no"
                                                                checked={ind_item.radio_option === "0"}
                                                                onChange={(e) =>
                                                                  inputChangeChargeBasisFun(e, q, q.originalIndex, 'radio', 'package')
                                                                }
                                                              />
                                                              <label
                                                                className="form-check-label"
                                                                htmlFor={`no_q${q.originalIndex}_i${indIndex}`}
                                                              >
                                                                No
                                                              </label>
                                                            </div>

                                                          </div>
                                                        ) : (
                                                          <input
                                                            disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                            type="text"
                                                            className="form-control"
                                                            name={`name_${q.originalIndex}_ind_${indIndex}`}
                                                            id={`input_q${q.originalIndex}_i${indIndex}`}
                                                            value={ind_item.inputValue}
                                                            onChange={(e) =>
                                                              inputChangeChargeBasisFun(e, q, q.originalIndex, 'input', 'package')
                                                            }
                                                          />
                                                        )}

                                                      </div>
                                                    </td>

                                                  ))}
                                              </tr>
                                            ))
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                  : ""
                              }



                              {/* Total Cost Section */}
                              <div className="col-lg-3 col-md-6 text-end ms-auto">
                                <label className="form-label text-muted small">Total Cost</label>
                                <div className="price text-pink">
                                  £{
                                    (() => {
                                      const basisId = val?.Service?.sell_chargebasis_id || val?.Service?.default_chargebasis_id;
                                      const matched = val?.Service?.ServiceChargeBases?.find(chargeBase =>
                                        chargeBase?.ChargeBasis?.id === basisId &&
                                        chargeBase?.ChargeBasis?.BasisType?.id === 2
                                      );


                                      if (matched && parseFloat(val?.price) === 0) {

                                        return roundNumber(matched?.rate) || "0.00";
                                      }

                                      const value =
                                        (val?.price * (1 + increasePremiumFinal / 100)) *
                                        (1 - discountValueFinal / 100);
                                      return roundNumber(value);
                                    })()
                                  }

                                </div>
                              </div>
                            </div>

                          </div>
                          <div className="card-footer text-end mt-4">
                            <button
                              className="icon-btn text-end ms-auto btn p-0"
                              disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                            >
                              <Trash2 className="text-dark"
                                onClick={() => handleDeleteService(index, 'package')}
                              ></Trash2></button>
                          </div>
                        </div>
                      </div>
                    );
                  })

                }

                {
                  // Display  Services
                  addedService && addedService?.map((item, index) => {
                    const servicItem = item?.ServiceChargeBases
                    return (
                      <div className="card-body pt-1">
                        <div className="card service-card mb-4 pink-card">
                          <div className="card-body pt-1 ">

                            {/* Header: Service Name & Icon */}
                            <div className="d-flex justify-content-between align-items-center mb-3 pt-3">
                              <h6 className="service-name-new-heading text-pink">
                                {
                                  item.name
                                }

                                <span style={{ color: "black", marginLeft: '12px' }}>
                                  {
                                    !['', null, undefined].includes(packageID) ?
                                      <>
                                        <span className="badge bg-dark rounded-pill py-2">Additionally Added</span>
                                      </>
                                      : ''
                                  }
                                </span>
                              </h6>

                              {/* <TrashIcon /> */}
                            </div>

                            {/* Input Fields Row */}
                            <div className="row g-3 align-items-end">

                              {/* Field 1: Basis Dropdown */}
                              <div className="col-lg-3 col-md-6">


                                <label className="col-form-label">

                                  {/* Basis */}

                                  {(() => {
                                    // if (Number(item.incremental_rule) !== 0) return null;

                                    const serviceBasisIds = new Set(
                                      item?.ServiceChargeBases?.map(s => s.ChargeBasis.id)
                                    );

                                    const basisToShow = quoteEnterDefaultValue?.filter(b => {
                                      if (!serviceBasisIds.has(b.chargebasis_id)) return false;
                                      if (usedChargeBasisCopy.has(b.chargebasis_id)) return false;

                                      usedChargeBasisCopy.add(b.chargebasis_id);
                                      return true;
                                    });

                                    const isSelfAsscessment = item?.ServiceChargeBases?.find(
                                      item => item?.ChargeBasis?.BasisType?.id === 5
                                    ) || null;

                                    // console.log("isSelfAsscessment -- ", isSelfAsscessment);
                                    return isSelfAsscessment === null ? "Basis" : null;

                                    //return basisToShow?.length > 0 ? "Basis" : null;
                                  })()}




                                </label>


                                {item.default_chargebasis_status === "1" && item.default_chargebasis_id ? (
                                  <select
                                    disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                    name="default"
                                    className="form-select fs-8 select-pink"
                                    onChange={(e) => handleChangeChargeBasis(e, item, index, 'service')}
                                  >
                                    {item?.ServiceChargeBases.map((chargeBase) => (
                                      <option
                                        key={chargeBase.id}
                                        value={chargeBase.ChargeBasis.id}
                                        selected={
                                          item.sell_chargebasis_id != undefined ? item.sell_chargebasis_id === chargeBase.ChargeBasis.id :
                                            chargeBase.ChargeBasis.id === item.default_chargebasis_id
                                        }
                                      >
                                        {chargeBase.ChargeBasis.name}
                                      </option>
                                    ))}
                                  </select>
                                ) :
                                  Number(item.frequency_status) === 1 && Number(item.link_frequency_rule) === 1 ?

                                    (

                                      ""
                                    )
                                    :

                                    item.frequency_status === "1" && item.frequency_optional_chargebasis_id ?

                                      (

                                        <select
                                          disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                          name="frequency"
                                          className="form-select fs-8 select-pink"
                                          onChange={(e) => handleChangeChargeBasis(e, item, index, 'service')}
                                        >
                                          {item.ServiceChargeBases.map((chargeBase) => (

                                            chargeBase.ChargeBasis.BasisType.id === 4 ? null : (
                                              <option
                                                key={chargeBase.id}
                                                value={chargeBase.ChargeBasis.id}
                                                selected={
                                                  item.sell_chargebasis_id != undefined ? item.sell_chargebasis_id === chargeBase.ChargeBasis.id :
                                                    chargeBase.ChargeBasis.id === item.frequency_optional_chargebasis_id
                                                }
                                              >
                                                {chargeBase.ChargeBasis.name}
                                              </option>
                                            )
                                          ))}
                                        </select>
                                      )
                                      :
                                      (
                                        ""
                                      )}
                              </div>

                              {/* Without Self Assesment Service Chargebasis */}

                              {
                                (() => {
                                  let perhourFrequencyCondition = true;
                                  const renderChargeBasis = () =>
                                    Number(item.incremental_rule) === 0 &&
                                    quoteEnterDefaultValue
                                      ?.filter((b) => {
                                        const serviceBasisIds = new Set(
                                          item?.ServiceChargeBases?.map(s => s.ChargeBasis.id)
                                        );

                                        if (serviceBasisIds.has(b.chargebasis_id)) {
                                          if (b.basistypes_id === 2) {
                                            return true;
                                          } else {
                                            if (usedChargeBasis.has(b.chargebasis_id)) return false;
                                            usedChargeBasis.add(b.chargebasis_id);
                                            return true;
                                          }
                                        }
                                        return false;
                                      })
                                      ?.map((itemChargeBasis, index) => {

                                        const currentChargeBasis = item?.ServiceChargeBases?.find(chargeBasis => chargeBasis.ChargeBasis.id === itemChargeBasis?.chargebasis_id);

                                        const showInput = [1].includes(itemChargeBasis.basistypes_id);
                                        const showSelect = [3, 4].includes(itemChargeBasis.basistypes_id);
                                        const showInputHour = [2].includes(itemChargeBasis?.basistypes_id);


                                        if (item.frequency_status === "1" && item.frequency_optional_chargebasis_id != null && showInputHour) {
                                          perhourFrequencyCondition = false;

                                        }

                                        const chargeBasisId = itemChargeBasis.chargebasis_id;
                                        if (!showInput && !showSelect && !showInputHour) return null;
                                        countChargeBsasis++
                                        return (

                                          <div className="col-lg-4 col-md-6" key={index}>
                                            {
                                              showInputHour ?
                                                ""
                                                :
                                                perhourFrequencyCondition === false ?
                                                  "" :
                                                  <label className="fcol-form-label align-center">
                                                    {itemChargeBasis.pricing_queries}
                                                  </label>

                                            }
                                            {
                                              showSelect && perhourFrequencyCondition ? (
                                                <select className="form-select custom-select-pink"
                                                  disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                  name={`chargeBasisQuery_${index}`}
                                                  //value={quoteEnterDefaultValue?.[index]?.chargetype_rule_id}
                                                  value={quoteEnterDefaultValue?.find(v => v.chargebasis_id == chargeBasisId)?.chargetype_rule_id}
                                                  onChange={(e) => inputChangeChargeBasisFun(e, itemChargeBasis, index, 'dropdown')}
                                                >
                                                  {
                                                    itemChargeBasis?.ChargeTypes?.map((option, index1) => {
                                                      return (
                                                        <option key={index1} value={option.id}>
                                                          {option.name}
                                                        </option>
                                                      );
                                                    })
                                                  }
                                                </select>
                                              )
                                                :
                                                showInput ?
                                                  (
                                                    <input type="text"
                                                      disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                      className="form-control custom-input-pink"
                                                      name={`chargeBasisQuery_${index}`}
                                                      // value={quoteEnterDefaultValue?.[index]?.inputValue}
                                                      value={quoteEnterDefaultValue?.find(v => v.chargebasis_id == chargeBasisId)?.inputValue}
                                                      onChange={(e) => inputChangeChargeBasisFun(e, itemChargeBasis, index, 'input')}
                                                    />
                                                  )
                                                  :
                                                  showInputHour ?
                                                    (
                                                      <>

                                                        <div className="d-flex gap-4 ">
                                                          <div className="position-relative ">

                                                            <div className="tooltip-custom-div d-flex gap-2">
                                                              <div className="tooltip-custom-rate">
                                                                Rate can be adjusted as required.
                                                              </div>
                                                              <label >
                                                                Rate
                                                              </label>
                                                              <Info
                                                                size={16}
                                                                style={{ cursor: "pointer" }}
                                                              />

                                                            </div>


                                                            <input type="text"
                                                              disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                              className="form-control custom-input-pink"
                                                              name={`hoursQuery_${index}`}
                                                              value={currentChargeBasis?.rate}
                                                              onChange={(e) => inputChangeChargeBasisFun(e, itemChargeBasis, index, 'rate', "service", item, currentChargeBasis)}
                                                            />

                                                            {
                                                              rateError[item.id + '_' + currentChargeBasis.id] &&
                                                              <div className="text-danger"
                                                                style={{
                                                                  position: "absolute",
                                                                  fontSize: "12px",
                                                                  marginTop: "2px",
                                                                  whiteSpace: "nowrap",
                                                                  display: "block",

                                                                }}>
                                                                {rateError[item.id + '_' + currentChargeBasis.id]}
                                                              </div>

                                                            }

                                                          </div>

                                                          <div className="position-relative ">

                                                            <div className="tooltip-custom-div d-flex gap-2">
                                                              <label>
                                                                {itemChargeBasis?.pricing_queries}
                                                              </label>

                                                              <Info
                                                                size={16}

                                                                style={{ cursor: "pointer" }}
                                                              />
                                                              <div className="tooltip-custom-rate-1">
                                                                Enter '0' hours to keep the Time & Fees billing model. If you want Fixed Fees billing, enter the required number of hours to set a fixed hour limit.
                                                              </div>
                                                            </div>

                                                            <input type="text"
                                                              disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                              className="form-control custom-input-pink"
                                                              name={`hoursQuery_${index}`}
                                                              value={currentChargeBasis?.inputValueHour}
                                                              onChange={(e) => inputChangeChargeBasisFun(e, itemChargeBasis, index, 'input', "service", item, currentChargeBasis)}
                                                            />

                                                            {/* Validation Message */}
                                                            {["", undefined, null].includes(currentChargeBasis?.inputValueHour) && (
                                                              <div
                                                                className="text-danger"
                                                                style={{
                                                                  position: "absolute",
                                                                  fontSize: "12px",
                                                                  marginTop: "2px",
                                                                  whiteSpace: "nowrap",
                                                                  display: "block"
                                                                }}
                                                              >
                                                                Please enter the value.
                                                              </div>
                                                            )}
                                                          </div>

                                                        </div>


                                                      </>
                                                    )
                                                    :
                                                    ""
                                            }
                                          </div>
                                        );
                                      });

                                  if (
                                    item?.default_chargebasis_id != null &&
                                    Number(item?.default_chargebasis_status) === 1
                                  ) {
                                    let matchId = item?.default_chargebasis_id;

                                    if (!['', null, undefined].includes(item?.setDefaultId)) {
                                      matchId = item?.setDefaultId;
                                    }


                                    if (!['', null, undefined].includes(item?.sell_chargebasis_id)) {
                                      matchId = item?.sell_chargebasis_id;
                                    }

                                    const defaultBasis = item?.ServiceChargeBases?.find(
                                      b => b?.ChargeBasis?.id === matchId
                                    );
                                    //  BasisType 6 → hide
                                    if (defaultBasis?.ChargeBasis?.BasisType?.id === 6) {
                                      return null;
                                    }

                                    const service = item;
                                    item = {
                                      ...item,
                                      ServiceChargeBases: service?.ServiceChargeBases.filter(cb =>
                                        cb.ChargeBasis?.id === matchId
                                      )
                                    };

                                    return renderChargeBasis();
                                  } else {   // Frequency Condition show charge Basis


                                    const service = item;
                                    if (Number(service?.custom_rule == 1) && Number(service?.frequency_status == 1) && Number(service?.link_frequency_rule) === 0) {


                                      let matchId = service?.frequency_optional_chargebasis_id;

                                      if (!['', null, undefined].includes(item?.sell_chargebasis_id)) {
                                        matchId = item?.sell_chargebasis_id;
                                      }

                                      item = {
                                        ...service,
                                        ServiceChargeBases: service?.ServiceChargeBases.filter(cb =>
                                          cb.ChargeBasis?.id === matchId ||
                                          cb.ChargeBasis?.BasisType?.id === 4
                                        )
                                      };
                                      return renderChargeBasis();
                                    } else {

                                      // custom rule condition Show Charge Basis
                                      return renderChargeBasis();
                                    }

                                  }

                                  // return renderChargeBasis();
                                })()
                              }



                              {/* Self Assesment Service Chargebasis */}

                              {
                                Number(item.incremental_rule) === 1 ?
                                  <div className="table-responsive px-4">

                                    {
                                      Number(item.incremental_rule) === 1 && !shownIncrementalInput && (
                                        (() => {
                                          shownIncrementalInput = true;
                                          return (
                                            <div className="col-md-6 pe-lg-5 mb-3">
                                              <label className="col-form-label">
                                                How many self assessments do you need?
                                              </label>
                                              <input
                                                disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                type="text"
                                                className="form-control"
                                                name="needSelfAssessmentCount"
                                                value={selfAssessmentCount}
                                                onChange={(e) => inputChangeChargeBasisFun(e)}
                                                placeholder="Enter number of self assessments"
                                              />
                                            </div>
                                          );
                                        })()
                                      )
                                    }


                                    <table className="table border">
                                      <thead>
                                        <tr>
                                          <td
                                            style={{
                                              background: "#F5F5F5",
                                              color: "#4E4E4E",
                                              fontSize: "14px",
                                            }}
                                          >
                                            Queries
                                          </td>
                                          {individuals.map((name, idx) => (
                                            <td
                                              width={"300px"}
                                              key={idx}
                                              style={{
                                                background: "#F5F5F5",
                                                color: "#4E4E4E",
                                                fontSize: "14px",

                                              }}
                                            >
                                              {name}
                                            </td>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {

                                          quoteIndividualSetValue
                                            ?.map((b, originalIndex) => {
                                              const serviceBasisIds = new Set(
                                                item?.ServiceChargeBases?.map(s => s.ChargeBasis.id)
                                              );
                                              if (!serviceBasisIds.has(b.chargebases_id)) return null;
                                              if (usedChargeBasisSelfAssesment.has(b.chargebases_id)) return null;
                                              usedChargeBasisSelfAssesment.add(b.chargebases_id);
                                              return { ...b, originalIndex };
                                            })
                                            ?.filter(row => row !== null)
                                            ?.map((q) => (
                                              <tr key={q.originalIndex}>
                                                <td className="fs-14">
                                                  <div style={{ width: '300px' }}>{q.name}</div>
                                                </td>

                                                {selfAssessmentCount !== '' &&
                                                  q?.individual?.map((ind_item, indIndex) => (

                                                    <td className="fs-14" key={indIndex}>
                                                      <div style={{ width: '150px', padding: '0px 15px 0 0' }}>

                                                        {Number(q.basistypes_id === 5) ? (
                                                          <div className="d-flex">

                                                            <div className="form-check">
                                                              <input
                                                                disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`name_${q.originalIndex}_ind_${indIndex}`}
                                                                id={`yes_q${q.originalIndex}_i${indIndex}`}
                                                                checked={ind_item.radio_option === "1"}
                                                                onChange={(e) =>
                                                                  inputChangeChargeBasisFun(e, q, q.originalIndex, 'radio')
                                                                }
                                                              />
                                                              <label
                                                                className="form-check-label"
                                                                htmlFor={`yes_q${q.originalIndex}_i${indIndex}`}
                                                              >
                                                                Yes
                                                              </label>
                                                            </div>

                                                            <div className="form-check ms-3">
                                                              <input
                                                                disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`name_${q.originalIndex}_ind_${indIndex}`}
                                                                id={`no_q${q.originalIndex}_i${indIndex}`}
                                                                value="no"
                                                                checked={ind_item.radio_option === "0"}
                                                                onChange={(e) =>
                                                                  inputChangeChargeBasisFun(e, q, q.originalIndex, 'radio')
                                                                }
                                                              />
                                                              <label
                                                                className="form-check-label"
                                                                htmlFor={`no_q${q.originalIndex}_i${indIndex}`}
                                                              >
                                                                No
                                                              </label>
                                                            </div>

                                                          </div>
                                                        ) : (
                                                          <input
                                                            disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                                            type="text"
                                                            className="form-control"
                                                            name={`name_${q.originalIndex}_ind_${indIndex}`}
                                                            id={`input_q${q.originalIndex}_i${indIndex}`}
                                                            value={ind_item.inputValue}
                                                            onChange={(e) =>
                                                              inputChangeChargeBasisFun(e, q, q.originalIndex, 'input')
                                                            }
                                                          />
                                                        )}

                                                      </div>
                                                    </td>

                                                  ))}
                                              </tr>
                                            ))
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                  : ""
                              }



                              {/* Total Cost Section */}
                              <div className="col-lg-3 col-md-6 text-end ms-auto">
                                <label className="form-label text-muted small">Total Cost</label>
                                <div className="price text-pink">
                                  £{
                                    (() => {


                                      const basisId = item.sell_chargebasis_id || item.default_chargebasis_id;
                                      const matched = item.ServiceChargeBases.find(chargeBase =>
                                        chargeBase.ChargeBasis?.id === basisId &&
                                        chargeBase.ChargeBasis?.BasisType?.id === 2
                                      );

                                      if (matched && parseFloat(item?.price) === 0) {
                                        return roundNumber(matched?.rate) || "0.00";
                                      }


                                      if (Number(item?.servicetype_id) == 2) {
                                        const value =
                                          (item?.price * (1 + increasePremiumFinalOneOff / 100)) *
                                          (1 - discountValueFinalOneOff / 100);

                                        return roundNumber(value);
                                      } else {

                                        const value =
                                          (item?.price * (1 + increasePremiumFinal / 100)) *
                                          (1 - discountValueFinal / 100);

                                        return roundNumber(value);

                                      }

                                    })()
                                  }

                                </div>
                              </div>
                            </div>

                          </div>
                          <div className="card-footer text-end mt-4">
                            <button
                              className="icon-btn text-end ms-auto btn p-0"
                              disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                            >
                              <Trash2 className="text-dark"

                                onClick={() => handleDeleteService(index, 'service')}
                              ></Trash2></button>
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>


              {/* complexity Risk Start ---------> */}

              <div className="card p-3">
                <div className="card-header border-0 bg-transparent">
                  <div className="row">
                    <div className="col-md-6">
                      <h4 className="page-title" >
                        Multipliers
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="card-body">

                  <div className="row align-items-end mb-4 mt-3">
                    <div className="col-md-4 mb-3 ss">

                      <label className="col-form-label mb-2 py-0 me-2 sss label-height-new">Complexity & Risk: </label>
                      <div className=""
                        onClick={(e) => handleSliderComplexityClick(e)}
                        style={{ cursor: 'pointer' }}


                      >
                        <RangeSlider
                          className="single-thumb"
                          // defaultValue={[0, 50]}
                          value={sliderValueComplexity}
                          thumbsDisabled={[true, false]}
                          rangeSlideDisabled={true}


                        />

                        <div className="d-flex justify-content-between mt-2">
                          {Object.keys(levels).map((label, i) => (

                            <label
                              key={i}
                              className={`col-form-label range-label pt-0 ${selectedLabelComplexity === label ? "fw-bold " : ''} ${i > 0 ? 'ms-3' : ''}`}
                              // onClick={() => handleLabelComplexityClick(label)}
                              onClick={() => {
                                if (Number(higherDiscountStatus) !== 1) {
                                  handleLabelComplexityClick(label);
                                }
                              }}

                              style={{
                                cursor: 'pointer',

                              }}
                            >
                              {/* {label} */}
                              {label?.toLocaleLowerCase() == "default" ? "Zero" : label}
                            </label>
                          ))}
                        </div>
                      </div>


                    </div>

                    {/* <div className="col-md-4 mb-5">
                      <label className="col-form-label mb-2 py-0 me-2">  Risk: </label>
                      <div className=""
                        onClick={(e) => handleSliderRiskClick(e)}
                        style={{ cursor: 'pointer' }}

                      >
                        <RangeSlider
                          className="single-thumb"
                          // defaultValue={[0, 50]}
                          value={sliderValueRisk}
                          thumbsDisabled={[true, false]}
                          rangeSlideDisabled={true}
                        />
                        <div className="d-flex justify-content-between mt-2">
                          {Object.keys(levels).map((label, i) => (

                            <label
                              key={i}
                              className={`col-form-label range-label  pt-0 ${selectedLabelRisk === label ? "fw-bold " : ''} ${i > 0 ? 'ms-3' : ''}`}
                             
                              onClick={() => {
                                if (Number(higherDiscountStatus) !== 1) {
                                  handleLabelRiskClick(label);
                                }
                              }}
                              style={{
                                cursor: 'pointer',

                              }}
                            >
                              {label}
                            </label>
                          ))}
                        </div>
                      </div>
                    </div> */}

                    <div className="col-md-4  mb-3 ss">
                      <label className="col-form-label mb-2 py-0 me-2 sss label-height-new">  Quality of Data: </label>
                      <div className=""
                        onClick={(e) => handleSliderQualityDataClick(e)}
                        style={{ cursor: 'pointer' }}

                      >
                        <RangeSlider
                          className="single-thumb"
                          // defaultValue={[0, 50]}
                          value={sliderValueQualityData}
                          thumbsDisabled={[true, false]}
                          rangeSlideDisabled={true}
                        />
                        <div className="d-flex justify-content-between mt-2">
                          {Object.keys(levels).map((label, i) => (

                            <label
                              key={i}
                              className={`col-form-label range-label pt-0 ${selectedLabelQualityData === label ? "fw-bold " : ''} ${i > 0 ? 'ms-3' : ''}`}

                              onClick={() => {
                                if (Number(higherDiscountStatus) !== 1) {
                                  handleLabelQualityDataClick(label);
                                }
                              }}
                              style={{
                                cursor: 'pointer',
                                // color: selectedLabelRisk === label ? '#ff00aa' : '#000000',
                              }}
                            >
                              {label?.toLocaleLowerCase() == "default" ? "Excellent" : label?.toLocaleLowerCase() == "low" ? "Good" : label?.toLocaleLowerCase() == "medium" ? "Average" : label?.toLocaleLowerCase() == "high" ? "Poor" : label}
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4  mb-3 ss">
                      <label className="col-form-label mb-2 py-0 me-2 sss label-height-new"> Meeting frequency and access to seniors/experts: </label>
                      <div className=""
                        onClick={(e) => handleSliderFrequencyMeetingClick(e)}
                        style={{ cursor: 'pointer' }}

                      >
                        <RangeSlider
                          className="single-thumb"
                          // defaultValue={[0, 50]}
                          value={sliderValueFrequencyMeeting}
                          thumbsDisabled={[true, false]}
                          rangeSlideDisabled={true}
                        />
                        <div className="d-flex justify-content-between mt-2">
                          {Object.keys(levels).map((label, i) => (

                            <label
                              key={i}
                              className={`col-form-label range-label pt-0 ${selectedLabelFrequencyMeeting === label ? "fw-bold " : ''} ${i > 0 ? 'ms-3' : ''}`}

                              onClick={() => {
                                if (Number(higherDiscountStatus) !== 1) {
                                  handleLabelFrequencyMeetingClick(label);
                                }
                              }}
                              style={{
                                cursor: 'pointer',
                                // color: selectedLabelRisk === label ? '#ff00aa' : '#000000',
                              }}
                            >
                              {/* {label} */}
                              {label?.toLocaleLowerCase() == "default" ? "Zero/Minimal" : label}
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-md-4 mb-3">
                      <label className="col-form-label mb-2 py-0 me-2"> Access to Seniors/ Experts: </label>
                      <div className=""
                        onClick={(e) => handleSliderAccessSeniorClick(e)}
                        style={{ cursor: 'pointer' }}

                      >
                        <RangeSlider
                          className="single-thumb"
                          // defaultValue={[0, 50]}
                          value={sliderValueAccessSenior}
                          thumbsDisabled={[true, false]}
                          rangeSlideDisabled={true}
                        />
                        <div className="d-flex justify-content-between mt-2">
                          {Object.keys(levels).map((label, i) => (

                            <label
                              key={i}
                              className={`col-form-label range-label pt-0 ${selectedLabelAccessSenior === label ? "fw-bold " : ''} ${i > 0 ? 'ms-3' : ''}`}
                             
                              onClick={() => {
                                if (Number(higherDiscountStatus) !== 1) {
                                  handleLabelAccessSeniorClick(label);
                                }
                              }}
                              style={{
                                cursor: 'pointer',
                                // color: selectedLabelRisk === label ? '#ff00aa' : '#000000',
                              }}
                            >
                              {label}
                            </label>
                          ))}
                        </div>
                      </div>
                    </div> */}

                    {
                      (addedService.length > 0 && addedService?.find(item => [1, 3].includes(Number(item?.servicetype_id)))) || packagesServiceData.length > 0 ?
                        <>
                          <div className="col-md-3  mb-3 ss">
                            <label className="col-form-label mb-2 py-0 me-2 sss">  Payment Type : </label>
                            <div className="d-flex justify-content-between mt-2">
                              {/*select box*/}
                              <select className="form-select custom-select-pink pink-select my-select"
                                id="floatingSelect"
                                aria-label="Floating label select example"
                                //onChange={(e) => handlePaymentTypeChange(e , 'ongoing')}
                                onChange={(e) => {
                                  setPaymentTerm(e.target.value);
                                  setPaymentTypeOngoing(e.target.value);
                                  paymentTermModal(e);
                                  handleCombinedMultiplier(e, 'ongoing', 'payment');
                                }}
                                value={paymentTypeOngoing}
                                disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                              >
                                <option value="manual_payment_monthly">Non DD {paymentTypeOngoing == 'manual_payment_monthly' && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}</option>

                                <option value="monthly_dd">DD {paymentTypeOngoing == 'monthly_dd' && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}</option>

                                <option value="quarterly_dd">Quarterly DD {paymentTypeOngoing == 'quarterly_dd' && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}</option>

                                <option value="100_upfront">Upfront {paymentTypeOngoing == '100_upfront' && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}</option>
                                <option value="50_upfront">50-50 {paymentTypeOngoing == '50_upfront' && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3  mb-3 ss">
                            <label className="col-form-label mb-2 py-0 me-2 sss">  Contract Type : </label>
                            <div className="d-flex justify-content-between mt-2">
                              {/*select box*/}
                              <select className="form-select custom-select-pink pink-select my-select"
                                id="floatingSelect"
                                aria-label="Floating label select example"
                                // onChange={(e) => handleContractTypeChange(e , 'ongoing')}
                                onChange={(e) => {
                                  setContractTypeOngoing(e.target.value);
                                  handleCombinedMultiplier(e, 'ongoing', 'contract');
                                }}
                                value={contractTypeOngoing}
                                disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                              >
                                <option value="contract_type_ongoing">Ongoing</option>
                                <option value="contract_type_oneoff">One-off</option>
                                <option value="contract_type_payg">Pay As You Go</option>
                              </select>
                            </div>
                          </div>
                        </>
                        : ""
                    }


                    {
                      addedService.length > 0 && addedService?.find(item => [2].includes(Number(item?.servicetype_id))) ?
                        <>
                          <div className="col-md-3  mb-3 ss">
                            <label className="col-form-label mb-2 py-0 me-2 sss">Payment Type : </label>
                            <div className="d-flex justify-content-between mt-2">
                              {/*select box*/}
                              <select className="form-select custom-select-pink pink-select my-select"
                                id="floatingSelect"
                                aria-label="Floating label select example"
                                //onChange={(e) => handlePaymentTypeChange(e , 'oneoff')}
                                onChange={(e) => {
                                  setPaymentTermOneOff(e.target.value);
                                  setPaymentTypeOneOff(e.target.value);
                                  paymentTermModalOneOff(e);
                                  handleCombinedMultiplier(e, 'oneoff', 'payment');
                                }}
                                value={paymentTypeOneOff}
                                disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                              >
                                <option value="100_upfront">Upfront {paymentTypeOneOff == '100_upfront' && paymentTypeLableOneOff != undefined ? `( ${paymentTypeLableOneOff} )` : ""}</option>
                                <option value="50_upfront">50-50 {paymentTypeOneOff == '50_upfront' && paymentTypeLableOneOff != undefined ? `( ${paymentTypeLableOneOff} )` : ""}</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3  mb-3 ss">
                            <label className="col-form-label mb-2 py-0 me-2 sss">  Contract Type : </label>
                            <div className="d-flex justify-content-between mt-2">
                              {/*select box*/}
                              <select className="form-select custom-select-pink pink-select my-select"
                                id="floatingSelect"
                                aria-label="Floating label select example"
                                // onChange={(e) => handleContractTypeChange(e , 'oneoff')}
                                onChange={(e) => {
                                  setContractTypeOneOff(e.target.value);
                                  handleCombinedMultiplier(e, 'oneoff', 'contract');
                                }}
                                value={contractTypeOneOff}
                                disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                              >
                                <option value="contract_type_ongoing">Ongoing</option>
                                <option value="contract_type_oneoff">One-off</option>
                                <option value="contract_type_payg">Pay As You Go</option>
                              </select>
                            </div>
                          </div>
                        </>
                        : ""
                    }

                  </div>
                </div>
              </div>
              {/* -------  complexity Risk End ---------> */}

              {

                currentContractValue < ProposedContractValue() &&
                ![null, undefined, ""].includes(quoteData?.ExistClientContract) &&
                (
                  <>

                    {/* START --- ONGOING CONTRACT SUMMARY  */}
                    {


                      (
                        addedService.length > 0 &&
                        addedService?.find(item => {

                          if (![1, 3].includes(Number(item?.servicetype_id))) return false;

                          const basisId =
                            item.sell_chargebasis_id || item.default_chargebasis_id;

                          const matched = item?.ServiceChargeBases?.find(
                            chargeBase =>
                              chargeBase.ChargeBasis?.id === basisId &&
                              chargeBase.ChargeBasis?.BasisType?.id === 2
                          );

                          if (matched && parseFloat(item?.price) === 0) {
                            return false;
                          }

                          return true;
                        })
                      ) || packagesServiceData.length > 0 ?
                        <div className="cs-body">
                          <div className="wrapper1 mb-3">

                            <div className="top-row">
                              <h1>{contractTypeOngoing == 'contract_type_ongoing' ? 'Ongoing ' : contractTypeOngoing == 'contract_type_oneoff' ? 'One-Off ' : 'Pay As You Go '}
                                Contract Summary</h1>
                              <div className="toggle">
                                <span className="pill proposed">PROPOSED</span>
                                <span className="vs">VS</span>
                                <span className="pill current">CURRENT</span>
                              </div>
                            </div>

                            <div className="cs-compare-grid">

                              <div className="card">
                                <div className="card-title-new">Proposed Contract Summary</div>

                                <div className="inner-card">
                                  <div className="header-card">
                                    <span>Services</span>
                                    <span>Total</span>
                                  </div>

                                  <table className="cs-table">
                                    <tbody>


                                      {
                                        packagesServiceData && packagesServiceData?.map((item, index) => {
                                          let val = item;
                                          item = item?.Service;

                                          const basisId = item.sell_chargebasis_id || item.default_chargebasis_id;
                                          const matched = item.ServiceChargeBases.find(chargeBase =>
                                            chargeBase.ChargeBasis?.id === basisId &&
                                            chargeBase.ChargeBasis?.BasisType?.id === 2
                                          );

                                          if (matched && parseFloat(val?.price) === 0) {
                                            return
                                          }

                                          const proposedPrice = getProposedPrice(val?.price, item?.servicetype_id);

                                          return (

                                            <>
                                              <tr>
                                                <td>
                                                  <div className="service-name-flex">
                                                    <span className="service-name-new">{item?.name}</span>
                                                    {!isExistingService(item?.id) && (
                                                      <span className="new-badge">NEW</span>
                                                    )}
                                                  </div>
                                                  <div className="service-desc">
                                                    {item?.description}
                                                  </div>
                                                </td>
                                                <td className="price1">
                                                  £{proposedPrice}
                                                  {renderWasPrice(item?.id, proposedPrice)}
                                                </td>
                                              </tr>
                                            </>
                                          )
                                        })
                                      }

                                      {
                                        addedService && addedService?.
                                          filter(item => [1, 3].includes(Number(item.servicetype_id)))
                                          .map((item, index) => {

                                            const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
                                            const matched = item?.ServiceChargeBases.find(chargeBase =>
                                              chargeBase.ChargeBasis?.id === basisId &&
                                              chargeBase.ChargeBasis?.BasisType?.id === 2
                                            );
                                            if (matched && parseFloat(item?.price) === 0) {
                                              return
                                            }

                                            const proposedPrice = getProposedPrice(item?.price, item?.servicetype_id);

                                            return (
                                              <>
                                                <tr>
                                                  <td>
                                                    <div className="service-name-flex">
                                                      <span className="service-name-new">{item?.name}</span>
                                                      {!isExistingService(item?.id) && (
                                                        <span className="new-badge">NEW</span>
                                                      )}
                                                    </div>
                                                    <div className="service-desc">
                                                      {item?.description}
                                                    </div>
                                                  </td>
                                                  <td className="price1">
                                                    £{proposedPrice}
                                                    {renderWasPrice(item?.id, proposedPrice)}
                                                  </td>
                                                </tr>
                                              </>
                                            )
                                          })
                                      }





                                    </tbody>
                                  </table>
                                </div>

                                <div className="summary-box">
                                  <div className="summary-row bold">
                                    <span className="label">Total cost of services</span>
                                    <span className="value summary-value-pink">£{roundNumber(totalCost)}</span>
                                  </div>

                                  <div className="summary-row">
                                    <span className="label">Discount (%)</span>
                                    <input type="text" name="discount" min={0}
                                      value={(discount)}
                                      disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                      onChange={(e) => InputChangeDiscountPremium(e)}
                                      className="input-box" />
                                    {
                                      errorDiscount ? <span className="text-danger">Discount can not be less than {packageDefaultDiscount}</span> : ""
                                    }
                                  </div>

                                  <div className="summary-row">
                                    <span className="label">Premium (%)</span>

                                    <input type="text" name="premium"
                                      value={premium}
                                      disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                      onChange={(e) => InputChangeDiscountPremium(e)}
                                      className="input-box" />
                                  </div>

                                  {/* <hr className="divider" /> */}

                                  <div className="summary-row bold">
                                    <span className="label">Net Cost of Services</span>
                                    <span className="value summary-value-pink">£{roundNumber(totalCostWithDiscount)}</span>
                                  </div>
                                  <div className="summary-row sub">
                                    <span className="label">VAT</span>
                                    <span className="value">£{roundNumber(vat)}</span>
                                  </div>
                                  <div className="summary-row bold">
                                    <span className="label">
                                      Total (Including VAT)
                                    </span>
                                    <span className="value summary-value-pink">£{roundNumber(totalIncludingVAT)}</span>
                                  </div>
                                  <div className="summary-row sub">
                                    <span className="label">{{
                                      monthly_dd: "Total Monthly Cost",
                                      manual_payment_monthly: "Total Monthly Cost",
                                      quarterly_dd: "Total Quarterly Cost",
                                      manual_payment_quarterly: "Total Quarterly Cost",
                                      "100_upfront": "Total Upfront Cost (100%)",
                                      "100_post_completion": "Total Post Completion Cost (100%)",
                                      "50_upfront": "Total Upfront Cost (50%)",
                                    }[paymentTerm] || "Total Monthly Cost"} (Excluding VAT)</span>
                                    <span className="value">£{roundNumber(totalMonthlyCostExcluding)}</span>
                                  </div>
                                  <div className="summary-row bold">
                                    <span className="label">
                                      {{
                                        monthly_dd: "Total Monthly Cost",
                                        manual_payment_monthly: "Total Monthly Cost",
                                        quarterly_dd: "Total Quarterly Cost",
                                        manual_payment_quarterly: "Total Quarterly Cost",
                                        "100_upfront": "Total Upfront Cost (100%)",
                                        "100_post_completion": "Total Post Completion Cost (100%)",
                                        "50_upfront": "Total Upfront Cost (50%)",
                                      }[paymentTerm] || "Total Monthly Cost"} (Including VAT)
                                    </span>
                                    <span className="value summary-value-pink">£{roundNumber(totalMonthlyCost)}</span>
                                  </div>
                                </div>
                              </div>

                              <div className="card">
                                <div className="justify-content-between d-flex">
                                  <div className="card-title-new-current">Current Contract Summary</div>
                                  <span className="ccs-reference">Reference</span>
                                </div>
                                <div className="inner-card-current">
                                  <div className="ccs-thead ccs-row">
                                    <span>Services</span>
                                    <span>Total</span>
                                  </div>

                                  <table className="cs-table">
                                    <tbody>


                                      {


                                        quoteData?.ExistClientContract?.ContractPackageServices &&
                                        quoteData?.ExistClientContract?.ContractPackageServices?.
                                          filter(item => [1, 3, 4].includes(Number(item?.Service?.servicetype_id)))
                                          .map((item1, index) => {
                                            let item = item1?.Service
                                            // console.log("item ====>>", item)
                                            const basisId = item1?.sell_chargebasis_id || item?.default_chargebasis_id;
                                            const matched = item?.ServiceChargeBases.find(chargeBase =>
                                              chargeBase.ChargeBasis?.id === basisId &&
                                              chargeBase.ChargeBasis?.BasisType?.id === 2
                                            );
                                            if (matched && parseFloat(item1?.price) === 0) {
                                              return
                                            }
                                            totalCostCurrento_ongoing += parseFloat(item1?.price) || 0;



                                            return (

                                              <>
                                                <tr>
                                                  <td>
                                                    <div className="service-name-flex">
                                                      <span className="service-name-new-current">{item?.name}</span>
                                                      <span>  </span>
                                                    </div>
                                                    <div className="service-desc">
                                                      {item?.description}
                                                    </div>
                                                  </td>

                                                  <td className="price1">
                                                    £{roundNumber(item1?.price)}
                                                    {renderWasSpacer(item?.id)}
                                                  </td>
                                                </tr>
                                              </>
                                            )
                                          })
                                      }

                                    </tbody>
                                  </table>
                                </div>

                                <div className="summary-box">
                                  <div className="summary-row bold">
                                    <span className="label">Total cost of services</span>
                                    <span className="value summary-value-pink">£{roundNumber(totalCostCurrento_ongoing)}</span>
                                  </div>

                                  <div className="summary-row">
                                    <span className="label">Discount (%)</span>
                                    <input className="input-box-d" type="text" value={[null, undefined, ""
                                    ].includes(quoteData?.ExistClientContract?.discount_ongoing) ? "0.00" :
                                      Number(quoteData?.ExistClientContract?.discount_ongoing).toFixed(2)} disabled />
                                  </div>

                                  <div className="summary-row">
                                    <span className="label">Premium (%)</span>
                                    <input className="input-box-d" type="text" value={[null, undefined, ""
                                    ].includes(quoteData?.ExistClientContract?.premium_ongoing) ? "0.00" :
                                      Number(quoteData?.ExistClientContract?.premium_ongoing).toFixed(2)} disabled />
                                  </div>


                                  <div className="summary-row bold">
                                    <span className="label">Net Cost of Services</span>

                                    {/* <span className="value summary-value-pink">£{roundNumber(totalCostCurrento_ongoing * (1 -
                                      (quoteData?.ExistClientContract?.cmDiscountOngoing || 0) / 100) * (1 -
                                        (quoteData?.ExistClientContract?.discount_ongoing || 0) / 100))}</span> */}
                                    <span className="value summary-value-pink">£{roundNumber(totalCostCurrento_ongoing * (1 -
                                      (quoteData?.ExistClientContract?.discount_ongoing || 0) / 100))
                                    }</span>

                                  </div>
                                  <div className="summary-row sub">
                                    <span className="label">VAT</span>
                                    <span className="value">£{roundNumber(quoteData?.ExistClientContract?.vat_ongoing)}</span>
                                  </div>
                                  <div className="summary-row bold">
                                    <span className="label">
                                      Total (Including VAT)
                                    </span>
                                    {/* <span className="value summary-value-pink">£{roundNumber(totalCostCurrento_ongoing * (1 -
                                      (quoteData?.ExistClientContract?.cmDiscountOngoing || 0) / 100) * (1 -
                                        (quoteData?.ExistClientContract?.discount_ongoing || 0) / 100) +
                                      quoteData?.ExistClientContract?.vat_ongoing)}</span> */}
                                    <span className="value summary-value-pink">£{roundNumber(totalCostCurrento_ongoing * (1 -
                                      (quoteData?.ExistClientContract?.discount_ongoing || 0) / 100) +
                                      quoteData?.ExistClientContract?.vat_ongoing)}</span>
                                  </div>
                                  <div className="summary-row sub">
                                    <span className="label">{{
                                      monthly_dd: "Total Monthly Cost",
                                      manual_payment_monthly: "Total Monthly Cost",
                                      quarterly_dd: "Total Quarterly Cost",
                                      manual_payment_quarterly: "Total Quarterly Cost",
                                      "100_upfront": "Total Upfront Cost (100%)",
                                      "100_post_completion": "Total Post Completion Cost (100%)",
                                      "50_upfront": "Total Upfront Cost (50%)",
                                    }[quoteData?.ExistClientContract?.payment_term_ongoing] || "Total Monthly Cost"} (Excluding VAT)</span>

                                    <span className="value">£{roundNumber(quoteData?.ExistClientContract?.total_monthly_excluding_ongoing)}</span>
                                  </div>
                                  <div className="summary-row bold">
                                    <span className="label">
                                      {{
                                        monthly_dd: "Total Monthly Cost",
                                        manual_payment_monthly: "Total Monthly Cost",
                                        quarterly_dd: "Total Quarterly Cost",
                                        manual_payment_quarterly: "Total Quarterly Cost",
                                        "100_upfront": "Total Upfront Cost (100%)",
                                        "100_post_completion": "Total Post Completion Cost (100%)",
                                        "50_upfront": "Total Upfront Cost (50%)",
                                      }[quoteData?.ExistClientContract?.payment_term_ongoing] || "Total Monthly Cost"} (Including VAT)
                                    </span>
                                    <span
                                      className="value summary-value-pink">£{roundNumber(quoteData?.ExistClientContract?.total_monthly_ongoing)}</span>
                                  </div>
                                </div>
                              </div>

                            </div>

                          </div>
                        </div>
                        : ""}
                    {/* END --- ONGOING CONTRACT SUMMARY  */}


                    {/* START --- ONE-OFF CONTRACT SUMMARY  */}
                    {

                      addedService.length > 0 &&
                        addedService?.find(item => {

                          if (![2].includes(Number(item?.servicetype_id))) return false;

                          const basisId =
                            item.sell_chargebasis_id || item.default_chargebasis_id;

                          const matched = item?.ServiceChargeBases?.find(
                            chargeBase =>
                              chargeBase.ChargeBasis?.id === basisId &&
                              chargeBase.ChargeBasis?.BasisType?.id === 2
                          );

                          if (matched && parseFloat(item?.price) === 0) {
                            return false;
                          }

                          return true;
                        }) ?
                        <div className="cs-body">
                          <div className="wrapper1 mb-3">

                            <div className="top-row">
                              <h1>{contractTypeOneOff == 'contract_type_ongoing' ? 'Ongoing ' : contractTypeOneOff == 'contract_type_oneoff' ? 'One-Off ' : 'Pay As You Go '}
                                Contract Summary</h1>

                              <div className="toggle">
                                <span className="pill proposed">PROPOSED</span>
                                <span className="vs">VS</span>
                                <span className="pill current">CURRENT</span>
                              </div>

                            </div>

                            <div className="cs-compare-grid">

                              <div className="card">
                                <div className="card-title-new">Proposed Contract Summary</div>

                                <div className="inner-card">
                                  <div className="header-card">
                                    <span>Services</span>
                                    <span>Total</span>
                                  </div>

                                  <table className="cs-table">
                                    <tbody>

                                      {


                                        addedService && addedService?.
                                          filter(item => [2].includes(Number(item.servicetype_id)))
                                          .map((item, index) => {

                                            const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
                                            const matched = item?.ServiceChargeBases.find(chargeBase =>
                                              chargeBase.ChargeBasis?.id === basisId &&
                                              chargeBase.ChargeBasis?.BasisType?.id === 2
                                            );
                                            if (matched && parseFloat(item?.price) === 0) {
                                              return
                                            }

                                            const proposedPrice = getProposedPrice(item?.price, item?.servicetype_id);

                                            return (
                                              <>
                                                <tr>
                                                  <td>
                                                    <div className="service-name-flex">
                                                      <span className="service-name-new">{item?.name}</span>
                                                      {!isExistingService(item?.id) && (
                                                        <span className="new-badge">NEW</span>
                                                      )}
                                                    </div>
                                                    <div className="service-desc">
                                                      {item?.description}
                                                    </div>
                                                  </td>
                                                  <td className="price1">
                                                    £{proposedPrice}
                                                    {renderWasPrice(item?.id, proposedPrice)}
                                                  </td>
                                                </tr>
                                              </>
                                            )
                                          })
                                      }





                                    </tbody>
                                  </table>
                                </div>

                                <div className="summary-box">
                                  <div className="summary-row bold">
                                    <span className="label">Total cost of services</span>
                                    <span className="value summary-value-pink">£{roundNumber(totalCostOneOff)}</span>
                                  </div>

                                  <div className="summary-row">
                                    <span className="label">Discount (%)</span>

                                    <input type="text"
                                      name="discount"
                                      min={0}
                                      value={(discountOneOff)}
                                      disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                      onChange={(e) => InputChangeDiscountPremiumOneOff(e)}
                                      className="input-box" />
                                    {
                                      errorDiscount ? <span className="text-danger">Discount can not be less than {packageDefaultDiscount}</span> : ""
                                    }
                                  </div>

                                  <div className="summary-row">
                                    <span className="label">Premium (%)</span>


                                    <input type="text"
                                      name="premium"
                                      value={premiumOneOff}
                                      disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                      onChange={(e) => InputChangeDiscountPremiumOneOff(e)}
                                      className="input-box" />
                                  </div>

                                  {/* <hr className="divider" /> */}

                                  <div className="summary-row bold">
                                    <span className="label">Net Cost of Services</span>
                                    <span className="value summary-value-pink">£{roundNumber(totalCostWithDiscountOneOff)}</span>
                                  </div>
                                  <div className="summary-row sub">
                                    <span className="label">VAT</span>
                                    <span className="value">£{roundNumber(vatOneOff)}</span>
                                  </div>
                                  <div className="summary-row bold">
                                    <span className="label">
                                      Total (Including VAT)
                                    </span>
                                    <span className="value summary-value-pink">£{roundNumber(totalIncludingVATOneOff)}</span>
                                  </div>
                                  <div className="summary-row sub">
                                    <span className="label">
                                      {{
                                        monthly_dd: "Total Monthly Cost",
                                        manual_payment_monthly: "Total Monthly Cost",
                                        quarterly_dd: "Total Quarterly Cost",
                                        manual_payment_quarterly: "Total Quarterly Cost",
                                        "100_upfront": "Total Upfront Cost (100%)",
                                        "100_post_completion": "Total Post Completion Cost (100%)",
                                        "50_upfront": "Total Upfront Cost (50%)",
                                      }[paymentTermOneOff] || "Total Monthly Cost"} (Excluding VAT)
                                    </span>
                                    <span className="value">£{roundNumber(totalMonthlyCostExcludingOneOff)}</span>
                                  </div>
                                  <div className="summary-row bold">
                                    <span className="label">
                                      {{
                                        monthly_dd: "Total Monthly Cost",
                                        manual_payment_monthly: "Total Monthly Cost",
                                        quarterly_dd: "Total Quarterly Cost",
                                        manual_payment_quarterly: "Total Quarterly Cost",
                                        "100_upfront": "Total Upfront Cost (100%)",
                                        "100_post_completion": "Total Post Completion Cost (100%)",
                                        "50_upfront": "Total Upfront Cost (50%)",
                                      }[paymentTermOneOff] || "Total Monthly Cost"} (Including VAT)
                                    </span>
                                    <span className="value summary-value-pink">£{roundNumber(totalMonthlyCostOneOff)}</span>
                                  </div>
                                </div>
                              </div>

                              <div className="card">
                                <div className="justify-content-between d-flex">
                                  <div className="card-title-new-current">Current Contract Summary</div>
                                  <span className="ccs-reference">Reference</span>
                                </div>
                                <div className="inner-card-current">
                                  <div className="ccs-thead ccs-row">
                                    <span>Services</span>
                                    <span>Total</span>
                                  </div>

                                  <table className="cs-table">
                                    <tbody>

                                      {

                                        quoteData?.ExistClientContract?.ContractPackageServices &&
                                        quoteData?.ExistClientContract?.ContractPackageServices?.
                                          filter(item => [2].includes(Number(item?.Service?.servicetype_id)))
                                          .map((item1, index) => {
                                            let item = item1?.Service
                                            // console.log("item ====>>", item)
                                            const basisId = item1?.sell_chargebasis_id ||
                                              item?.default_chargebasis_id;

                                            const matched = item?.ServiceChargeBases?.find(chargeBase =>
                                              chargeBase.ChargeBasis?.id === basisId &&
                                              chargeBase.ChargeBasis?.BasisType?.id === 2
                                            );

                                            if (matched && parseFloat(item1?.price) === 0) {
                                              return
                                            }
                                            totalCostCurrento_oneoff += parseFloat(item1?.price) || 0;

                                            return (

                                              <>
                                                <tr>
                                                  <td>
                                                    <div className="service-name-flex">
                                                      <span className="service-name-new-current">{item?.name}</span>
                                                      <span> </span>
                                                    </div>
                                                    <div className="service-desc">
                                                      {item?.description}
                                                    </div>
                                                  </td>

                                                  <td className="price1">
                                                    £{roundNumber(item1?.price)}
                                                    {renderWasSpacer(item?.id)}
                                                  </td>
                                                </tr>
                                              </>
                                            )
                                          })
                                      }

                                    </tbody>
                                  </table>
                                </div>

                                <div className="summary-box">
                                  <div className="summary-row bold">
                                    <span className="label">Total cost of services</span>
                                    <span
                                      className="value summary-value-pink">£{roundNumber(totalCostCurrento_oneoff)}</span>
                                  </div>

                                  <div className="summary-row">
                                    <span className="label">Discount (%)</span>
                                    <input className="input-box-d" type="text" value={[null, undefined,
                                      ""].includes(quoteData?.ExistClientContract?.discount_oneoff) ? "0.00" :
                                      Number(quoteData?.ExistClientContract?.discount_oneoff).toFixed(2)}
                                      disabled />
                                  </div>

                                  <div className="summary-row">
                                    <span className="label">Premium (%)</span>
                                    <input className="input-box-d" type="text" value={[null, undefined,
                                      ""].includes(quoteData?.ExistClientContract?.premium_oneoff) ? "0.00" :
                                      Number(quoteData?.ExistClientContract?.premium_oneoff).toFixed(2)}
                                      disabled />
                                  </div>

                                  {/* <hr className="divider" /> */}



                                  <div className="summary-row bold">
                                    <span className="label">Net Cost of Services</span>
                                    {/* <span
                                      className="value summary-value-pink">£{roundNumber(totalCostCurrento_oneoff
                                        * (1 - (quoteData?.ExistClientContract?.cmDiscountOneOff || 0) / 100) *
                                        (1 - (quoteData?.ExistClientContract?.discount_oneoff || 0) /
                                          100))}</span> */}
                                    <span
                                      className="value summary-value-pink">£{roundNumber(totalCostCurrento_oneoff
                                        *
                                        (1 - (quoteData?.ExistClientContract?.discount_oneoff || 0) / 100)
                                      )
                                      }</span>
                                  </div>
                                  <div className="summary-row sub">
                                    <span className="label">VAT</span>
                                    <span
                                      className="value">£{roundNumber(quoteData?.ExistClientContract?.vat_oneoff)}</span>
                                  </div>
                                  <div className="summary-row bold">
                                    <span className="label">
                                      Total (Including VAT)
                                    </span>
                                    {/* <span
                                      className="value summary-value-pink">£{roundNumber(totalCostCurrento_oneoff
                                        * (1 - (quoteData?.ExistClientContract?.cmDiscountOneOff || 0) / 100) *
                                        (1 - (quoteData?.ExistClientContract?.discount_oneoff || 0) / 100) +
                                        quoteData?.ExistClientContract?.vat_oneoff)}</span> */}
                                    <span
                                      className="value summary-value-pink">£{roundNumber(totalCostCurrento_oneoff
                                        *
                                        (1 - (quoteData?.ExistClientContract?.discount_oneoff || 0) / 100) +
                                        quoteData?.ExistClientContract?.vat_oneoff)}</span>
                                  </div>
                                  <div className="summary-row sub">
                                    <span className="label">
                                      {{
                                        monthly_dd: "Total Monthly Cost",
                                        manual_payment_monthly: "Total Monthly Cost",
                                        quarterly_dd: "Total Quarterly Cost",
                                        manual_payment_quarterly: "Total Quarterly Cost",
                                        "100_upfront": "Total Upfront Cost (100%)",
                                        "100_post_completion": "Total Post Completion Cost (100%)",
                                        "50_upfront": "Total Upfront Cost (50%)",
                                      }[quoteData?.ExistClientContract?.payment_term_oneoff] ||
                                        "Total Monthly Cost"} (Excluding VAT)
                                    </span>

                                    <span
                                      className="value">£{roundNumber(quoteData?.ExistClientContract?.total_monthly_excluding_oneoff)}</span>
                                  </div>
                                  <div className="summary-row bold">
                                    <span className="label">
                                      {{
                                        monthly_dd: "Total Monthly Cost",
                                        manual_payment_monthly: "Total Monthly Cost",
                                        quarterly_dd: "Total Quarterly Cost",
                                        manual_payment_quarterly: "Total Quarterly Cost",
                                        "100_upfront": "Total Upfront Cost (100%)",
                                        "100_post_completion": "Total Post Completion Cost (100%)",
                                        "50_upfront": "Total Upfront Cost (50%)",
                                      }[quoteData?.ExistClientContract?.payment_term_oneoff] ||
                                        "Total Monthly Cost"} (Including VAT)
                                    </span>
                                    <span
                                      className="value summary-value-pink">£{roundNumber(quoteData?.ExistClientContract?.total_monthly_oneoff)}</span>
                                  </div>
                                </div>
                              </div>

                            </div>

                          </div>


                        </div> : ""}
                    {/* END --- ONE-OFF CONTRACT SUMMARY  */}



                    {/* START --- HOURLY CONTRACT SUMMARY  */}
                    {
                      HourlyBillingArray?.length > 0 &&
                        HourlyBillingArray?.find(item => {
                          const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
                          const matched = item?.ServiceChargeBases?.find(
                            chargeBase =>
                              chargeBase?.ChargeBasis?.id === basisId &&
                              chargeBase?.ChargeBasis?.BasisType?.id === 2
                          );

                          if (matched && parseFloat(item?.price) === 0) {
                            return true;
                          }

                          return false;
                        }) ?
                        <div className="cs-body">
                          <div className="wrapper1 mb-3">

                            <div className="top-row">
                              <h1>Hourly Contract Summary</h1>

                              <div className="toggle">
                                <span className="pill proposed">PROPOSED</span>
                                <span className="vs">VS</span>
                                <span className="pill current">CURRENT</span>
                              </div>


                            </div>

                            <div className="cs-compare-grid">

                              <div className="card">
                                <div className="card-title-new">Proposed Contract Summary</div>

                                <div className="inner-card">
                                  <div className="header-card">
                                    <span>Services</span>
                                    <span>Total</span>
                                  </div>

                                  <table className="cs-table">
                                    <tbody>

                                      {

                                        HourlyBillingArray && HourlyBillingArray?.map((item, index) => {

                                          const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
                                          const matched = item?.ServiceChargeBases.find(chargeBase =>
                                            chargeBase?.ChargeBasis?.id === basisId &&
                                            chargeBase?.ChargeBasis?.BasisType?.id === 2
                                          );


                                          if (!matched) {
                                            return
                                          }

                                          if (matched && Number(item?.price) > 0) {
                                            return
                                          }

                                          const proposedRate = roundNumber(matched?.rate);

                                          return (
                                            <>


                                              <tr>
                                                <td><span className="service-name-new">{item?.name}</span></td>
                                                <td className="price1">£{proposedRate} + VAT
                                                  {renderWasPrice(item?.id, proposedRate, "rate")}</td>
                                              </tr>
                                            </>
                                          )
                                        })


                                      }
                                    </tbody>
                                  </table>
                                </div>

                                <div className="payment-type-div">
                                  <span>Payment Type</span>
                                  <span className="payment-type-div-value">On Invoice</span>
                                </div>

                              </div>

                              <div className="card">
                                <div className="justify-content-between d-flex">
                                  <div className="card-title-new-current">Current Contract Summary</div>
                                  <span className="ccs-reference">Reference</span>
                                </div>

                                <div className="inner-card-current">
                                  <div className="ccs-thead ccs-row">
                                    <span>Services</span>
                                    <span>Total</span>
                                  </div>

                                  <table className="cs-table">
                                    <tbody>

                                      {

                                        quoteData?.ExistClientContract?.ContractPackageServices &&
                                        quoteData?.ExistClientContract?.ContractPackageServices?.
                                          filter(item => Number(item?.price) === 0 && Number(item?.inputValueHour) === 0)
                                          .map((item1, index) => {
                                            let item = item1?.Service

                                            const basisId = item1?.sell_chargebasis_id || item?.default_chargebasis_id;
                                            const matched = item?.ServiceChargeBases.find(chargeBase =>
                                              chargeBase?.ChargeBasis?.id === basisId &&
                                              chargeBase?.ChargeBasis?.BasisType?.id === 2
                                            );

                                            if (!matched) {
                                              return
                                            }

                                            if (matched && Number(item1?.price) > 0) {
                                              return
                                            }

                                            return (
                                              <>


                                                <tr>
                                                  <td><span className="service-name-new-current">{item?.name}</span></td>
                                                  <td className="price1">£{roundNumber(item1?.rate)} + VAT</td>
                                                </tr>
                                              </>
                                            )
                                          })


                                      }
                                    </tbody>
                                  </table>
                                </div>

                                <div className="payment-type-div">
                                  <span>Payment Type</span>
                                  <span className="payment-type-div-value">On Invoice</span>
                                </div>

                              </div>

                            </div>

                          </div>

                        </div> : ""}
                    {/* END --- HOURLY CONTRACT SUMMARY  */}
                  </>
                )
              }


              <div className="card">
                <div className="card-body">

                  {/*------START-------Ongoing Contract Summary-----START-----*/}
                  {

                    (
                      ([null, undefined, ""].includes(quoteData?.ExistClientContract) || currentContractValue >= ProposedContractValue()) &&
                      addedService.length > 0 &&
                      addedService?.find(item => {

                        if (![1, 3].includes(Number(item?.servicetype_id))) return false;

                        const basisId =
                          item.sell_chargebasis_id || item.default_chargebasis_id;

                        const matched = item?.ServiceChargeBases?.find(
                          chargeBase =>
                            chargeBase.ChargeBasis?.id === basisId &&
                            chargeBase.ChargeBasis?.BasisType?.id === 2
                        );

                        if (matched && parseFloat(item?.price) === 0) {
                          return false;
                        }

                        return true;
                      })
                    ) || (
                      ([null, undefined, ""].includes(quoteData?.ExistClientContract) || currentContractValue >= ProposedContractValue()) && packagesServiceData.length > 0
                    ) ?

                      <div className="wrap " >
                        <h4 className="page-title text-pink py-4 ">
                          {contractTypeOngoing == 'contract_type_ongoing' ? 'Ongoing ' : contractTypeOngoing == 'contract_type_oneoff' ? 'One-Off ' : 'Pay As You Go '}
                          Contract Summary</h4>
                        <div className="summary-card" style={{ background: '#FFF4FB' }}>
                          <div className="row gx-4">
                            {/* LEFT: Services */}
                            <div className="col-md-12">
                              <div className="service-row">
                                <div className=" services-title" >Services</div>
                                <div className=" services-title">Total</div>
                              </div>


                              {
                                packagesServiceData && packagesServiceData?.map((item, index) => {
                                  let val = item;
                                  item = item?.Service;

                                  const basisId = item.sell_chargebasis_id || item.default_chargebasis_id;
                                  const matched = item.ServiceChargeBases.find(chargeBase =>
                                    chargeBase.ChargeBasis?.id === basisId &&
                                    chargeBase.ChargeBasis?.BasisType?.id === 2
                                  );

                                  if (matched && parseFloat(val?.price) === 0) {
                                    return
                                  }

                                  return (
                                    <div className="service-row">
                                      <div>
                                        <div className="service-name-new">{item?.name}</div>
                                        <div className="service-desc">{item?.description}</div>
                                      </div>
                                      <div className="service-amount">
                                        {/* £{
                                          (() => {
                                            const value =
                                              (val?.price * (1 + increasePremiumFinal / 100)) *
                                              (1 - discountValueFinal / 100);
                                            return roundNumber(value);
                                          })()
                                        } */}
                                        £{
                                          (() => {

                                            if (Number(item?.servicetype_id) == 2) {
                                              const value =
                                                (val?.price * (1 + increasePremiumFinalOneOff / 100)) *
                                                (1 - discountValueFinalOneOff / 100);

                                              return roundNumber(value);
                                            } else {
                                              const value =
                                                (val?.price * (1 + increasePremiumFinal / 100)) *
                                                (1 - discountValueFinal / 100);

                                              return roundNumber(value);
                                            }

                                          })()
                                        }
                                      </div>
                                    </div>
                                  )
                                })
                              }

                              {
                                addedService && addedService?.
                                  filter(item => [1, 3].includes(Number(item.servicetype_id)))
                                  .map((item, index) => {

                                    const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
                                    const matched = item?.ServiceChargeBases.find(chargeBase =>
                                      chargeBase.ChargeBasis?.id === basisId &&
                                      chargeBase.ChargeBasis?.BasisType?.id === 2
                                    );
                                    if (matched && parseFloat(item?.price) === 0) {
                                      return
                                    }

                                    return (
                                      <div className="service-row">
                                        <div>
                                          <div className="service-name-new">{item?.name}</div>
                                          <div className="service-desc">{item?.description}</div>
                                        </div>
                                        <div className="service-amount">
                                          £{
                                            (() => {

                                              // const basisId = item.sell_chargebasis_id || item.default_chargebasis_id;
                                              // const matched = item.ServiceChargeBases.find(chargeBase =>
                                              //   chargeBase.ChargeBasis?.id === basisId &&
                                              //   chargeBase.ChargeBasis?.BasisType?.id === 2
                                              // );

                                              // if (matched) {
                                              //   if (quoteData.quote.ContractPackageServices.length > 0
                                              //     && quoteData.quote.ContractPackageServices.find(service => service.service_id === item.id)?.higher_discount_status === 1
                                              //   ) {
                                              //     const approval_price = quoteData.quote.ContractPackageServices.find(service => service.service_id === item.id)?.approval_price || item.price;
                                              //     return approval_price

                                              //   } else {
                                              //     return (matched.price_rate).toFixed(2);
                                              //   }

                                              // } else {

                                              //   if (Number(item?.servicetype_id) == 2) {
                                              //     const value =
                                              //       (item?.price * (1 + increasePremiumFinalOneOff / 100)) *
                                              //       (1 - discountValueFinalOneOff / 100);

                                              //     return roundNumber(value);
                                              //   } else {
                                              //     const value =
                                              //       (item?.price * (1 + increasePremiumFinal / 100)) *
                                              //       (1 - discountValueFinal / 100);

                                              //     return roundNumber(value);

                                              //   }
                                              // }

                                              if (Number(item?.servicetype_id) == 2) {
                                                const value =
                                                  (item?.price * (1 + increasePremiumFinalOneOff / 100)) *
                                                  (1 - discountValueFinalOneOff / 100);

                                                return roundNumber(value);
                                              } else {
                                                const value =
                                                  (item?.price * (1 + increasePremiumFinal / 100)) *
                                                  (1 - discountValueFinal / 100);

                                                return roundNumber(value);
                                              }

                                            })()
                                          }
                                        </div>
                                      </div>
                                    )
                                  })
                              }


                            </div>
                            <div className="col-md-5"></div>
                            <div className="col-md-7 text-end">
                              <div className="right-block">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <label className="label col-form-label">Total cost of services</label>
                                  <div className="value">£{
                                    // totalCost.toFixed(2)
                                    roundNumber(totalCost)
                                  }</div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <label className="label col-form-label">Discount(%)</label>
                                  <div>
                                    <input type="text" name="discount" min={0}
                                      value={(discount)}
                                      disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                      onChange={(e) => InputChangeDiscountPremium(e)}
                                      className="form-control" />
                                    {
                                      errorDiscount ? <span className="text-danger">Discount can not be less than {packageDefaultDiscount}</span> : ""
                                    }
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <label className="label col-form-label">Premium(%)</label>
                                  <div>
                                    <input type="text" name="premium"
                                      value={premium}
                                      disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                      onChange={(e) => InputChangeDiscountPremium(e)}
                                      className="form-control" />
                                  </div>
                                </div>
                                <hr />
                                <div className="d-flex justify-content-end align-items-center mb-1">
                                  <div className="row w-100">
                                    <div className="col-md-9"> <div className="total-big text-pink text-end">Net Cost of Services</div></div>
                                    <div className="col-md-3"><div className="value total-big text-pink ">£{

                                      roundNumber(totalCostWithDiscount)
                                      // (Math.trunc(totalCostWithDiscount * 100) / 100).toFixed(2)
                                    }</div></div>
                                  </div>
                                </div>


                                {/* {
                                  paymentTerm != "" ?
                                    ['manual_payment_monthly', 'manual_payment_quarterly'].includes(paymentTerm) && Number(agentConfigSetting.admin_charge) === 1 ?
                                      <div className="d-flex justify-content-end align-items-center mb-3">
                                        <div className="row w-100">
                                          <div className="col-md-9">
                                            <div className="label total-big text-pink">
                                              Admin Charge (for Non-DD clients)
                                            </div></div>
                                          <div className="col-md-3"> <div className="value total-big text-pink ">£{adminChargeAmount?.toFixed(2)}</div></div>
                                        </div>
                                      </div>
                                      :
                                      ""
                                    : ""
                                } */}


                                <div className="d-flex justify-content-end align-items-center mb-1">
                                  <div className="row w-100">
                                    <div className="col-md-9">  <div className="label  text-end">VAT</div></div>
                                    <div className="col-md-3"><div className="value " >
                                      £{roundNumber(vat)}
                                    </div></div>
                                  </div>
                                </div>


                                <div className="d-flex justify-content-end align-items-center mb-3">
                                  <div className="row w-100">
                                    <div className="col-md-9">  <div className="label total-big text-pink">Total (Including VAT)</div></div>
                                    <div className="col-md-3"> <div className="value total-big text-pink ">£{
                                      roundNumber(totalIncludingVAT)
                                      // (Math.trunc(totalIncludingVAT * 100) / 100).toFixed(2)
                                    }</div></div>
                                  </div>

                                </div>

                                {/* <div className="mb-3">
                                  <div className="row">
                                    <div className="col-md-3">
                                      <label className="form-label small">Payment Types</label>
                                    </div>
                                    <div className="col-md-9">
                                      <select
                                        className="form-select rounded-select"
                                        value={paymentTerm}
                                        onChange={(e) => {
                                          setPaymentTerm(e.target.value);
                                          paymentTermModal(e);
                                        }}
                                      >
                                        <option value=""> -- Select Payment Types -- </option>
                                        {
                                          containsGoCardless ?
                                            <>
                                              <option value="monthly_dd">Monthly DD</option>
                                            </>
                                            :
                                            ""
                                        }

                                        <option value="100_upfront" >100% Upfront
                                          {paymentTerm === "100_upfront" && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}
                                        </option>
                                        <option value="50_upfront">50% Upfront / 50% on Draft Submission

                                          {paymentTerm === "50_upfront" && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}
                                        </option>
                                     
                                        <option value="manual_payment_monthly">Manual Payment Monthly - Non DD
                                          {paymentTerm === "manual_payment_monthly" && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div> */}


                                {
                                  paymentTerm != "" ?
                                    <>
                                      {/* {['manual_payment_monthly', 'manual_payment_quarterly'].includes(paymentTerm) && Number(agentConfigSetting.admin_charge) === 1 ?
                                        <div className="d-flex justify-content-end align-items-center mb-3">
                                          <div className="row w-100">
                                            <div className="col-md-9">
                                              <div className="label total-big text-pink">
                                                Admin Charge (for Non-DD clients)
                                              </div></div>
                                            <div className="col-md-4"> <div className="value total-big text-pink ">£{adminChargeAmount?.toFixed(2)}</div></div>
                                          </div>
                                        </div>
                                        :
                                        ""} */}

                                      <div className="d-flex justify-content-end align-items-center mb-3">
                                        <div className="row w-100">
                                          <div className="col-md-9">
                                            <div className="label">

                                              {{
                                                monthly_dd: "Total Monthly Cost",
                                                manual_payment_monthly: "Total Monthly Cost",
                                                quarterly_dd: "Total Quarterly Cost",
                                                manual_payment_quarterly: "Total Quarterly Cost",
                                                "100_upfront": "Total Upfront Cost (100%)",
                                                "100_post_completion": "Total Post Completion Cost (100%)",
                                                "50_upfront": "Total Upfront Cost (50%)",
                                              }[paymentTerm] || "Total Monthly Cost"} (Excluding VAT)

                                            </div></div>
                                          <div className="col-md-3"> <div className="">£{roundNumber(totalMonthlyCostExcluding)}</div></div>
                                        </div>
                                      </div>

                                      <div className="d-flex justify-content-end align-items-center mb-3">
                                        <div className="row w-100">
                                          <div className="col-md-9">
                                            <div className="label total-big text-pink">

                                              {{
                                                monthly_dd: "Total Monthly Cost",
                                                manual_payment_monthly: "Total Monthly Cost",
                                                quarterly_dd: "Total Quarterly Cost",
                                                manual_payment_quarterly: "Total Quarterly Cost",
                                                "100_upfront": "Total Upfront Cost (100%)",
                                                "100_post_completion": "Total Post Completion Cost (100%)",
                                                "50_upfront": "Total Upfront Cost (50%)",
                                              }[paymentTerm] || "Total Monthly Cost"} (Including VAT)

                                            </div></div>
                                          <div className="col-md-3"> <div className="value total-big text-pink ">£{roundNumber(totalMonthlyCost)}</div></div>
                                        </div>
                                      </div>


                                    </>
                                    : ""
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ""
                  }
                  {/*------END-------Ongoing Contract Summary-----END-----*/}






                  {/*------START-------OneOff Contract Summary-----START-----*/}
                  {
                   ([null, undefined, ""].includes(quoteData?.ExistClientContract) || currentContractValue >= ProposedContractValue())
                    &&
                    addedService.length > 0 &&
                    addedService?.find(item => {

                      if (![2].includes(Number(item?.servicetype_id))) return false;

                      const basisId =
                        item.sell_chargebasis_id || item.default_chargebasis_id;

                      const matched = item?.ServiceChargeBases?.find(
                        chargeBase =>
                          chargeBase.ChargeBasis?.id === basisId &&
                          chargeBase.ChargeBasis?.BasisType?.id === 2
                      );

                      if (matched && parseFloat(item?.price) === 0) {
                        return false;
                      }

                      return true;
                    }) ?

                    <div className="wrap " >
                      <h4 className="page-title text-pink py-4 ">
                        {contractTypeOneOff == 'contract_type_ongoing' ? 'Ongoing ' : contractTypeOneOff == 'contract_type_oneoff' ? 'One-Off ' : 'Pay As You Go '}
                        Contract Summary</h4>
                      <div className="summary-card" style={{ background: '#FFF4FB' }}>
                        <div className="row gx-4">
                          {/* LEFT: Services */}
                          <div className="col-md-12">
                            <div className="service-row">
                              <div className=" services-title" >Services</div>
                              <div className=" services-title">Total</div>
                            </div>

                            {
                              addedService && addedService?.
                                filter(item => [2].includes(Number(item.servicetype_id)))
                                .map((item, index) => {

                                  const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
                                  const matched = item?.ServiceChargeBases.find(chargeBase =>
                                    chargeBase?.ChargeBasis?.id === basisId &&
                                    chargeBase?.ChargeBasis?.BasisType?.id === 2
                                  );
                                  if (matched && parseFloat(item?.price) === 0) {
                                    return
                                  }
                                  return (
                                    <div className="service-row">
                                      <div>
                                        <div className="service-name-new">{item?.name}</div>
                                        <div className="service-desc">{item?.description}</div>
                                      </div>
                                      <div className="service-amount">
                                        £{
                                          (() => {
                                            // const basisId = item.sell_chargebasis_id || item.default_chargebasis_id;
                                            // const matched = item.ServiceChargeBases.find(chargeBase =>
                                            //   chargeBase.ChargeBasis?.id === basisId &&
                                            //   chargeBase.ChargeBasis?.BasisType?.id === 2
                                            // );
                                            // if (matched) {
                                            //   if (quoteData.quote.ContractPackageServices.length > 0
                                            //     && quoteData.quote.ContractPackageServices.find(service => service.service_id === item.id)?.higher_discount_status === 1
                                            //   ) {
                                            //     const approval_price = quoteData.quote.ContractPackageServices.find(service => service.service_id === item.id)?.approval_price || item.price;
                                            //     return approval_price

                                            //   } else {
                                            //     return (matched.price_rate).toFixed(2);
                                            //   }

                                            // } else {
                                            //   if (Number(item?.servicetype_id) == 2) {
                                            //     const value =
                                            //       (item?.price * (1 + increasePremiumFinalOneOff / 100)) *
                                            //       (1 - discountValueFinalOneOff / 100);

                                            //     return roundNumber(value);
                                            //   } else {
                                            //     const value =
                                            //       (item?.price * (1 + increasePremiumFinal / 100)) *
                                            //       (1 - discountValueFinal / 100);

                                            //     return roundNumber(value);

                                            //   }
                                            // }

                                            if (Number(item?.servicetype_id) == 2) {
                                              const value =
                                                (item?.price * (1 + increasePremiumFinalOneOff / 100)) *
                                                (1 - discountValueFinalOneOff / 100);

                                              return roundNumber(value);
                                            } else {
                                              const value =
                                                (item?.price * (1 + increasePremiumFinal / 100)) *
                                                (1 - discountValueFinal / 100);

                                              return roundNumber(value);
                                            }

                                          })()
                                        }
                                      </div>
                                    </div>
                                  )
                                }
                                )
                            }


                          </div>
                          <div className="col-md-5"></div>
                          <div className="col-md-7 text-end">
                            <div className="right-block">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <label className="label col-form-label">Total cost of services</label>
                                <div className="value">£{
                                  // totalCostOneOff?.toFixed(2)
                                  roundNumber(totalCostOneOff)
                                }</div>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <label className="label col-form-label">Discount(%)</label>
                                <div>
                                  <input type="text"
                                    name="discount"
                                    min={0}
                                    value={(discountOneOff)}
                                    disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                    onChange={(e) => InputChangeDiscountPremiumOneOff(e)}
                                    className="form-control" />
                                  {
                                    errorDiscount ? <span className="text-danger">Discount can not be less than {packageDefaultDiscount}</span> : ""
                                  }
                                </div>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <label className="label col-form-label">Premium(%)</label>
                                <div>
                                  <input type="text"
                                    name="premium"
                                    value={premiumOneOff}
                                    disabled={Number(higherDiscountStatus) === 1 || requestHigherDiscountStatus === true ? true : false}
                                    onChange={(e) => InputChangeDiscountPremiumOneOff(e)}
                                    className="form-control" />
                                </div>
                              </div>
                              <hr />
                              <div className="d-flex justify-content-end align-items-center mb-1">
                                <div className="row w-100">
                                  <div className="col-md-9"> <div className="total-big text-pink text-end">Net Cost of Services</div></div>
                                  <div className="col-md-3"><div className="value total-big text-pink ">£{

                                    roundNumber(totalCostWithDiscountOneOff)
                                    // (Math.trunc(totalCostWithDiscount * 100) / 100).toFixed(2)
                                  }</div></div>
                                </div>


                              </div>
                              <div className="d-flex justify-content-end align-items-center mb-1">
                                <div className="row w-100">
                                  <div className="col-md-9">  <div className="label  text-end">VAT</div></div>
                                  <div className="col-md-3"><div className="value " >
                                    £{roundNumber(vatOneOff)}
                                  </div></div>
                                </div>


                              </div>
                              <div className="d-flex justify-content-end align-items-center mb-3">
                                <div className="row w-100">
                                  <div className="col-md-9">  <div className="label total-big text-pink">Total (Including VAT)</div></div>
                                  <div className="col-md-3"> <div className="value total-big text-pink ">£{
                                    roundNumber(totalIncludingVATOneOff)
                                    // (Math.trunc(totalIncludingVAT * 100) / 100).toFixed(2)
                                  }</div></div>
                                </div>

                              </div>


                              {/* <div className="mb-3">
                                  <div className="row">
                                    <div className="col-md-3">  <label className="form-label small">Payment Types</label></div>
                                    <div className="col-md-9">
                                      <select
                                        className="form-select rounded-select"
                                        value={paymentTermOneOff}
                                        onChange={(e) => {
                                          setPaymentTermOneOff(e.target.value);
                                          paymentTermModalOneOff(e);
                                        }}
                                      >
                                        <option value=""> -- Select Payment Types -- </option>
                                        {
                                          containsGoCardless ?
                                            <>
                                            </>
                                            :
                                            ""
                                        }

                                        <option value="100_upfront" >100% Upfront
                                          {paymentTermOneOff === "100_upfront" && paymentTypeLableOneOff != undefined ? `( ${paymentTypeLableOneOff} )` : ""}
                                        </option>
                                        <option value="50_upfront">50% Upfront / 50% on Draft Submission

                                          {paymentTermOneOff === "50_upfront" && paymentTypeLableOneOff != undefined ? `( ${paymentTypeLableOneOff} )` : ""}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div> */}


                              {
                                paymentTermOneOff != "" ?
                                  <>
                                    {/* {
                                       ['manual_payment_monthly', 'manual_payment_quarterly'].includes(paymentTermOneOff) && Number(agentConfigSetting.admin_charge) === 1 ?
                                        <div className="d-flex justify-content-end align-items-center mb-3">
                                          <div className="row w-100">
                                            <div className="col-md-9">
                                              <div className="label total-big text-pink">
                                                Admin Charge (for Non-DD clients)
                                              </div></div>
                                            <div className="col-md-3"> <div className="value total-big text-pink ">£{adminChargeOneOff.toFixed(2)}</div></div>
                                          </div>
                                        </div>
                                        :
                                        ""
                                        } */}

                                    <div className="d-flex justify-content-end align-items-center mb-3">
                                      <div className="row w-100">
                                        <div className="col-md-9">
                                          <div className="label">

                                            {{
                                              monthly_dd: "Total Monthly Cost",
                                              manual_payment_monthly: "Total Monthly Cost",
                                              quarterly_dd: "Total Quarterly Cost",
                                              manual_payment_quarterly: "Total Quarterly Cost",
                                              "100_upfront": "Total Upfront Cost (100%)",
                                              "100_post_completion": "Total Post Completion Cost (100%)",
                                              "50_upfront": "Total Upfront Cost (50%)",
                                            }[paymentTermOneOff] || "Total Monthly Cost"} (Excluding VAT)

                                          </div></div>
                                        <div className="col-md-3"> <div className="">£{roundNumber(totalMonthlyCostExcludingOneOff)}</div></div>
                                      </div>
                                    </div>

                                    <div className="d-flex justify-content-end align-items-center mb-3">
                                      <div className="row w-100">
                                        <div className="col-md-9">
                                          <div className="label total-big text-pink">

                                            {{
                                              monthly_dd: "Total Monthly Cost",
                                              manual_payment_monthly: "Total Monthly Cost",
                                              quarterly_dd: "Total Quarterly Cost",
                                              manual_payment_quarterly: "Total Quarterly Cost",
                                              "100_upfront": "Total Upfront Cost (100%)",
                                              "100_post_completion": "Total Post Completion Cost (100%)",
                                              "50_upfront": "Total Upfront Cost (50%)",
                                            }[paymentTermOneOff] || "Total Monthly Cost"} (Including VAT)

                                          </div></div>
                                        <div className="col-md-3"> <div className="value total-big text-pink ">£{roundNumber(totalMonthlyCostOneOff)}</div></div>
                                      </div>
                                    </div>


                                  </>
                                  : ""
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ""
                  }
                  {/*------END-------OneOff Contract Summary-----END-----*/}

                  {
                    ([null, undefined, ""].includes(quoteData?.ExistClientContract) || currentContractValue >= ProposedContractValue()) &&
                      HourlyBillingArray?.length > 0 &&
                      HourlyBillingArray?.find(item => {
                        const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
                        const matched = item?.ServiceChargeBases?.find(
                          chargeBase =>
                            chargeBase?.ChargeBasis?.id === basisId &&
                            chargeBase?.ChargeBasis?.BasisType?.id === 2
                        );

                        if (matched && parseFloat(item?.price) === 0) {
                          return true;
                        }

                        return false;
                      }) ?

                      <div className="mt-3 mb-3">

                        <h5
                          className="fw-semibold mb-3 text-pink"

                        >
                          Time and Fees Billing ( Hourly )
                        </h5>

                        <div
                          className="card border-0 "
                          style={{
                            border: "1px solid #e7cbd8",
                            borderRadius: "8px",
                            overflow: "hidden"
                          }}
                        >

                          {/* Header */}
                          <div
                            className="d-flex justify-content-between px-3 py-3 fw-semibold pink-select"
                          // style={{ background: "#fff4fb" }}
                          >
                            <div>Services</div>
                            <div>Total</div>
                          </div>

                          {
                            // addedService && addedService?.map((item, index) => {
                            HourlyBillingArray && HourlyBillingArray?.map((item, index) => {

                              const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
                              const matched = item?.ServiceChargeBases.find(chargeBase =>
                                chargeBase?.ChargeBasis?.id === basisId &&
                                chargeBase?.ChargeBasis?.BasisType?.id === 2
                              );


                              if (!matched) {
                                return
                              }

                              if (matched && Number(item?.price) > 0) {
                                return
                              }


                              return (
                                <div className="d-flex justify-content-between px-3 py-3 border-top">
                                  <div className="service-name-new">{item?.name}</div>
                                  <div>£{roundNumber(matched?.rate)} + VAT</div>

                                </div>
                              )
                            })


                          }


                          <div className="d-flex justify-content-between px-3 py-3 border-top">
                            <div className="service-name-new">Payment Types</div>
                            <div>On invoice</div>
                          </div>
                        </div>
                      </div>

                      : ""
                  }

                  {/* PACKAGE DESCRIPTION*/}
                  <div className="row mb-3 px-2">
                    <label className="col-sm-4 col-md-2 col-form-label">
                      <span className="text-pink">
                        <strong>Additional Notes:</strong>
                      </span>
                    </label>
                    {/* <div className="col-sm-8 col-md-10 ">
                          <textarea
                            ref={textareaRef}
                            value={packageDescription}
                            name="package_description"
                            onChange={(e) => OngoingInputDescription(e)}
                            placeholder="Enter package description"
                            style={{
                              width: "100%",
                              minHeight: "40px",
                              maxHeight: "300px",
                              overflowY: "hidden",
                              padding: "8px",
                              fontSize: "16px",
                              borderRadius: "5px",
                              border: "1px solid #ccc",
                            }}
                          />
                        </div> */}
                    <div className="col-sm-12">
                      <JoditEditor
                        ref={editor}
                        config={config1}
                        tabIndex={1}

                        name="packageDescription"
                        value={formData.packageDescription}
                        onBlur={(newContent) => {
                          setFormData((prev) => ({
                            ...prev,
                            packageDescription: newContent,
                          }));
                        }}
                      />

                    </div>
                  </div>


                  {/* <div className="col-sm-9">
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => document.getElementById("fileInput").click()}
                    >
                      <i className="bi bi-paperclip me-2"></i>
                      Add Attachment
                    </button>
                    <input
                      id="fileInput"
                      type="file"
                      multiple
                      accept=".pdf,.doc,.docx"
                      onChange={handleAttachmentChange}
                      className="d-none"
                    />
                    <div className="attachment-list mt-3">
                      {formData?.attachments?.map((file, index) => (
                        <div
                          key={index}
                          className="attachment-item d-flex align-items-center justify-content-between mb-2 p-2"
                        >
                          <div className="d-flex align-items-center gap-2">
                            <div className="file-icon">
                              <i className="bi bi-paperclip"></i>
                            </div>

                            <span className="file-name">{file?.name}</span>
                          </div>

                          <button
                            type="button"
                            className="btn btn-sm btn-light-danger remove-btn"
                            onClick={() => handleRemoveAttachment(index)}
                          >
                            <i className="bi bi-x-lg"></i>
                          </button>
                        </div>
                      ))}
                    </div>

                  </div> */}


                  {/* PAYMENT TERMS DESCRIPTION */}
                  <div className="row mb-3 px-2">
                    {/* <label className="col-sm-4 col-md-3 col-form-label">
                      <span className="text-pink">
                        <strong>Payment Terms Description: </strong>
                      </span>
                    </label> */}
                    {/* <div className="col-sm-8 col-md-10 ">
              <textarea
                ref={textareaRef_payment}
                value={paymentTermDescription}
                name="payment_term_description"
                onChange={(e) => OngoingInputDescription(e)}
                placeholder="Enter payment tems description"
                style={{
                  width: "100%",
                  minHeight: "40px",
                  maxHeight: "300px",
                  overflowY: "hidden",
                  padding: "8px",
                  fontSize: "16px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
            </div> */}
                    {/* <div className="col-sm-12">
                      <JoditEditor
                        ref={editor}
                        config={config1}
                        tabIndex={1}
                        name="paymentTermDescription"
                        value={formData.paymentTermDescription}
                        onBlur={(newContent) => {
                          setFormData((prev) => ({
                            ...prev,
                            paymentTermDescription: newContent,
                          }));
                        }}
                      />


                    </div> */}

                  </div>
                </div>
              </div>



              <div className="row mt-3 align-items-center">

                {/* <div className="col-md-12  ps-lg-3">
                  <div className="d-flex">
                    <label className="col-form-label c pt-0">
                      Do you want to send attachments?
                    </label>
                    <div className="ms-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gridRadios11"
                          id="gridRadios111"
                          defaultValue="option11"
                          checked={showAttachment === "1"}
                          onChange={(e) => setShowAttachment("1")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="gridRadios111"
                        >
                          Yes
                        </label>
                      </div>
                    </div>
                    <div className="ms-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gridRadios11"
                          id="gridRadios111"
                          defaultValue="option11"
                          checked={showAttachment === "0"}
                          onChange={(e) => setShowAttachment("0")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="gridRadios111"
                        >
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div> */}

                <div className="col-md-12  ps-lg-3 mb-3 mt-3">
                  <div className="d-flex align-items-center">
                    <label className="col-form-label c pt-0">
                      Do you want to display discount?
                    </label>
                    <div className="ms-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gridRadios"
                          id="gridRadios1"
                          defaultValue="option1"
                          checked={showDiscount == "1"}
                          onChange={(e) => setShowDiscount("1")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="gridRadios1"
                        >
                          Yes
                        </label>
                      </div>
                    </div>


                    <div className="ms-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gridRadios"
                          id="gridRadios1"
                          defaultValue="option1"
                          checked={showDiscount == "0"}
                          onChange={(e) => { setShowDiscount("0"); setShowPrice("0") }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="gridRadios1"
                        >
                          No
                        </label>
                      </div>
                    </div>

                    {
                      showDiscount == "1" && (
                        <div className="ms-3">
                          <button
                            type="button"
                            className="btn btn-pink btn-sm"
                            onClick={() => {
                              if (Number(showDiscount) === 1) {
                                setShowDiscountModal(true);
                              } else {
                                Swal.fire({
                                  title: "Do you want to display discount?",
                                  text: "Please select show discount",
                                  icon: "warning",
                                  confirmButtonText: "OK"
                                });
                              }
                            }}
                          >
                            View Discount
                          </button>
                        </div>
                      )
                    }



                  </div>


                </div>


                <div className="col-md-12  ps-lg-3">
                  <div className="d-flex">
                    <label className="col-form-label c pt-0">
                      Do you want to display price breakdown of services?
                    </label>
                    <div className="ms-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gridRadios1"
                          id="gridRadios11"
                          defaultValue="option1"
                          checked={showPrice === "1"}
                          onChange={(e) => setShowPrice("1")}
                          disabled={showDiscount == "0" ? true : false}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="gridRadios11"
                        >
                          Yes
                        </label>
                      </div>
                    </div>
                    <div className="ms-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gridRadios1"
                          id="gridRadios11"
                          defaultValue="option1"
                          checked={showPrice === "0"}
                          onChange={(e) => setShowPrice("0")}
                          disabled={showDiscount == "0" ? true : false}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="gridRadios11"
                        >
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </>

            : ""
        }






        <div className="d-flex justify-content-between mt-3">
          {currentStep > 1 && (
            <button className="btn btn-secondary" onClick={prevStep}>
              Previous
            </button>
          )}
          <button
            className="btn btn-pink"
            onClick={handleSubmit}
          >
            {currentStep < 4 ? "Next" : "Submit"}
          </button>
        </div>


        {/* Modal for Preview */}
        {showModalPaymentTerm && (
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-md">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Payment Types :
                    {{
                      monthly_dd: "Monthly DD (Direct Debit via GoCardless)",
                      manual_payment_monthly: "Manual Payment-Monthly",
                      quarterly_dd: "Quarterly DD (Direct Debit via GoCardless)",
                      manual_payment_quarterly: "Manual Payment- Quarterly",
                      "100_upfront": "100% Upfront",
                      "100_post_completion": "100% Post Completion",
                      "50_upfront": "50% Upfront / 50% on Draft Submission",
                    }[paymentTerm] || ""}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal}
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <p>Select Payment Method</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <select
                        className="form-select"
                        value={paymentTypeOfModal}
                        onChange={(e) => {
                          setPaymentTypeOfModal(e.target.value);
                        }}
                      >
                        {
                          paymentTermTypeGetAgent.length > 0 ?
                            paymentTermTypeGetAgent.map((item, index) => (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            ))
                            :
                            ""
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-pink"
                    onClick={handleCloseModal}
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal for Preview One Off */}
        {showModalPaymentTermOneOff && (
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-md">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Payment Types :
                    {{
                      monthly_dd: "Monthly DD (Direct Debit via GoCardless)",
                      manual_payment_monthly: "Manual Payment-Monthly",
                      quarterly_dd: "Quarterly DD (Direct Debit via GoCardless)",
                      manual_payment_quarterly: "Manual Payment- Quarterly",
                      "100_upfront": "100% Upfront",
                      "100_post_completion": "100% Post Completion",
                      "50_upfront": "50% Upfront / 50% on Draft Submission",
                    }[paymentTermOneOff] || ""}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModalOneOff}
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <p>Select Payment Method</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <select
                        className="form-select"
                        value={paymentTypeOfModalOneOff}
                        onChange={(e) => {
                          setPaymentTypeOfModalOneOff(e.target.value);
                        }}
                      >
                        {
                          paymentTermTypeGetAgentOneOff.length > 0 ?
                            paymentTermTypeGetAgentOneOff.map((item, index) => (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            ))
                            :
                            ""
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-pink"
                    onClick={handleCloseModalOneOff}
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal for Packages Any Changes */}
        {packagesChangesModel && (
          <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">

                {/* Header */}
                <div className="modal-header" style={{ borderColor: '#ff00aa' }}>
                  <h5 className="modal-title text-pink">Warning</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModalPackageChanges}
                  ></button>
                </div>

                {/* Body */}
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <p>
                        Changing these values will make the selected package ineligible.
                        The quote/contract will then be treated as a Tailor made package
                        and the price will be different.
                      </p>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="row justify-content-center mt-3">
                    <button
                      type="button"
                      className="btn btn-pink rounded w-auto"
                      onClick={handlePackageChangesProceed}
                    >
                      Proceed
                    </button>

                    <button
                      type="button"
                      className="btn btn-outline-pink rounded w-auto ms-3"
                      onClick={handleCloseModalPackageChanges}
                    >
                      Cancel
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        )}


        {/*Modal Request Higher Discount */}
        {
          packageID !== null && packagesChanges == false && isServicediscount.current == false ?
            <>
              {/* package request higher discount modal  */}
              <ReusableModal
                show={showModal}
                onClose={() => setShowModal(false)}
                modalsize="lg"
                title={
                  <span className="text-pink fw-bold" style={{ fontWeight: "600", fontSize: "20px" }}>Request Higher Discount</span>
                }
                body={
                  <>
                    <div className="p-3 rounded">
                      <div className="row mb-3">
                        <div className="col-md-4">
                          <label className="form-label">Approved By:</label>
                        </div>

                        <div className="col-md-8">
                          <select
                            className="form-select"
                            onChange={(e) => { setEmailAuthorised(e.target.value) }}
                          >
                            <option value=""> -- Select -- </option>
                            {agentListDataAuthorised && agentListDataAuthorised?.map((val, index) => (
                              <option
                                key={index}
                                value={val?.user_email}
                                selected={val?.user_email === emailAuthorised}
                              >

                                {/* {val?.user_fname + ' ' + val?.user_lname} */}
                                {`${val?.user_fname} ${val?.user_lname} (${val?.min_discount} - ${val?.max_discount})`}

                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-4">
                          <label className="form-label">Package:</label>
                        </div>
                        <div className="col-md-8">
                          <input
                            disabled
                            className="form-control"
                            value={packageName && packageName}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-4">
                          <label className="form-label">Current Package Discount (%):</label>

                        </div>
                        <div className="col-md-8">
                          <input
                            disabled
                            className="form-control"
                            value={discount && discount + '%'}
                          />

                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-4">
                          <label className="form-label">Current Cost:</label>

                        </div>
                        <div className="col-md-8">
                          <input
                            disabled
                            className="form-control"
                            value={totalCostWithDiscount && '£' + roundNumber(totalCostWithDiscount)}
                          />

                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-4">
                          <label className="form-label">Desired Higher Discount (%):</label>
                        </div>
                        <div className="col-md-8">
                          <input
                            disabled
                            className="form-control"
                            type="text"
                            max={100}
                            value={desiredHigherDiscount && desiredHigherDiscount + '%'}
                            onChange={(e) => {
                              setDesiredHigherDiscountFun(e);
                            }}
                          />

                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-4">
                          <label className="form-label">Desired Price for Approval:</label>

                        </div>
                        <div className="col-md-8">
                          <input
                            className="form-control"
                            type="text"
                            value={desiredPriceApproval}
                            onChange={(e) => desiredPriceApprovalFun(e)}
                          />
                          {
                            desiredPriceApproval === "" ?
                              <span className="text-danger">Please enter desired price for approval</span> :
                              errorDiscountValue ? <span className="text-danger">Desired Price can not be greater than current cost {roundNumber(totalCostWithDiscount)}</span> : ""
                          }
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label className="col-sm-4 col-md-2 col-form-label">
                          <strong>Reason:</strong>
                        </label>
                        <div className="col-sm-8 col-md-10 ">
                          <textarea
                            ref={textareaRef}
                            value={reasonHigherDiscount}
                            name="reason_higher_discount"
                            onChange={(e) => setReasonHigherDiscount(e.target.value)}
                            placeholder="Please Enter Reason For Higher Discount"
                            style={{
                              width: "100%",
                              minHeight: "40px",
                              maxHeight: "300px",
                              overflowY: "hidden",
                              padding: "8px",
                              fontSize: "16px",
                              borderRadius: "5px",
                              border: "1px solid #ccc",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                }
                footer={
                  <>
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => setShowModal(false)}>
                      Cancel
                    </button>
                    <button className="btn btn-pink" onClick={(e) => submitReqHigherDiscount(e)}
                      disabled={isLoading}
                    >{isLoading ? "Submitting..." : "Submit"}</button>
                  </>
                }
              />
            </>

            :

            <>
              {/* Only Service request higher discount modal  */}

              <ReusableModal
                show={showModal}
                onClose={() => setShowModal(false)}
                modalsize="xl"
                modalContentClass="higher-discount-content"


                body={
                  <div style={{ background: "#fff", padding: "10px 20px" }}>
                    <div> <h4 className="text-pink text-center">Request Higher Discount</h4></div>
                    <div style={{
                      fontSize: "14px",
                      textAlign: "center",
                      borderBottom: "1px solid #ccc",
                      paddingBottom: "20px",
                      marginBottom: "14px"
                    }}>
                      <strong>Package Name :</strong> Custom
                    </div>



                    {/* Top Summary Section */}
                    <div>

                      {/* Approved By */}
                      <div className="appo-by">
                        <label className="me-2" style={{ fontWeight: "500" }}>Approved By : </label>
                        <select
                          value={emailAuthorised}
                          onChange={(e) => setEmailAuthorised(e.target.value)}
                          style={{
                            padding: "4px 10px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                          }}
                        >
                          <option value=""> -- Select -- </option>
                          {agentListDataAuthorised?.map((val, index) => (
                            <option key={index} value={val?.user_email}>
                              {/* {val?.user_fname + " " + val?.user_lname} */}
                              {`${val?.user_fname} ${val?.user_lname} (${val?.min_discount} - ${val?.max_discount})`}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Price Summary */}
                      <div className="d-flex justify-content-between">
                        {
                          showServiceHigherDiscount === 'ongoing' ?
                            <div style={{ display: "flex", gap: "30px", fontSize: "14px", }}>
                              <span>
                                <strong>Total Current Pricing :</strong> £
                                {roundNumber(totalCostWithDiscount)}
                              </span>

                              <span>
                                <strong>Total Pricing For Approval :</strong> £
                                {ongoingServicesHigherDiscount?.length > 0
                                  ? roundNumber(ongoingServicesHigherDiscount?.filter((item) => Number(item.service_type) === 1)
                                    .reduce((sum, item) => {
                                      const chargeBasisId = item?.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

                                      const serviceChargeBases =
                                        item?.ServiceChargeBases ||
                                        item?.Service?.ServiceChargeBases ||
                                        [];

                                      const exclude = chargeBasisId && serviceChargeBases?.some(cb =>
                                        cb.ChargeBasis?.id === chargeBasisId &&
                                        (cb.ChargeBasis?.BasisType?.id === 2 && parseFloat(item?.price) === 0)
                                      );

                                      if (exclude) return sum;

                                      const price =
                                        item?.approval_price !== undefined && item?.approval_price !== null
                                          ? parseFloat(item?.approval_price || 0)
                                          : item?.price_afterdiscount;

                                      return sum + price;
                                    }, 0))
                                  : 0
                                }
                              </span>
                            </div>
                            : ""
                        }


                        {
                          showServiceHigherDiscount === 'oneoff' ?
                            <div style={{ display: "flex", gap: "30px", fontSize: "14px", }}>
                              <span>
                                <strong>Total Current Pricing one off:</strong> £
                                {roundNumber(totalCostWithDiscountOneOff)}
                              </span>

                              <span>
                                <strong>Total Pricing For Approval off :</strong> £
                                {oneoffServicesHigherDiscount?.length > 0
                                  ? roundNumber(oneoffServicesHigherDiscount?.filter((item) => Number(item.service_type) === 0).reduce((sum, item) => {
                                    const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

                                    const serviceChargeBases =
                                      item?.ServiceChargeBases ||
                                      item?.Service?.ServiceChargeBases ||
                                      [];

                                    const exclude = chargeBasisId && serviceChargeBases?.some(cb =>
                                      cb.ChargeBasis?.id === chargeBasisId &&
                                      (cb.ChargeBasis?.BasisType?.id === 2 && parseFloat(item?.price) === 0)
                                    );

                                    if (exclude) return sum;

                                    const price =
                                      item.approval_price !== undefined && item.approval_price !== null
                                        ? parseFloat(item.approval_price || 0)
                                        : item.price_afterdiscount;

                                    return sum + price;
                                  }, 0))
                                  : 0
                                }
                              </span>
                            </div>
                            : ""
                        }



                      </div>

                    </div>

                    {/* Package Name */}


                    {/* ===== 2 PARTITION SERVICES ===== */}
                    {(() => {

                      // console.log("ongoingServicesHigherDiscount", ongoingServicesHigherDiscount)
                      // console.log("oneoffServicesHigherDiscount", oneoffServicesHigherDiscount)

                      return (

                        <>

                          {/* ongoing TABLE */}
                          {
                            showServiceHigherDiscount === 'ongoing' && ongoingServicesHigherDiscount.length > 0 ?
                              <div style={{ flex: 1 }}>
                                <table
                                  style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    fontSize: "13px",
                                  }}
                                >
                                  <thead>
                                    <tr style={{ background: "#fafafa" }}>
                                      {[
                                        "Service Name",
                                        "Price",
                                        "Discounted Price",
                                        "Current Discount (%)",
                                        "Approval Discount (%)",
                                        "Approval Price",
                                      ].map((heading, i) => (
                                        <th
                                          key={i}
                                          style={{
                                            padding: "8px",
                                            borderBottom: "1px solid #ddd",
                                            textAlign: "left",
                                          }}
                                        >
                                          {heading}
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {ongoingServicesHigherDiscount?.map((val, index) => {

                                      const basisId = val?.sell_chargebasis_id || val?.Service?.default_chargebasis_id;

                                      const serviceChargeBases = val?.ServiceChargeBases || val?.Service?.ServiceChargeBases ||
                                        [];

                                      const matched = serviceChargeBases?.find(
                                        chargeBase =>
                                          chargeBase?.ChargeBasis?.id === basisId &&
                                          chargeBase?.ChargeBasis?.BasisType?.id === 2
                                      );

                                      if (matched && parseFloat(val?.price) === 0) {
                                        return false;
                                      }

                                      return (
                                        <tr key={index}>
                                          <td style={tdStyle}>{val?.Service?.name || val?.name}</td>
                                          <td style={tdStyle}>£{roundNumber(val?.price)}</td>
                                          <td style={tdStyle}>
                                            £{roundNumber(val?.price_afterdiscount)}
                                          </td>
                                          <td style={tdStyle}>
                                            {Number(val?.discount_rate ?? 0).toFixed(2)}
                                          </td>

                                          <td style={tdStyle}>
                                            <input
                                              disabled
                                              value={
                                                Number(
                                                  val?.approval_discount ?? val?.discount_rate ?? 0
                                                ).toFixed(2)
                                              }
                                              style={inputStyle}
                                            />
                                          </td>

                                          <td style={tdStyle}>
                                            {/* <input
                                            type="number"
                                            // value={
                                            //   val.approval_price != undefined
                                            //     ? val?.approval_price?.toFixed(2)
                                            //     : val?.price_afterdiscount?.toFixed(2)
                                            // }
                                            value={Number(val?.approval_price ?? val?.price_afterdiscount ?? 0)}
                                            onChange={(e) =>
                                              applyApprovalPrice(
                                                e,
                                                val,
                                                ongoingServicesHigherDiscount.findIndex(
                                                  (s) => s.id === val.id
                                                ),
                                                'ongoing'
                                              )
                                            }
                                            style={inputStyle}
                                          /> */}

                                            <input
                                              type="text"
                                              disabled={parseFloat(val?.price) === 0 ? true : false}
                                              value={roundNumber(val?.approval_price ?? val?.price_afterdiscount) || ""}
                                              onChange={(e) =>
                                                applyApprovalPrice(
                                                  e,
                                                  val,
                                                  index,
                                                  "ongoing"
                                                )
                                              }
                                              onBlur={(e) => {
                                                const value = parseFloat(e.target.value);
                                                if (!isNaN(value)) {
                                                  e.target.value = roundNumber(value);
                                                }
                                              }}
                                              style={inputStyle}
                                            />
                                            {approvalErrors[index] && approvalErrors[index] && (
                                              <div style={{ color: "red" }}>
                                                {approvalErrors[index] && approvalErrors[index]}
                                              </div>
                                            )}
                                          </td>
                                        </tr>
                                      )
                                    })
                                    }
                                  </tbody>
                                </table>
                              </div>
                              : ""
                          }

                          {/* oneoff TABLE */}
                          {
                            showServiceHigherDiscount === 'oneoff' && oneoffServicesHigherDiscount.length > 0 ?
                              <div style={{ flex: 1 }}>
                                <table
                                  style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    fontSize: "13px",
                                  }}
                                >
                                  <thead>
                                    <tr style={{ background: "#fafafa" }}>
                                      {[
                                        "Service Name",
                                        "Price",
                                        "Discounted Price",
                                        "Current Discount (%)",
                                        "Approval Discount (%)",
                                        "Approval Price",
                                      ].map((heading, i) => (
                                        <th
                                          key={i}
                                          style={{
                                            padding: "8px",
                                            borderBottom: "1px solid #ddd",
                                            textAlign: "left",
                                          }}
                                        >
                                          {heading}
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {oneoffServicesHigherDiscount?.map((val, index) => {

                                      const basisId = val?.sell_chargebasis_id || val?.default_chargebasis_id;
                                      const matched = val?.ServiceChargeBases?.find(
                                        chargeBase =>
                                          chargeBase?.ChargeBasis?.id === basisId &&
                                          chargeBase?.ChargeBasis?.BasisType?.id === 2
                                      );

                                      if (matched && parseFloat(val?.price) === 0) {
                                        return false;
                                      }

                                      return (
                                        <tr key={val.id}>
                                          <td style={tdStyle}>{val.name}</td>
                                          <td style={tdStyle}>£{roundNumber(val.price)}</td>
                                          <td style={tdStyle}>
                                            £{roundNumber(val?.price_afterdiscount)}
                                          </td>

                                          <td style={tdStyle}>
                                            {Number(val?.discount_rate ?? 0).toFixed(2)}
                                          </td>


                                          <td style={tdStyle}>
                                            <input
                                              disabled
                                              value={
                                                Number(
                                                  val?.approval_discount ?? val?.discount_rate ?? 0
                                                ).toFixed(2)
                                              }
                                              style={inputStyle}
                                            />
                                          </td>

                                          <td style={tdStyle}>
                                            {/* <input
                                            type="number"
                                            // value={
                                            //   val.approval_price != undefined
                                            //     ? val?.approval_price?.toFixed(2)
                                            //     : val?.price_afterdiscount?.toFixed(2)
                                            // }
                                            value={Number(val?.approval_price ?? val?.price_afterdiscount ?? 0)}
                                            onChange={(e) =>
                                              applyApprovalPrice(
                                                e,
                                                val,
                                                oneoffServicesHigherDiscount.findIndex(
                                                  (s) => s.id === val.id
                                                ),
                                                'oneoff'
                                              )
                                            }
                                            style={inputStyle}
                                          /> */}
                                            <input
                                              type="text"
                                              disabled={parseFloat(val?.price) === 0 ? true : false}
                                              value={roundNumber(val?.approval_price ?? val?.price_afterdiscount) || ""}
                                              onChange={(e) =>
                                                applyApprovalPrice(
                                                  e,
                                                  val,
                                                  oneoffServicesHigherDiscount.findIndex(
                                                    (s) => s.id === val.id
                                                  ),
                                                  "oneoff"
                                                )
                                              }
                                              onBlur={(e) => {
                                                const value = parseFloat(e.target.value);
                                                if (!isNaN(value)) {
                                                  e.target.value = roundNumber(value);
                                                }
                                              }}
                                              style={inputStyle}
                                            />
                                            {approvalErrors[oneoffServicesHigherDiscount.findIndex((s) => s.id === val.id)] && (
                                              <div style={{ color: "red" }}>
                                                {approvalErrors[oneoffServicesHigherDiscount.findIndex((s) => s.id === val.id)]}
                                              </div>
                                            )}
                                          </td>
                                        </tr>
                                      )
                                    })
                                    }
                                  </tbody>
                                </table>
                              </div>
                              : ""
                          }

                        </>


                      );
                    })()}

                    {/* ===== SINGLE REASON ===== */}
                    <div style={{ marginTop: "25px" }}>
                      <label style={{ fontWeight: "600" }}>Reason:</label>
                      <textarea
                        value={reasonHigherDiscount}
                        onChange={(e) => setReasonHigherDiscount(e.target.value)}
                        placeholder="Please Enter Reason For Higher Discount"
                        style={{
                          width: "100%",
                          marginTop: "8px",
                          padding: "8px",
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                          resize: "none",
                          fontSize: "14px",
                        }}
                        rows="3"
                      />
                    </div>
                  </div>
                }
                footer={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px",
                    }}
                  >
                    <button
                      onClick={() => setShowModal(false)}
                      className="btn btn-outline-secondary"
                    >
                      Cancel
                    </button>

                    <button
                      onClick={submitReqHigherDiscount}
                      disabled={isLoading}
                      className="btn btn-pink"
                    >
                      {isLoading ? "Submitting..." : "Send"}
                    </button>
                  </div>
                }
              />


            </>
        }


        <ReusableModal
          show={showDiscountModal}
          onClose={() => setShowDiscountModal(false)}

          modalsize="lg"
          title={
            <span className="text-pink fw-bold" style={{ fontWeight: "600", fontSize: "20px" }}>
              {/* Show Discount */}
            </span>
          }
          body={
            <>

              {/* ================= Packages Services ================= */}
              {
                (
                  (
                    (addedService?.length > 0 && addedService?.some(item => [1, 3].includes(Number(item?.servicetype_id)))) ||
                    packagesServiceData?.length > 0
                  ) && !['', null, undefined].includes(packageID)
                ) && (
                  <>
                    <div className="section-header-d-model">
                      {
                        packagesChanges === true ?
                          "Custom Package"
                          : packageName
                      }
                    </div>

                    <table className="custom-table-d-model">
                      <thead>
                        <tr>
                          <th className="th-left-d-model">Service Name</th>
                          <th className="th-right-d-model">Price</th>
                        </tr>
                      </thead>

                      <tbody>

                        {/* Packages Services */}
                        {filterWithoutPerHourBasis(packagesServiceData, 'package')?.map((item, index) => {
                          const service = item?.Service;

                          const value =
                            (item?.price * (1 + increasePremiumFinal / 100)) *
                            (1 - discountValueFinal / 100);

                          return (
                            <tr key={`pkg-${index}`}>
                              <td className="td-left-d-model">{service?.name}</td>
                              <td className="td-right-d-model">
                                {/* £{(Math.floor(value * 100) / 100).toFixed(2)} */}
                                £{
                                  (() => {


                                    const basisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
                                    const matched = service?.ServiceChargeBases?.find(chargeBase =>
                                      chargeBase.ChargeBasis?.id === basisId &&
                                      chargeBase.ChargeBasis?.BasisType?.id === 2
                                    );



                                    if (Number(service?.servicetype_id) == 2) {
                                      const value =
                                        (item?.price * (1 + increasePremiumFinalOneOff / 100)) *
                                        (1 - discountValueFinalOneOff / 100);

                                      return roundNumber(value);
                                    } else {
                                      const value =
                                        (item?.price * (1 + increasePremiumFinal / 100)) *
                                        (1 - discountValueFinal / 100);

                                      return roundNumber(value);
                                    }


                                  })()
                                }
                              </td>
                            </tr>
                          );
                        })}

                        {/* Added Services */}
                        {
                          filterWithoutPerHourBasis(addedService?.filter(item => [1, 3].includes(Number(item?.servicetype_id))))
                            .map((item, index) => {

                              const value =
                                (item?.price * (1 + increasePremiumFinal / 100)) *
                                (1 - discountValueFinal / 100);

                              return (
                                <tr key={`add-${index}`}>
                                  <td className="td-left-d-model">{item?.name}</td>
                                  <td className="td-right-d-model">
                                    {/* £{(Math.floor(value * 100) / 100).toFixed(2)} */}
                                    £{
                                      (() => {
                                        const basisId = item.sell_chargebasis_id || item.default_chargebasis_id;
                                        const matched = item.ServiceChargeBases.find(chargeBase =>
                                          chargeBase.ChargeBasis?.id === basisId &&
                                          chargeBase.ChargeBasis?.BasisType?.id === 2
                                        );

                                        if (matched) {
                                          return roundNumber(matched?.rate);
                                        } else {

                                          if (Number(item?.servicetype_id) == 2) {
                                            const value =
                                              (item?.price * (1 + increasePremiumFinalOneOff / 100)) *
                                              (1 - discountValueFinalOneOff / 100);

                                            return roundNumber(value);
                                          } else {
                                            const value =
                                              (item?.price * (1 + increasePremiumFinal / 100)) *
                                              (1 - discountValueFinal / 100);

                                            return roundNumber(value);
                                          }
                                        }

                                      })()
                                    }
                                  </td>
                                </tr>
                              );
                            })}

                        {/* Summary */}
                        <tr>
                          <td className="td-bold-d-model">Total Cost of Services</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalCost)}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Discount</td>
                          <td className="td-bold-right-d-model">{discount}%</td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Net Cost of Services</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalCostWithDiscount)}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">VAT @ 20%</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(vat)}
                          </td>
                        </tr>

                        <tr className="row-highlight-d-model">
                          <td className="td-bold-d-model">Total (Including VAT)</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalIncludingVAT)}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Payment Type</td>
                          <td className="td-bold-right-d-model">
                            {{
                              monthly_dd: "Monthly DD",
                              quarterly_dd: "Quarterly DD",
                              "100_upfront": "100% Upfront",
                              "50_upfront": "50% Upfront / 50% on Draft",
                              "100_post_completion": "100% Post Completion",
                              manual_payment_monthly: "Manual Payment-Monthly",
                              manual_payment_quarterly: "Manual Payment- Quarterly",
                            }[paymentTerm]}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Contract Type</td>
                          <td className="td-bold-right-d-model">
                            {{
                              contract_type_ongoing: "Ongoing",
                              contract_type_oneoff: "One-off",
                              contract_type_payg: "Pay As You Go",
                            }[contractTypeOngoing]}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">
                            {
                              {
                                monthly_dd: "Total Monthly Cost",
                                manual_payment_monthly: "Total Monthly Cost",
                                quarterly_dd: "Total Quarterly Cost",
                                manual_payment_quarterly: "Total Quarterly Cost",
                                "100_upfront": "Total Upfront Cost (100%)",
                                "100_post_completion": "Total Post Completion Cost (100%)",
                                "50_upfront": "Total Upfront Cost (50%)",
                              }[paymentTerm] || "Total Monthly Cost"
                            } (Excluding VAT)
                          </td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalMonthlyCostExcluding)}
                          </td>
                        </tr>

                        <tr className="row-highlight-d-model">
                          <td className="td-bold-d-model">
                            {
                              {
                                monthly_dd: "Total Monthly Cost",
                                manual_payment_monthly: "Total Monthly Cost",
                                quarterly_dd: "Total Quarterly Cost",
                                manual_payment_quarterly: "Total Quarterly Cost",
                                "100_upfront": "Total Upfront Cost (100%)",
                                "100_post_completion": "Total Post Completion Cost (100%)",
                                "50_upfront": "Total Upfront Cost (50%)",
                              }[paymentTerm] || "Total Monthly Cost"
                            } (Including VAT)
                          </td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalMonthlyCost)}
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </>
                )
              }



              {/* Hourly Billing Package */}
              {filterPerHourBasis(packagesServiceData, 'package')?.length > 0 && (
                <>
                  <div className="section-header-d-model mt-50-d-model">
                    Services - Time and Fees Billing (Hourly) (Ongoing)
                  </div>

                  <table className="custom-table-d-model">
                    <thead>
                      <tr>
                        <th className="th-left-d-model">Service Name</th>
                        <th className="th-right-d-model">Per Hour</th>
                      </tr>
                    </thead>

                    <tbody>

                      {
                        filterPerHourBasis(packagesServiceData, 'package')?.map((item, index) => {

                          let vat_label = item?.vat_label;
                          item = item?.Service || item;
                          const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
                          const matched = item?.ServiceChargeBases?.find(chargeBase =>
                            chargeBase?.ChargeBasis?.id === basisId &&
                            chargeBase?.ChargeBasis?.BasisType?.id === 2
                          );

                          return (
                            <tr key={index}>
                              <td className="td-left-d-model">
                                {item?.name}
                              </td>
                              <td className="td-right-d-model">
                                {`£ ${matched?.rate} + VAT`}
                              </td>
                            </tr>
                          )
                        })
                      }

                      <tr>
                        <td className="td-bold-d-model">Payment Types</td>
                        <td className="td-bold-right-d-model">
                          On Invoice
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              )}









              {/* ================= Ongoing Services ================= */}
              {
                (

                  (
                    (addedService?.length > 0 &&
                      filterWithoutPerHourBasis(addedService?.filter(item => [1, 3].includes(Number(item?.servicetype_id))))?.length > 0
                    ) ||
                    packagesServiceData?.length > 0
                  ) && ['', null, undefined].includes(packageID)
                ) && (
                  <>
                    <div className="section-header-d-model">
                      Contract for {ongoing_label} Services
                    </div>

                    <table className="custom-table-d-model">
                      <thead>
                        <tr>
                          <th className="th-left-d-model">Service Name</th>
                          <th className="th-right-d-model">Price</th>
                        </tr>
                      </thead>

                      <tbody>

                        {/* Packages Services */}
                        {packagesServiceData?.map((item, index) => {
                          const service = item?.Service;

                          const value =
                            (item?.price * (1 + increasePremiumFinal / 100)) *
                            (1 - discountValueFinal / 100);

                          return (
                            <tr key={`pkg-${index}`}>
                              <td className="td-left-d-model">{service?.name}</td>
                              <td className="td-right-d-model">
                                {/* £{(Math.floor(value * 100) / 100).toFixed(2)} */}
                                £{
                                  (() => {
                                    const basisId = item.sell_chargebasis_id || item.default_chargebasis_id;
                                    const matched = service.ServiceChargeBases.find(chargeBase =>
                                      chargeBase.ChargeBasis?.id === basisId &&
                                      chargeBase.ChargeBasis?.BasisType?.id === 2
                                    );

                                    if (matched) {
                                      return roundNumber(matched?.rate);
                                    } else {

                                      if (Number(item?.servicetype_id) == 2) {
                                        const value =
                                          (item?.price * (1 + increasePremiumFinalOneOff / 100)) *
                                          (1 - discountValueFinalOneOff / 100);

                                        return roundNumber(value);
                                      } else {
                                        const value =
                                          (item?.price * (1 + increasePremiumFinal / 100)) *
                                          (1 - discountValueFinal / 100);

                                        return roundNumber(value);
                                      }
                                    }

                                  })()
                                }
                              </td>
                            </tr>
                          );
                        })}

                        {/* Added Services */}
                        {
                          filterWithoutPerHourBasis(addedService?.filter(item => [1, 3].includes(Number(item?.servicetype_id))))
                            .map((item, index) => {

                              const value =
                                (item?.price * (1 + increasePremiumFinal / 100)) *
                                (1 - discountValueFinal / 100);

                              return (
                                <tr key={`add-${index}`}>
                                  <td className="td-left-d-model">{item?.name}</td>
                                  <td className="td-right-d-model">
                                    {/* £{(Math.floor(value * 100) / 100).toFixed(2)} */}
                                    £{
                                      (() => {
                                        if (Number(item?.servicetype_id) == 2) {
                                          const value =
                                            (item?.price * (1 + increasePremiumFinalOneOff / 100)) *
                                            (1 - discountValueFinalOneOff / 100);

                                          return roundNumber(value);
                                        } else {
                                          const value =
                                            (item?.price * (1 + increasePremiumFinal / 100)) *
                                            (1 - discountValueFinal / 100);

                                          return roundNumber(value);
                                        }

                                      })()
                                    }
                                  </td>
                                </tr>
                              );
                            })}

                        {/* Summary */}
                        <tr>
                          <td className="td-bold-d-model">Total Cost of Services</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalCost)}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Discount</td>
                          <td className="td-bold-right-d-model">{discount}%</td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Net Cost of Services</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalCostWithDiscount)}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">VAT @ 20%</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(vat)}
                          </td>
                        </tr>

                        <tr className="row-highlight-d-model">
                          <td className="td-bold-d-model">Total (Including VAT)</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalIncludingVAT)}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Payment Type</td>
                          <td className="td-bold-right-d-model">
                            {{
                              monthly_dd: "Monthly DD",
                              quarterly_dd: "Quarterly DD",
                              "100_upfront": "100% Upfront",
                              "50_upfront": "50% Upfront / 50% on Draft",
                              "100_post_completion": "100% Post Completion",
                              manual_payment_monthly: "Manual Payment-Monthly",
                              manual_payment_quarterly: "Manual Payment- Quarterly",
                            }[paymentTerm]}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Contract Type</td>
                          <td className="td-bold-right-d-model">
                            {{
                              contract_type_ongoing: "Ongoing",
                              contract_type_oneoff: "One-off",
                              contract_type_payg: "Pay As You Go",
                            }[contractTypeOngoing]}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">
                            {
                              {
                                monthly_dd: "Total Monthly Cost",
                                manual_payment_monthly: "Total Monthly Cost",
                                quarterly_dd: "Total Quarterly Cost",
                                manual_payment_quarterly: "Total Quarterly Cost",
                                "100_upfront": "Total Upfront Cost (100%)",
                                "100_post_completion": "Total Post Completion Cost (100%)",
                                "50_upfront": "Total Upfront Cost (50%)",
                              }[paymentTerm] || "Total Monthly Cost"
                            } (Excluding VAT)
                          </td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalMonthlyCostExcluding)}
                          </td>
                        </tr>

                        <tr className="row-highlight-d-model">
                          <td className="td-bold-d-model">
                            {
                              {
                                monthly_dd: "Total Monthly Cost",
                                manual_payment_monthly: "Total Monthly Cost",
                                quarterly_dd: "Total Quarterly Cost",
                                manual_payment_quarterly: "Total Quarterly Cost",
                                "100_upfront": "Total Upfront Cost (100%)",
                                "100_post_completion": "Total Post Completion Cost (100%)",
                                "50_upfront": "Total Upfront Cost (50%)",
                              }[paymentTerm] || "Total Monthly Cost"
                            } (Including VAT)
                          </td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalMonthlyCost)}
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </>
                )
              }


              {/* Hourly Billing Ongoing */}
              {filterPerHourBasis(addedService?.filter(item => [1, 3].includes(Number(item?.servicetype_id))))?.length > 0 && (
                <>
                  <div className="section-header-d-model mt-50-d-model">
                    Services - Time and Fees Billing (Hourly) (Ongoing)
                  </div>

                  <table className="custom-table-d-model">
                    <thead>
                      <tr>
                        <th className="th-left-d-model">Service Name</th>
                        <th className="th-right-d-model">Per Hour</th>
                      </tr>
                    </thead>

                    <tbody>

                      {
                        filterPerHourBasis(addedService?.filter(item => [1, 3].includes(Number(item?.servicetype_id)))).map((item, index) => {

                          const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
                          const matched = item?.ServiceChargeBases?.find(chargeBase =>
                            chargeBase?.ChargeBasis?.id === basisId &&
                            chargeBase?.ChargeBasis?.BasisType?.id === 2
                          );

                          return (
                            <tr key={index}>
                              <td className="td-left-d-model">
                                {item?.name}
                              </td>
                              <td className="td-right-d-model">
                                {`£ ${matched?.rate}${item?.vat_label}`}
                              </td>
                            </tr>
                          )
                        })
                      }

                      <tr>
                        <td className="td-bold-d-model">Payment Types</td>
                        <td className="td-bold-right-d-model">
                          On Invoice
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              )}


              {/* ================= One -Off Services ================= */}

              {
                (

                  (
                    // addedService.length > 0 && addedService?.find(item => [2].includes(Number(item?.servicetype_id)))
                    addedService && filterWithoutPerHourBasis(addedService?.filter(item => [2].includes(Number(item.servicetype_id))))?.length > 0
                  )
                ) && (
                  <>
                    <div className="section-header-d-model mt-50-d-model">
                      Contract for {oneoff_label} Services
                    </div>

                    <table className="custom-table-d-model">
                      <thead>
                        <tr>
                          <th className="th-left-d-model">Service Name</th>
                          <th className="th-right-d-model">Price</th>
                        </tr>
                      </thead>

                      <tbody>



                        {/* Added Services */}
                        {addedService && filterWithoutPerHourBasis(addedService?.filter(item => [2].includes(Number(item.servicetype_id))))
                          .map((item, index) => {

                            const value =
                              (item?.price * (1 + increasePremiumFinal / 100)) *
                              (1 - discountValueFinal / 100);

                            return (
                              <tr key={`add-${index}`}>
                                <td className="td-left-d-model">{item?.name}</td>
                                <td className="td-right-d-model">
                                  {/* £{(Math.floor(value * 100) / 100).toFixed(2)} */}
                                  £{
                                    (() => {

                                      if (Number(item?.servicetype_id) == 2) {
                                        const value =
                                          (item?.price * (1 + increasePremiumFinalOneOff / 100)) *
                                          (1 - discountValueFinalOneOff / 100);

                                        return roundNumber(value);
                                      } else {
                                        const value =
                                          (item?.price * (1 + increasePremiumFinal / 100)) *
                                          (1 - discountValueFinal / 100);

                                        return roundNumber(value);
                                      }

                                    })()
                                  }
                                </td>
                              </tr>
                            );
                          })}

                        {/* Summary */}
                        <tr>
                          <td className="td-bold-d-model">Total Cost of Services</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalCostOneOff)}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Discount</td>
                          <td className="td-bold-right-d-model">{discountOneOff}%</td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Net Cost of Services</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalCostWithDiscountOneOff)}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">VAT @ 20%</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(vatOneOff)}
                          </td>
                        </tr>

                        <tr className="row-highlight-d-model">
                          <td className="td-bold-d-model">Total (Including VAT)</td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalIncludingVATOneOff)}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Payment Type</td>
                          <td className="td-bold-right-d-model">
                            {{
                              monthly_dd: "Monthly DD",
                              quarterly_dd: "Quarterly DD",
                              "100_upfront": "100% Upfront",
                              "50_upfront": "50% Upfront / 50% on Draft",
                              "100_post_completion": "100% Post Completion",
                              manual_payment_monthly: "Manual Payment-Monthly",
                              manual_payment_quarterly: "Manual Payment- Quarterly",
                            }[paymentTermOneOff]}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">Contract Type</td>
                          <td className="td-bold-right-d-model">
                            {{
                              contract_type_ongoing: "Ongoing",
                              contract_type_oneoff: "One-off",
                              contract_type_payg: "Pay As You Go",
                            }[contractTypeOneOff] || "Ongoing"}
                          </td>
                        </tr>

                        <tr>
                          <td className="td-bold-d-model">
                            {
                              {
                                monthly_dd: "Total Monthly Cost",
                                manual_payment_monthly: "Total Monthly Cost",
                                quarterly_dd: "Total Quarterly Cost",
                                manual_payment_quarterly: "Total Quarterly Cost",
                                "100_upfront": "Total Upfront Cost (100%)",
                                "100_post_completion": "Total Post Completion Cost (100%)",
                                "50_upfront": "Total Upfront Cost (50%)",
                              }[paymentTermOneOff] || "Total Monthly Cost"
                            } (Excluding VAT)
                          </td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalMonthlyCostExcludingOneOff)}
                          </td>
                        </tr>

                        <tr className="row-highlight-d-model">
                          <td className="td-bold-d-model">
                            {
                              {
                                monthly_dd: "Total Monthly Cost",
                                manual_payment_monthly: "Total Monthly Cost",
                                quarterly_dd: "Total Quarterly Cost",
                                manual_payment_quarterly: "Total Quarterly Cost",
                                "100_upfront": "Total Upfront Cost (100%)",
                                "100_post_completion": "Total Post Completion Cost (100%)",
                                "50_upfront": "Total Upfront Cost (50%)",
                              }[paymentTermOneOff] || "Total Monthly Cost"
                            } (Including VAT)
                          </td>
                          <td className="td-bold-right-d-model">
                            £{roundNumber(totalMonthlyCostOneOff)}
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </>
                )
              }


              {/* Hourly Billing One Off */}
              {filterPerHourBasis(addedService?.filter(item => [2].includes(Number(item?.servicetype_id))))?.length > 0 && (
                <>
                  <div className="section-header-d-model mt-50-d-model">
                    Services - Time and Fees Billing (Hourly) - (One Off)
                  </div>

                  <table className="custom-table-d-model">
                    <thead>
                      <tr>
                        <th className="th-left-d-model">Service Name</th>
                        <th className="th-right-d-model">Per Hour</th>
                      </tr>
                    </thead>

                    <tbody>
                      {filterPerHourBasis(addedService?.filter(item => [2].includes(Number(item?.servicetype_id)))).map((item, index) => {

                        const basisId = item?.sell_chargebasis_id || item?.default_chargebasis_id;
                        const matched = item?.ServiceChargeBases?.find(chargeBase =>
                          chargeBase?.ChargeBasis?.id === basisId &&
                          chargeBase?.ChargeBasis?.BasisType?.id === 2
                        );

                        return (
                          <tr key={index}>
                            <td className="td-left-d-model">
                              {item?.name}
                            </td>
                            <td className="td-right-d-model">
                              {`£ ${matched?.rate}${item?.vat_label}`}
                            </td>
                          </tr>
                        )
                      })
                      }

                      <tr>
                        <td className="td-bold-d-model">Payment Types</td>
                        <td className="td-bold-right-d-model">
                          On Invoice
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              )}

            </>
          }
          footer={
            <button
              className="btn btn-outline-secondary"
              onClick={() => setShowDiscountModal(false)}
            >
              Close
            </button>
          }
        />



      </div>

    </div>
  )
};
export default StepTwo;